
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire81df"];
var parcelRegister = parcelRequire.register;
parcelRegister("5vLkJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "presets", () => $4034906a84e141fe$export$7afd9c1079ecedf7);
$parcel$export(module.exports, "compressSpaces", () => $4034906a84e141fe$export$807f8f89b800558c);
$parcel$export(module.exports, "trimLeft", () => $4034906a84e141fe$export$c5557f40488c48ec);
$parcel$export(module.exports, "trimRight", () => $4034906a84e141fe$export$da8e5da96e287379);
$parcel$export(module.exports, "toNumbers", () => $4034906a84e141fe$export$39f594ce2cc17fac);
$parcel$export(module.exports, "normalizeAttributeName", () => $4034906a84e141fe$export$b3f31ce51802c0eb);
$parcel$export(module.exports, "parseExternalUrl", () => $4034906a84e141fe$export$3255a1f681144687);
$parcel$export(module.exports, "normalizeColor", () => $4034906a84e141fe$export$4cde5df63f53f473);
$parcel$export(module.exports, "getSelectorSpecificity", () => $4034906a84e141fe$export$df1c50e5e34679bb);
$parcel$export(module.exports, "PSEUDO_ZERO", () => $4034906a84e141fe$export$8aefd221e087d814);
$parcel$export(module.exports, "vectorMagnitude", () => $4034906a84e141fe$export$7ded36ac6e1c5d43);
$parcel$export(module.exports, "vectorsRatio", () => $4034906a84e141fe$export$26217366fe93b305);
$parcel$export(module.exports, "vectorsAngle", () => $4034906a84e141fe$export$7796842e1d4b1fa5);
$parcel$export(module.exports, "CB1", () => $4034906a84e141fe$export$9e530b7c1b7c1200);
$parcel$export(module.exports, "CB2", () => $4034906a84e141fe$export$eaadfcb9a27922af);
$parcel$export(module.exports, "CB3", () => $4034906a84e141fe$export$7e5f271a1479ae46);
$parcel$export(module.exports, "CB4", () => $4034906a84e141fe$export$60426d27d140e174);
$parcel$export(module.exports, "QB1", () => $4034906a84e141fe$export$1d72cc358c390964);
$parcel$export(module.exports, "QB2", () => $4034906a84e141fe$export$e0e2e9099da349e2);
$parcel$export(module.exports, "QB3", () => $4034906a84e141fe$export$6a0be4a5e8765c00);
$parcel$export(module.exports, "Property", () => $4034906a84e141fe$export$41b04b3a73e7216d);
$parcel$export(module.exports, "ViewPort", () => $4034906a84e141fe$export$15d36fc1a69ab4a0);
$parcel$export(module.exports, "Point", () => $4034906a84e141fe$export$baf26146a414f24a);
$parcel$export(module.exports, "Mouse", () => $4034906a84e141fe$export$7caecd373b84cec3);
$parcel$export(module.exports, "Screen", () => $4034906a84e141fe$export$a98515d67472a41f);
$parcel$export(module.exports, "Parser", () => $4034906a84e141fe$export$7acfa6ed01010e37);
$parcel$export(module.exports, "Translate", () => $4034906a84e141fe$export$9db2ba50894db2b9);
$parcel$export(module.exports, "Rotate", () => $4034906a84e141fe$export$152db69a76b6b79e);
$parcel$export(module.exports, "Scale", () => $4034906a84e141fe$export$d60cfc58d3c358b6);
$parcel$export(module.exports, "Matrix", () => $4034906a84e141fe$export$5b12bf1653c0dd85);
$parcel$export(module.exports, "Skew", () => $4034906a84e141fe$export$a376180acd65c7ba);
$parcel$export(module.exports, "SkewX", () => $4034906a84e141fe$export$80e6f3ff66bb89e7);
$parcel$export(module.exports, "SkewY", () => $4034906a84e141fe$export$64b480ceb2d2b00);
$parcel$export(module.exports, "Transform", () => $4034906a84e141fe$export$563a914cafbdc389);
$parcel$export(module.exports, "Element", () => $4034906a84e141fe$export$db77ccec0bb4ccac);
$parcel$export(module.exports, "UnknownElement", () => $4034906a84e141fe$export$868534362d0f7d0f);
$parcel$export(module.exports, "Font", () => $4034906a84e141fe$export$89abf52a030e56ee);
$parcel$export(module.exports, "BoundingBox", () => $4034906a84e141fe$export$63080c4de6cfc362);
$parcel$export(module.exports, "PathParser", () => $4034906a84e141fe$export$2c011581dc2d802);
$parcel$export(module.exports, "RenderedElement", () => $4034906a84e141fe$export$66cca51e2e9c1a33);
$parcel$export(module.exports, "PathElement", () => $4034906a84e141fe$export$c1ed4714510a72ff);
$parcel$export(module.exports, "GlyphElement", () => $4034906a84e141fe$export$9f86a6657dbbe872);
$parcel$export(module.exports, "TextElement", () => $4034906a84e141fe$export$764077542c4bf9bd);
$parcel$export(module.exports, "TSpanElement", () => $4034906a84e141fe$export$c433ff877cb33f94);
$parcel$export(module.exports, "SVGElement", () => $4034906a84e141fe$export$1c514248cc7fa12c);
$parcel$export(module.exports, "RectElement", () => $4034906a84e141fe$export$263978a7d84b5a3c);
$parcel$export(module.exports, "CircleElement", () => $4034906a84e141fe$export$adbac4af9c5f9fe3);
$parcel$export(module.exports, "EllipseElement", () => $4034906a84e141fe$export$44c88df001c2e0c9);
$parcel$export(module.exports, "LineElement", () => $4034906a84e141fe$export$55e463fa7bcd3469);
$parcel$export(module.exports, "PolylineElement", () => $4034906a84e141fe$export$809f53f9291c2b68);
$parcel$export(module.exports, "PolygonElement", () => $4034906a84e141fe$export$d2c42f21e401c1a);
$parcel$export(module.exports, "PatternElement", () => $4034906a84e141fe$export$5216db53c3c8c1fb);
$parcel$export(module.exports, "MarkerElement", () => $4034906a84e141fe$export$81ddf2cd10cb96db);
$parcel$export(module.exports, "DefsElement", () => $4034906a84e141fe$export$ebdb3435ac0bd33d);
$parcel$export(module.exports, "GElement", () => $4034906a84e141fe$export$6266fb18b118dc8f);
$parcel$export(module.exports, "GradientElement", () => $4034906a84e141fe$export$a28828aea105bf34);
$parcel$export(module.exports, "LinearGradientElement", () => $4034906a84e141fe$export$2c94155b281d2a65);
$parcel$export(module.exports, "RadialGradientElement", () => $4034906a84e141fe$export$c701c9794d8ff39a);
$parcel$export(module.exports, "StopElement", () => $4034906a84e141fe$export$935706179ceb26b7);
$parcel$export(module.exports, "AnimateElement", () => $4034906a84e141fe$export$5ad74a1ea4543e04);
$parcel$export(module.exports, "AnimateColorElement", () => $4034906a84e141fe$export$1a8c178571a10fd8);
$parcel$export(module.exports, "AnimateTransformElement", () => $4034906a84e141fe$export$33212fc20d66cba8);
$parcel$export(module.exports, "FontElement", () => $4034906a84e141fe$export$950f494922cd7f64);
$parcel$export(module.exports, "FontFaceElement", () => $4034906a84e141fe$export$4e49cc5aca2dcd2);
$parcel$export(module.exports, "MissingGlyphElement", () => $4034906a84e141fe$export$f7e8c9808bb1f18e);
$parcel$export(module.exports, "TRefElement", () => $4034906a84e141fe$export$e3818feda1216434);
$parcel$export(module.exports, "AElement", () => $4034906a84e141fe$export$750c958a3d844280);
$parcel$export(module.exports, "TextPathElement", () => $4034906a84e141fe$export$ed2570164d72b374);
$parcel$export(module.exports, "ImageElement", () => $4034906a84e141fe$export$c78ad754952d364a);
$parcel$export(module.exports, "SymbolElement", () => $4034906a84e141fe$export$cf2a8e13e8b6e2d6);
$parcel$export(module.exports, "SVGFontLoader", () => $4034906a84e141fe$export$9d6567569ea197f5);
$parcel$export(module.exports, "StyleElement", () => $4034906a84e141fe$export$921cd41ee3a8205e);
$parcel$export(module.exports, "UseElement", () => $4034906a84e141fe$export$5cc2b6e34b733075);
$parcel$export(module.exports, "FeColorMatrixElement", () => $4034906a84e141fe$export$9ef846fb34710785);
$parcel$export(module.exports, "MaskElement", () => $4034906a84e141fe$export$9b061fea64b209bc);
$parcel$export(module.exports, "ClipPathElement", () => $4034906a84e141fe$export$7080ac466fc109c8);
$parcel$export(module.exports, "FilterElement", () => $4034906a84e141fe$export$8b8c5dbc2df0a942);
$parcel$export(module.exports, "FeDropShadowElement", () => $4034906a84e141fe$export$b2c131cc4f80c8c6);
$parcel$export(module.exports, "FeMorphologyElement", () => $4034906a84e141fe$export$6bc5f062490f15a6);
$parcel$export(module.exports, "FeCompositeElement", () => $4034906a84e141fe$export$e739314f59309bc7);
$parcel$export(module.exports, "FeGaussianBlurElement", () => $4034906a84e141fe$export$3b1b99bc1cbb9f0);
$parcel$export(module.exports, "TitleElement", () => $4034906a84e141fe$export$56726d258a7004ee);
$parcel$export(module.exports, "DescElement", () => $4034906a84e141fe$export$e5e7007b6c523b20);
$parcel$export(module.exports, "Document", () => $4034906a84e141fe$export$b34a105447964f9f);
$parcel$export(module.exports, "Canvg", () => $4034906a84e141fe$export$c401b789680a0e53);
$parcel$export(module.exports, "default", () => $4034906a84e141fe$export$c401b789680a0e53);
parcelRequire("7nzI4");

var $fOd0O = parcelRequire("fOd0O");
parcelRequire("4Miql");
parcelRequire("6jpE8");
parcelRequire("gG87B");
parcelRequire("6Jv57");
parcelRequire("8ZxhT");

var $g5Zhu = parcelRequire("g5Zhu");
parcelRequire("hqBy5");
parcelRequire("7QN7n");
parcelRequire("6peZT");

var $ctRqH = parcelRequire("ctRqH");
parcelRequire("2lVA1");

var $4VIYO = parcelRequire("4VIYO");
parcelRequire("lc3S4");
parcelRequire("j30OU");
parcelRequire("fgEtE");

var $68e7U = parcelRequire("68e7U");
parcelRequire("eJkjO");

var $dKQCx = parcelRequire("dKQCx");
/**
 * Options preset for `OffscreenCanvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @returns Preset object.
 */ function $4034906a84e141fe$var$offscreen() {
    var { DOMParser: DOMParserFallback } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var preset = {
        window: null,
        ignoreAnimation: true,
        ignoreMouse: true,
        DOMParser: DOMParserFallback,
        createCanvas (width, height) {
            return new OffscreenCanvas(width, height);
        },
        createImage (url) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
                var response = yield fetch(url);
                var blob = yield response.blob();
                var img = yield createImageBitmap(blob);
                return img;
            })();
        }
    };
    if (typeof DOMParser !== 'undefined' || typeof DOMParserFallback === 'undefined') Reflect.deleteProperty(preset, 'DOMParser');
    return preset;
}
/**
 * Options preset for `node-canvas`.
 * @param config - Preset requirements.
 * @param config.DOMParser - XML/HTML parser from string into DOM Document.
 * @param config.canvas - `node-canvas` exports.
 * @param config.fetch - WHATWG-compatible `fetch` function.
 * @returns Preset object.
 */ function $4034906a84e141fe$var$node(_ref) {
    var { DOMParser: DOMParser1, canvas: canvas, fetch: fetch1 } = _ref;
    return {
        window: null,
        ignoreAnimation: true,
        ignoreMouse: true,
        DOMParser: DOMParser1,
        fetch: fetch1,
        createCanvas: canvas.createCanvas,
        createImage: canvas.loadImage
    };
}
var $4034906a84e141fe$export$7afd9c1079ecedf7 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    offscreen: $4034906a84e141fe$var$offscreen,
    node: $4034906a84e141fe$var$node
});
/**
 * HTML-safe compress white-spaces.
 * @param str - String to compress.
 * @returns String.
 */ function $4034906a84e141fe$export$807f8f89b800558c(str) {
    return str.replace(/(?!\u3000)\s+/gm, ' ');
}
/**
 * HTML-safe left trim.
 * @param str - String to trim.
 * @returns String.
 */ function $4034906a84e141fe$export$c5557f40488c48ec(str) {
    return str.replace(/^[\n \t]+/, '');
}
/**
 * HTML-safe right trim.
 * @param str - String to trim.
 * @returns String.
 */ function $4034906a84e141fe$export$da8e5da96e287379(str) {
    return str.replace(/[\n \t]+$/, '');
}
/**
 * String to numbers array.
 * @param str - Numbers string.
 * @returns Numbers array.
 */ function $4034906a84e141fe$export$39f594ce2cc17fac(str) {
    var matches = (str || '').match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
    return matches.map(parseFloat);
} // Microsoft Edge fix
var $4034906a84e141fe$var$allUppercase = /^[A-Z-]+$/;
/**
 * Normalize attribute name.
 * @param name - Attribute name.
 * @returns Normalized attribute name.
 */ function $4034906a84e141fe$export$b3f31ce51802c0eb(name) {
    if ($4034906a84e141fe$var$allUppercase.test(name)) return name.toLowerCase();
    return name;
}
/**
 * Parse external URL.
 * @param url - CSS url string.
 * @returns Parsed URL.
 */ function $4034906a84e141fe$export$3255a1f681144687(url) {
    //                      single quotes [2]
    //                      v         double quotes [3]
    //                      v         v         no quotes [4]
    //                      v         v         v
    var urlMatch = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(url) || [];
    return urlMatch[2] || urlMatch[3] || urlMatch[4];
}
/**
 * Transform floats to integers in rgb colors.
 * @param color - Color to normalize.
 * @returns Normalized color.
 */ function $4034906a84e141fe$export$4cde5df63f53f473(color) {
    if (!color.startsWith('rgb')) return color;
    var rgbParts = 3;
    var normalizedColor = color.replace(/\d+(\.\d+)?/g, (num, isFloat)=>rgbParts-- && isFloat ? String(Math.round(parseFloat(num))) : num);
    return normalizedColor;
}
// slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
var $4034906a84e141fe$var$attributeRegex = /(\[[^\]]+\])/g;
var $4034906a84e141fe$var$idRegex = /(#[^\s+>~.[:]+)/g;
var $4034906a84e141fe$var$classRegex = /(\.[^\s+>~.[:]+)/g;
var $4034906a84e141fe$var$pseudoElementRegex = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi;
var $4034906a84e141fe$var$pseudoClassWithBracketsRegex = /(:[\w-]+\([^)]*\))/gi;
var $4034906a84e141fe$var$pseudoClassRegex = /(:[^\s+>~.[:]+)/g;
var $4034906a84e141fe$var$elementRegex = /([^\s+>~.[:]+)/g;
function $4034906a84e141fe$var$findSelectorMatch(selector, regex) {
    var matches = regex.exec(selector);
    if (!matches) return [
        selector,
        0
    ];
    return [
        selector.replace(regex, ' '),
        matches.length
    ];
}
/**
 * Measure selector specificity.
 * @param selector - Selector to measure.
 * @returns Specificity.
 */ function $4034906a84e141fe$export$df1c50e5e34679bb(selector) {
    var specificity = [
        0,
        0,
        0
    ];
    var currentSelector = selector.replace(/:not\(([^)]*)\)/g, '     $1 ').replace(/{[\s\S]*/gm, ' ');
    var delta = 0;
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$attributeRegex);
    specificity[1] += delta;
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$idRegex);
    specificity[0] += delta;
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$classRegex);
    specificity[1] += delta;
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$pseudoElementRegex);
    specificity[2] += delta;
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$pseudoClassWithBracketsRegex);
    specificity[1] += delta;
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$pseudoClassRegex);
    specificity[1] += delta;
    currentSelector = currentSelector.replace(/[*\s+>~]/g, ' ').replace(/[#.]/g, ' ');
    [currentSelector, delta] = $4034906a84e141fe$var$findSelectorMatch(currentSelector, $4034906a84e141fe$var$elementRegex); // lgtm [js/useless-assignment-to-local]
    specificity[2] += delta;
    return specificity.join('');
}
var $4034906a84e141fe$export$8aefd221e087d814 = .00000001;
/**
 * Vector magnitude.
 * @param v
 * @returns Number result.
 */ function $4034906a84e141fe$export$7ded36ac6e1c5d43(v) {
    return Math.sqrt(Math.pow(v[0], 2) + Math.pow(v[1], 2));
}
/**
 * Ratio between two vectors.
 * @param u
 * @param v
 * @returns Number result.
 */ function $4034906a84e141fe$export$26217366fe93b305(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($4034906a84e141fe$export$7ded36ac6e1c5d43(u) * $4034906a84e141fe$export$7ded36ac6e1c5d43(v));
}
/**
 * Angle between two vectors.
 * @param u
 * @param v
 * @returns Number result.
 */ function $4034906a84e141fe$export$7796842e1d4b1fa5(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($4034906a84e141fe$export$26217366fe93b305(u, v));
}
function $4034906a84e141fe$export$9e530b7c1b7c1200(t) {
    return t * t * t;
}
function $4034906a84e141fe$export$eaadfcb9a27922af(t) {
    return 3 * t * t * (1 - t);
}
function $4034906a84e141fe$export$7e5f271a1479ae46(t) {
    return 3 * t * (1 - t) * (1 - t);
}
function $4034906a84e141fe$export$60426d27d140e174(t) {
    return (1 - t) * (1 - t) * (1 - t);
}
function $4034906a84e141fe$export$1d72cc358c390964(t) {
    return t * t;
}
function $4034906a84e141fe$export$e0e2e9099da349e2(t) {
    return 2 * t * (1 - t);
}
function $4034906a84e141fe$export$6a0be4a5e8765c00(t) {
    return (1 - t) * (1 - t);
}
class $4034906a84e141fe$export$41b04b3a73e7216d {
    constructor(document1, name, value){
        this.document = document1;
        this.name = name;
        this.value = value;
        this.isNormalizedColor = false;
    }
    static empty(document1) {
        return new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'EMPTY', '');
    }
    split() {
        var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' ';
        var { document: document1, name: name } = this;
        return $4034906a84e141fe$export$807f8f89b800558c(this.getString()).trim().split(separator).map((value)=>new $4034906a84e141fe$export$41b04b3a73e7216d(document1, name, value));
    }
    hasValue(zeroIsValue) {
        var { value: value } = this;
        return value !== null && value !== '' && (zeroIsValue || value !== 0) && typeof value !== 'undefined';
    }
    isString(regexp) {
        var { value: value } = this;
        var result = typeof value === 'string';
        if (!result || !regexp) return result;
        return regexp.test(value);
    }
    isUrlDefinition() {
        return this.isString(/^url\(/);
    }
    isPixels() {
        if (!this.hasValue()) return false;
        var asString = this.getString();
        switch(true){
            case asString.endsWith('px'):
            case /^[0-9]+$/.test(asString):
                return true;
            default:
                return false;
        }
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    getValue(def) {
        if (typeof def === 'undefined' || this.hasValue()) return this.value;
        return def;
    }
    getNumber(def) {
        if (!this.hasValue()) {
            if (typeof def === 'undefined') return 0;
            return parseFloat(def);
        }
        var { value: value } = this;
        var n = parseFloat(value);
        if (this.isString(/%$/)) n /= 100.0;
        return n;
    }
    getString(def) {
        if (typeof def === 'undefined' || this.hasValue()) return typeof this.value === 'undefined' ? '' : String(this.value);
        return String(def);
    }
    getColor(def) {
        var color = this.getString(def);
        if (this.isNormalizedColor) return color;
        this.isNormalizedColor = true;
        color = $4034906a84e141fe$export$4cde5df63f53f473(color);
        this.value = color;
        return color;
    }
    getDpi() {
        return 96.0; // TODO: compute?
    }
    getRem() {
        return this.document.rootEmSize;
    }
    getEm() {
        return this.document.emSize;
    }
    getUnits() {
        return this.getString().replace(/[0-9.-]/g, '');
    }
    getPixels(axisOrIsFontSize) {
        var processPercent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!this.hasValue()) return 0;
        var [axis, isFontSize] = typeof axisOrIsFontSize === 'boolean' ? [
            undefined,
            axisOrIsFontSize
        ] : [
            axisOrIsFontSize
        ];
        var { viewPort: viewPort } = this.document.screen;
        switch(true){
            case this.isString(/vmin$/):
                return this.getNumber() / 100.0 * Math.min(viewPort.computeSize('x'), viewPort.computeSize('y'));
            case this.isString(/vmax$/):
                return this.getNumber() / 100.0 * Math.max(viewPort.computeSize('x'), viewPort.computeSize('y'));
            case this.isString(/vw$/):
                return this.getNumber() / 100.0 * viewPort.computeSize('x');
            case this.isString(/vh$/):
                return this.getNumber() / 100.0 * viewPort.computeSize('y');
            case this.isString(/rem$/):
                return this.getNumber() * this.getRem();
            case this.isString(/em$/):
                return this.getNumber() * this.getEm();
            case this.isString(/ex$/):
                return this.getNumber() * this.getEm() / 2.0;
            case this.isString(/px$/):
                return this.getNumber();
            case this.isString(/pt$/):
                return this.getNumber() * this.getDpi() * (1.0 / 72.0);
            case this.isString(/pc$/):
                return this.getNumber() * 15;
            case this.isString(/cm$/):
                return this.getNumber() * this.getDpi() / 2.54;
            case this.isString(/mm$/):
                return this.getNumber() * this.getDpi() / 25.4;
            case this.isString(/in$/):
                return this.getNumber() * this.getDpi();
            case this.isString(/%$/) && isFontSize:
                return this.getNumber() * this.getEm();
            case this.isString(/%$/):
                return this.getNumber() * viewPort.computeSize(axis);
            default:
                var n = this.getNumber();
                if (processPercent && n < 1.0) return n * viewPort.computeSize(axis);
                return n;
        }
    }
    getMilliseconds() {
        if (!this.hasValue()) return 0;
        if (this.isString(/ms$/)) return this.getNumber();
        return this.getNumber() * 1000;
    }
    getRadians() {
        if (!this.hasValue()) return 0;
        switch(true){
            case this.isString(/deg$/):
                return this.getNumber() * (Math.PI / 180.0);
            case this.isString(/grad$/):
                return this.getNumber() * (Math.PI / 200.0);
            case this.isString(/rad$/):
                return this.getNumber();
            default:
                return this.getNumber() * (Math.PI / 180.0);
        }
    }
    getDefinition() {
        var asString = this.getString();
        var name = /#([^)'"]+)/.exec(asString);
        if (name) name = name[1];
        if (!name) name = asString;
        return this.document.definitions[name];
    }
    getFillStyleDefinition(element, opacity) {
        var def = this.getDefinition();
        if (!def) return null;
         // gradient
        if (typeof def.createGradient === 'function') return def.createGradient(this.document.ctx, element, opacity);
         // pattern
        if (typeof def.createPattern === 'function') {
            if (def.getHrefAttribute().hasValue()) {
                var patternTransform = def.getAttribute('patternTransform');
                def = def.getHrefAttribute().getDefinition();
                if (patternTransform.hasValue()) def.getAttribute('patternTransform', true).setValue(patternTransform.value);
            }
            return def.createPattern(this.document.ctx, element, opacity);
        }
        return null;
    }
    getTextBaseline() {
        if (!this.hasValue()) return null;
        return $4034906a84e141fe$export$41b04b3a73e7216d.textBaselineMapping[this.getString()];
    }
    addOpacity(opacity) {
        var value = this.getColor();
        var len = value.length;
        var commas = 0; // Simulate old RGBColor version, which can't parse rgba.
        for(var i = 0; i < len; i++){
            if (value[i] === ',') commas++;
            if (commas === 3) break;
        }
        if (opacity.hasValue() && this.isString() && commas !== 3) {
            var color = new (0, (/*@__PURE__*/$parcel$interopDefault($4VIYO)))(value);
            if (color.ok) {
                color.alpha = opacity.getNumber();
                value = color.toRGBA();
            }
        }
        return new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, this.name, value);
    }
}
$4034906a84e141fe$export$41b04b3a73e7216d.textBaselineMapping = {
    'baseline': 'alphabetic',
    'before-edge': 'top',
    'text-before-edge': 'top',
    'middle': 'middle',
    'central': 'middle',
    'after-edge': 'bottom',
    'text-after-edge': 'bottom',
    'ideographic': 'ideographic',
    'alphabetic': 'alphabetic',
    'hanging': 'hanging',
    'mathematical': 'alphabetic'
};
class $4034906a84e141fe$export$15d36fc1a69ab4a0 {
    constructor(){
        this.viewPorts = [];
    }
    clear() {
        this.viewPorts = [];
    }
    setCurrent(width, height) {
        this.viewPorts.push({
            width: width,
            height: height
        });
    }
    removeCurrent() {
        this.viewPorts.pop();
    }
    getCurrent() {
        var { viewPorts: viewPorts } = this;
        return viewPorts[viewPorts.length - 1];
    }
    get width() {
        return this.getCurrent().width;
    }
    get height() {
        return this.getCurrent().height;
    }
    computeSize(d) {
        if (typeof d === 'number') return d;
        if (d === 'x') return this.width;
        if (d === 'y') return this.height;
        return Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
    }
}
class $4034906a84e141fe$export$baf26146a414f24a {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    static parse(point) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var [x = defaultValue, y = defaultValue] = $4034906a84e141fe$export$39f594ce2cc17fac(point);
        return new $4034906a84e141fe$export$baf26146a414f24a(x, y);
    }
    static parseScale(scale) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var [x = defaultValue, y = x] = $4034906a84e141fe$export$39f594ce2cc17fac(scale);
        return new $4034906a84e141fe$export$baf26146a414f24a(x, y);
    }
    static parsePath(path) {
        var points = $4034906a84e141fe$export$39f594ce2cc17fac(path);
        var len = points.length;
        var pathPoints = [];
        for(var i = 0; i < len; i += 2)pathPoints.push(new $4034906a84e141fe$export$baf26146a414f24a(points[i], points[i + 1]));
        return pathPoints;
    }
    angleTo(point) {
        return Math.atan2(point.y - this.y, point.x - this.x);
    }
    applyTransform(transform) {
        var { x: x, y: y } = this;
        var xp = x * transform[0] + y * transform[2] + transform[4];
        var yp = x * transform[1] + y * transform[3] + transform[5];
        this.x = xp;
        this.y = yp;
    }
}
class $4034906a84e141fe$export$7caecd373b84cec3 {
    constructor(screen){
        this.screen = screen;
        this.working = false;
        this.events = [];
        this.eventElements = []; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.onClick = this.onClick.bind(this); // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.onMouseMove = this.onMouseMove.bind(this);
    }
    isWorking() {
        return this.working;
    }
    start() {
        if (this.working) return;
        var { screen: screen, onClick: onClick, onMouseMove: onMouseMove } = this;
        var canvas = screen.ctx.canvas;
        canvas.onclick = onClick;
        canvas.onmousemove = onMouseMove;
        this.working = true;
    }
    stop() {
        if (!this.working) return;
        var canvas = this.screen.ctx.canvas;
        this.working = false;
        canvas.onclick = null;
        canvas.onmousemove = null;
    }
    hasEvents() {
        return this.working && this.events.length > 0;
    }
    runEvents() {
        if (!this.working) return;
        var { screen: document1, events: events, eventElements: eventElements } = this;
        var { style: style } = document1.ctx.canvas;
        if (style) style.cursor = '';
        events.forEach((_ref, i)=>{
            var { run: run } = _ref;
            var element = eventElements[i];
            while(element){
                run(element);
                element = element.parent;
            }
        }); // done running, clear
        this.events = [];
        this.eventElements = [];
    }
    checkPath(element, ctx) {
        if (!this.working || !ctx) return;
        var { events: events, eventElements: eventElements } = this;
        events.forEach((_ref2, i)=>{
            var { x: x, y: y } = _ref2;
            if (!eventElements[i] && ctx.isPointInPath && ctx.isPointInPath(x, y)) eventElements[i] = element;
        });
    }
    checkBoundingBox(element, boundingBox) {
        if (!this.working || !boundingBox) return;
        var { events: events, eventElements: eventElements } = this;
        events.forEach((_ref3, i)=>{
            var { x: x, y: y } = _ref3;
            if (!eventElements[i] && boundingBox.isPointInBox(x, y)) eventElements[i] = element;
        });
    }
    mapXY(x, y) {
        var { window: window1, ctx: ctx } = this.screen;
        var point = new $4034906a84e141fe$export$baf26146a414f24a(x, y);
        var element = ctx.canvas;
        while(element){
            point.x -= element.offsetLeft;
            point.y -= element.offsetTop;
            element = element.offsetParent;
        }
        if (window1.scrollX) point.x += window1.scrollX;
        if (window1.scrollY) point.y += window1.scrollY;
        return point;
    }
    onClick(event) {
        var { x: x, y: y } = this.mapXY(event.clientX, event.clientY);
        this.events.push({
            type: 'onclick',
            x: x,
            y: y,
            run (eventTarget) {
                if (eventTarget.onClick) eventTarget.onClick();
            }
        });
    }
    onMouseMove(event) {
        var { x: x, y: y } = this.mapXY(event.clientX, event.clientY);
        this.events.push({
            type: 'onmousemove',
            x: x,
            y: y,
            run (eventTarget) {
                if (eventTarget.onMouseMove) eventTarget.onMouseMove();
            }
        });
    }
}
var $4034906a84e141fe$var$defaultWindow = typeof window !== 'undefined' ? window : null;
var $4034906a84e141fe$var$defaultFetch$1 = typeof fetch !== 'undefined' ? fetch.bind(undefined) // `fetch` depends on context: `someObject.fetch(...)` will throw error.
 : null;
class $4034906a84e141fe$export$a98515d67472a41f {
    constructor(ctx){
        var { fetch: fetch1 = $4034906a84e141fe$var$defaultFetch$1, window: window1 = $4034906a84e141fe$var$defaultWindow } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.ctx = ctx;
        this.FRAMERATE = 30;
        this.MAX_VIRTUAL_PIXELS = 30000;
        this.CLIENT_WIDTH = 800;
        this.CLIENT_HEIGHT = 600;
        this.viewPort = new $4034906a84e141fe$export$15d36fc1a69ab4a0();
        this.mouse = new $4034906a84e141fe$export$7caecd373b84cec3(this);
        this.animations = [];
        this.waits = [];
        this.frameDuration = 0;
        this.isReadyLock = false;
        this.isFirstRender = true;
        this.intervalId = null;
        this.window = window1;
        this.fetch = fetch1;
    }
    wait(checker) {
        this.waits.push(checker);
    }
    ready() {
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        if (!this.readyPromise) return Promise.resolve();
        return this.readyPromise;
    }
    isReady() {
        if (this.isReadyLock) return true;
        var isReadyLock = this.waits.every((_)=>_());
        if (isReadyLock) {
            this.waits = [];
            if (this.resolveReady) this.resolveReady();
        }
        this.isReadyLock = isReadyLock;
        return isReadyLock;
    }
    setDefaults(ctx) {
        // initial values and defaults
        ctx.strokeStyle = 'rgba(0,0,0,0)';
        ctx.lineCap = 'butt';
        ctx.lineJoin = 'miter';
        ctx.miterLimit = 4;
    }
    setViewBox(_ref) {
        var { document: document1, ctx: ctx, aspectRatio: aspectRatio, width: width, desiredWidth: desiredWidth, height: height, desiredHeight: desiredHeight, minX: minX = 0, minY: minY = 0, refX: refX, refY: refY, clip: clip = false, clipX: clipX = 0, clipY: clipY = 0 } = _ref;
        // aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
        var cleanAspectRatio = $4034906a84e141fe$export$807f8f89b800558c(aspectRatio).replace(/^defer\s/, ''); // ignore defer
        var [aspectRatioAlign, aspectRatioMeetOrSlice] = cleanAspectRatio.split(' ');
        var align = aspectRatioAlign || 'xMidYMid';
        var meetOrSlice = aspectRatioMeetOrSlice || 'meet'; // calculate scale
        var scaleX = width / desiredWidth;
        var scaleY = height / desiredHeight;
        var scaleMin = Math.min(scaleX, scaleY);
        var scaleMax = Math.max(scaleX, scaleY);
        var finalDesiredWidth = desiredWidth;
        var finalDesiredHeight = desiredHeight;
        if (meetOrSlice === 'meet') {
            finalDesiredWidth *= scaleMin;
            finalDesiredHeight *= scaleMin;
        }
        if (meetOrSlice === 'slice') {
            finalDesiredWidth *= scaleMax;
            finalDesiredHeight *= scaleMax;
        }
        var refXProp = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'refX', refX);
        var refYProp = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'refY', refY);
        var hasRefs = refXProp.hasValue() && refYProp.hasValue();
        if (hasRefs) ctx.translate(-scaleMin * refXProp.getPixels('x'), -scaleMin * refYProp.getPixels('y'));
        if (clip) {
            var scaledClipX = scaleMin * clipX;
            var scaledClipY = scaleMin * clipY;
            ctx.beginPath();
            ctx.moveTo(scaledClipX, scaledClipY);
            ctx.lineTo(width, scaledClipY);
            ctx.lineTo(width, height);
            ctx.lineTo(scaledClipX, height);
            ctx.closePath();
            ctx.clip();
        }
        if (!hasRefs) {
            var isMeetMinY = meetOrSlice === 'meet' && scaleMin === scaleY;
            var isSliceMaxY = meetOrSlice === 'slice' && scaleMax === scaleY;
            var isMeetMinX = meetOrSlice === 'meet' && scaleMin === scaleX;
            var isSliceMaxX = meetOrSlice === 'slice' && scaleMax === scaleX;
            if (align.startsWith('xMid') && (isMeetMinY || isSliceMaxY)) ctx.translate(width / 2.0 - finalDesiredWidth / 2.0, 0);
            if (align.endsWith('YMid') && (isMeetMinX || isSliceMaxX)) ctx.translate(0, height / 2.0 - finalDesiredHeight / 2.0);
            if (align.startsWith('xMax') && (isMeetMinY || isSliceMaxY)) ctx.translate(width - finalDesiredWidth, 0);
            if (align.endsWith('YMax') && (isMeetMinX || isSliceMaxX)) ctx.translate(0, height - finalDesiredHeight);
        } // scale
        switch(true){
            case align === 'none':
                ctx.scale(scaleX, scaleY);
                break;
            case meetOrSlice === 'meet':
                ctx.scale(scaleMin, scaleMin);
                break;
            case meetOrSlice === 'slice':
                ctx.scale(scaleMax, scaleMax);
                break;
        } // translate
        ctx.translate(-minX, -minY);
    }
    start(element) {
        var { enableRedraw: enableRedraw = false, ignoreMouse: ignoreMouse = false, ignoreAnimation: ignoreAnimation = false, ignoreDimensions: ignoreDimensions = false, ignoreClear: ignoreClear = false, forceRedraw: forceRedraw, scaleWidth: scaleWidth, scaleHeight: scaleHeight, offsetX: offsetX, offsetY: offsetY } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var { FRAMERATE: FRAMERATE, mouse: mouse } = this;
        var frameDuration = 1000 / FRAMERATE;
        this.frameDuration = frameDuration;
        this.readyPromise = new Promise((resolve)=>{
            this.resolveReady = resolve;
        });
        if (this.isReady()) this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
        if (!enableRedraw) return;
        var now = Date.now();
        var then = now;
        var delta = 0;
        var tick = ()=>{
            now = Date.now();
            delta = now - then;
            if (delta >= frameDuration) {
                then = now - delta % frameDuration;
                if (this.shouldUpdate(ignoreAnimation, forceRedraw)) {
                    this.render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY);
                    mouse.runEvents();
                }
            }
            this.intervalId = (0, (/*@__PURE__*/$parcel$interopDefault($ctRqH)))(tick);
        };
        if (!ignoreMouse) mouse.start();
        this.intervalId = (0, (/*@__PURE__*/$parcel$interopDefault($ctRqH)))(tick);
    }
    stop() {
        if (this.intervalId) {
            (0, (/*@__PURE__*/$parcel$interopDefault($ctRqH))).cancel(this.intervalId);
            this.intervalId = null;
        }
        this.mouse.stop();
    }
    shouldUpdate(ignoreAnimation, forceRedraw) {
        // need update from animations?
        if (!ignoreAnimation) {
            var { frameDuration: frameDuration } = this;
            var shouldUpdate = this.animations.reduce((shouldUpdate, animation)=>animation.update(frameDuration) || shouldUpdate, false);
            if (shouldUpdate) return true;
        } // need update from redraw?
        if (typeof forceRedraw === 'function' && forceRedraw()) return true;
        if (!this.isReadyLock && this.isReady()) return true;
         // need update from mouse events?
        if (this.mouse.hasEvents()) return true;
        return false;
    }
    render(element, ignoreDimensions, ignoreClear, scaleWidth, scaleHeight, offsetX, offsetY) {
        var { CLIENT_WIDTH: CLIENT_WIDTH, CLIENT_HEIGHT: CLIENT_HEIGHT, viewPort: viewPort, ctx: ctx, isFirstRender: isFirstRender } = this;
        var canvas = ctx.canvas;
        viewPort.clear();
        if (canvas.width && canvas.height) viewPort.setCurrent(canvas.width, canvas.height);
        else viewPort.setCurrent(CLIENT_WIDTH, CLIENT_HEIGHT);
        var widthStyle = element.getStyle('width');
        var heightStyle = element.getStyle('height');
        if (!ignoreDimensions && (isFirstRender || typeof scaleWidth !== 'number' && typeof scaleHeight !== 'number')) {
            // set canvas size
            if (widthStyle.hasValue()) {
                canvas.width = widthStyle.getPixels('x');
                if (canvas.style) canvas.style.width = "".concat(canvas.width, "px");
            }
            if (heightStyle.hasValue()) {
                canvas.height = heightStyle.getPixels('y');
                if (canvas.style) canvas.style.height = "".concat(canvas.height, "px");
            }
        }
        var cWidth = canvas.clientWidth || canvas.width;
        var cHeight = canvas.clientHeight || canvas.height;
        if (ignoreDimensions && widthStyle.hasValue() && heightStyle.hasValue()) {
            cWidth = widthStyle.getPixels('x');
            cHeight = heightStyle.getPixels('y');
        }
        viewPort.setCurrent(cWidth, cHeight);
        if (typeof offsetX === 'number') element.getAttribute('x', true).setValue(offsetX);
        if (typeof offsetY === 'number') element.getAttribute('y', true).setValue(offsetY);
        if (typeof scaleWidth === 'number' || typeof scaleHeight === 'number') {
            var viewBox = $4034906a84e141fe$export$39f594ce2cc17fac(element.getAttribute('viewBox').getString());
            var xRatio = 0;
            var yRatio = 0;
            if (typeof scaleWidth === 'number') {
                var _widthStyle = element.getStyle('width');
                if (_widthStyle.hasValue()) xRatio = _widthStyle.getPixels('x') / scaleWidth;
                else if (!isNaN(viewBox[2])) xRatio = viewBox[2] / scaleWidth;
            }
            if (typeof scaleHeight === 'number') {
                var _heightStyle = element.getStyle('height');
                if (_heightStyle.hasValue()) yRatio = _heightStyle.getPixels('y') / scaleHeight;
                else if (!isNaN(viewBox[3])) yRatio = viewBox[3] / scaleHeight;
            }
            if (!xRatio) xRatio = yRatio;
            if (!yRatio) yRatio = xRatio;
            element.getAttribute('width', true).setValue(scaleWidth);
            element.getAttribute('height', true).setValue(scaleHeight);
            var transformStyle = element.getStyle('transform', true, true);
            transformStyle.setValue("".concat(transformStyle.getString(), " scale(").concat(1.0 / xRatio, ", ").concat(1.0 / yRatio, ")"));
        } // clear and render
        if (!ignoreClear) ctx.clearRect(0, 0, cWidth, cHeight);
        element.render(ctx);
        if (isFirstRender) this.isFirstRender = false;
    }
}
$4034906a84e141fe$export$a98515d67472a41f.defaultWindow = $4034906a84e141fe$var$defaultWindow;
$4034906a84e141fe$export$a98515d67472a41f.defaultFetch = $4034906a84e141fe$var$defaultFetch$1;
var { defaultFetch: $4034906a84e141fe$var$defaultFetch } = $4034906a84e141fe$export$a98515d67472a41f;
var $4034906a84e141fe$var$DefaultDOMParser = typeof DOMParser !== 'undefined' ? DOMParser : null;
class $4034906a84e141fe$export$7acfa6ed01010e37 {
    constructor(){
        var { fetch: fetch1 = $4034906a84e141fe$var$defaultFetch, DOMParser: DOMParser1 = $4034906a84e141fe$var$DefaultDOMParser } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.fetch = fetch1;
        this.DOMParser = DOMParser1;
    }
    parse(resource) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            if (resource.startsWith('<')) return _this.parseFromString(resource);
            return _this.load(resource);
        })();
    }
    parseFromString(xml) {
        var parser = new this.DOMParser();
        try {
            return this.checkDocument(parser.parseFromString(xml, 'image/svg+xml'));
        } catch (err) {
            return this.checkDocument(parser.parseFromString(xml, 'text/xml'));
        }
    }
    checkDocument(document1) {
        var parserError = document1.getElementsByTagName('parsererror')[0];
        if (parserError) throw new Error(parserError.textContent);
        return document1;
    }
    load(url) {
        var _this2 = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            var response = yield _this2.fetch(url);
            var xml = yield response.text();
            return _this2.parseFromString(xml);
        })();
    }
}
class $4034906a84e141fe$export$9db2ba50894db2b9 {
    constructor(_, point){
        this.type = 'translate';
        this.point = null;
        this.point = $4034906a84e141fe$export$baf26146a414f24a.parse(point);
    }
    apply(ctx) {
        var { x: x, y: y } = this.point;
        ctx.translate(x || 0.0, y || 0.0);
    }
    unapply(ctx) {
        var { x: x, y: y } = this.point;
        ctx.translate(-1 * x || 0.0, -1 * y || 0.0);
    }
    applyToPoint(point) {
        var { x: x, y: y } = this.point;
        point.applyTransform([
            1,
            0,
            0,
            1,
            x || 0.0,
            y || 0.0
        ]);
    }
}
class $4034906a84e141fe$export$152db69a76b6b79e {
    constructor(document1, rotate, transformOrigin){
        this.type = 'rotate';
        this.angle = null;
        this.originX = null;
        this.originY = null;
        this.cx = 0;
        this.cy = 0;
        var numbers = $4034906a84e141fe$export$39f594ce2cc17fac(rotate);
        this.angle = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'angle', numbers[0]);
        this.originX = transformOrigin[0];
        this.originY = transformOrigin[1];
        this.cx = numbers[1] || 0;
        this.cy = numbers[2] || 0;
    }
    apply(ctx) {
        var { cx: cx, cy: cy, originX: originX, originY: originY, angle: angle } = this;
        var tx = cx + originX.getPixels('x');
        var ty = cy + originY.getPixels('y');
        ctx.translate(tx, ty);
        ctx.rotate(angle.getRadians());
        ctx.translate(-tx, -ty);
    }
    unapply(ctx) {
        var { cx: cx, cy: cy, originX: originX, originY: originY, angle: angle } = this;
        var tx = cx + originX.getPixels('x');
        var ty = cy + originY.getPixels('y');
        ctx.translate(tx, ty);
        ctx.rotate(-1 * angle.getRadians());
        ctx.translate(-tx, -ty);
    }
    applyToPoint(point) {
        var { cx: cx, cy: cy, angle: angle } = this;
        var rad = angle.getRadians();
        point.applyTransform([
            1,
            0,
            0,
            1,
            cx || 0.0,
            cy || 0.0 // this.p.y
        ]);
        point.applyTransform([
            Math.cos(rad),
            Math.sin(rad),
            -Math.sin(rad),
            Math.cos(rad),
            0,
            0
        ]);
        point.applyTransform([
            1,
            0,
            0,
            1,
            -cx || 0.0,
            -cy || 0.0 // -this.p.y
        ]);
    }
}
class $4034906a84e141fe$export$d60cfc58d3c358b6 {
    constructor(_, scale, transformOrigin){
        this.type = 'scale';
        this.scale = null;
        this.originX = null;
        this.originY = null;
        var scaleSize = $4034906a84e141fe$export$baf26146a414f24a.parseScale(scale); // Workaround for node-canvas
        if (scaleSize.x === 0 || scaleSize.y === 0) {
            scaleSize.x = $4034906a84e141fe$export$8aefd221e087d814;
            scaleSize.y = $4034906a84e141fe$export$8aefd221e087d814;
        }
        this.scale = scaleSize;
        this.originX = transformOrigin[0];
        this.originY = transformOrigin[1];
    }
    apply(ctx) {
        var { scale: { x: x, y: y }, originX: originX, originY: originY } = this;
        var tx = originX.getPixels('x');
        var ty = originY.getPixels('y');
        ctx.translate(tx, ty);
        ctx.scale(x, y || x);
        ctx.translate(-tx, -ty);
    }
    unapply(ctx) {
        var { scale: { x: x, y: y }, originX: originX, originY: originY } = this;
        var tx = originX.getPixels('x');
        var ty = originY.getPixels('y');
        ctx.translate(tx, ty);
        ctx.scale(1.0 / x, 1.0 / y || x);
        ctx.translate(-tx, -ty);
    }
    applyToPoint(point) {
        var { x: x, y: y } = this.scale;
        point.applyTransform([
            x || 0.0,
            0,
            0,
            y || 0.0,
            0,
            0
        ]);
    }
}
class $4034906a84e141fe$export$5b12bf1653c0dd85 {
    constructor(_, matrix, transformOrigin){
        this.type = 'matrix';
        this.matrix = [];
        this.originX = null;
        this.originY = null;
        this.matrix = $4034906a84e141fe$export$39f594ce2cc17fac(matrix);
        this.originX = transformOrigin[0];
        this.originY = transformOrigin[1];
    }
    apply(ctx) {
        var { originX: originX, originY: originY, matrix: matrix } = this;
        var tx = originX.getPixels('x');
        var ty = originY.getPixels('y');
        ctx.translate(tx, ty);
        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        ctx.translate(-tx, -ty);
    }
    unapply(ctx) {
        var { originX: originX, originY: originY, matrix: matrix } = this;
        var a = matrix[0];
        var b = matrix[2];
        var c = matrix[4];
        var d = matrix[1];
        var e = matrix[3];
        var f = matrix[5];
        var g = 0.0;
        var h = 0.0;
        var i = 1.0;
        var det = 1 / (a * (e * i - f * h) - b * (d * i - f * g) + c * (d * h - e * g));
        var tx = originX.getPixels('x');
        var ty = originY.getPixels('y');
        ctx.translate(tx, ty);
        ctx.transform(det * (e * i - f * h), det * (f * g - d * i), det * (c * h - b * i), det * (a * i - c * g), det * (b * f - c * e), det * (c * d - a * f));
        ctx.translate(-tx, -ty);
    }
    applyToPoint(point) {
        point.applyTransform(this.matrix);
    }
}
class $4034906a84e141fe$export$a376180acd65c7ba extends $4034906a84e141fe$export$5b12bf1653c0dd85 {
    constructor(document1, skew, transformOrigin){
        super(document1, skew, transformOrigin);
        this.type = 'skew';
        this.angle = null;
        this.angle = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'angle', skew);
    }
}
class $4034906a84e141fe$export$80e6f3ff66bb89e7 extends $4034906a84e141fe$export$a376180acd65c7ba {
    constructor(document1, skew, transformOrigin){
        super(document1, skew, transformOrigin);
        this.type = 'skewX';
        this.matrix = [
            1,
            0,
            Math.tan(this.angle.getRadians()),
            1,
            0,
            0
        ];
    }
}
class $4034906a84e141fe$export$64b480ceb2d2b00 extends $4034906a84e141fe$export$a376180acd65c7ba {
    constructor(document1, skew, transformOrigin){
        super(document1, skew, transformOrigin);
        this.type = 'skewY';
        this.matrix = [
            1,
            Math.tan(this.angle.getRadians()),
            0,
            1,
            0,
            0
        ];
    }
}
function $4034906a84e141fe$var$parseTransforms(transform) {
    return $4034906a84e141fe$export$807f8f89b800558c(transform).trim().replace(/\)([a-zA-Z])/g, ') $1').replace(/\)(\s?,\s?)/g, ') ').split(/\s(?=[a-z])/);
}
function $4034906a84e141fe$var$parseTransform(transform) {
    var [type, value] = transform.split('(');
    return [
        type.trim(),
        value.trim().replace(')', '')
    ];
}
class $4034906a84e141fe$export$563a914cafbdc389 {
    constructor(document1, transform, transformOrigin){
        this.document = document1;
        this.transforms = [];
        var data = $4034906a84e141fe$var$parseTransforms(transform);
        data.forEach((transform)=>{
            if (transform === 'none') return;
            var [type, value] = $4034906a84e141fe$var$parseTransform(transform);
            var TransformType = $4034906a84e141fe$export$563a914cafbdc389.transformTypes[type];
            if (typeof TransformType !== 'undefined') this.transforms.push(new TransformType(this.document, value, transformOrigin));
        });
    }
    static fromElement(document1, element) {
        var transformStyle = element.getStyle('transform', false, true);
        var [transformOriginXProperty, transformOriginYProperty = transformOriginXProperty] = element.getStyle('transform-origin', false, true).split();
        var transformOrigin = [
            transformOriginXProperty,
            transformOriginYProperty
        ];
        if (transformStyle.hasValue()) return new $4034906a84e141fe$export$563a914cafbdc389(document1, transformStyle.getString(), transformOrigin);
        return null;
    }
    apply(ctx) {
        var { transforms: transforms } = this;
        var len = transforms.length;
        for(var i = 0; i < len; i++)transforms[i].apply(ctx);
    }
    unapply(ctx) {
        var { transforms: transforms } = this;
        var len = transforms.length;
        for(var i = len - 1; i >= 0; i--)transforms[i].unapply(ctx);
    }
    applyToPoint(point) {
        var { transforms: transforms } = this;
        var len = transforms.length;
        for(var i = 0; i < len; i++)transforms[i].applyToPoint(point);
    }
}
$4034906a84e141fe$export$563a914cafbdc389.transformTypes = {
    translate: $4034906a84e141fe$export$9db2ba50894db2b9,
    rotate: $4034906a84e141fe$export$152db69a76b6b79e,
    scale: $4034906a84e141fe$export$d60cfc58d3c358b6,
    matrix: $4034906a84e141fe$export$5b12bf1653c0dd85,
    skewX: $4034906a84e141fe$export$80e6f3ff66bb89e7,
    skewY: $4034906a84e141fe$export$64b480ceb2d2b00
};
class $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node){
        var captureTextNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        this.document = document1;
        this.node = node;
        this.captureTextNodes = captureTextNodes;
        this.attributes = Object.create(null);
        this.styles = Object.create(null);
        this.stylesSpecificity = Object.create(null);
        this.animationFrozen = false;
        this.animationFrozenValue = '';
        this.parent = null;
        this.children = [];
        if (!node || node.nodeType !== 1) // ELEMENT_NODE
        return;
         // add attributes
        Array.from(node.attributes).forEach((attribute)=>{
            var nodeName = $4034906a84e141fe$export$b3f31ce51802c0eb(attribute.nodeName);
            this.attributes[nodeName] = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, nodeName, attribute.value);
        });
        this.addStylesFromStyleDefinition(); // add inline styles
        if (this.getAttribute('style').hasValue()) {
            var styles = this.getAttribute('style').getString().split(';').map((_)=>_.trim());
            styles.forEach((style)=>{
                if (!style) return;
                var [name, value] = style.split(':').map((_)=>_.trim());
                this.styles[name] = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, name, value);
            });
        }
        var { definitions: definitions } = document1;
        var id = this.getAttribute('id'); // add id
        if (id.hasValue()) {
            if (!definitions[id.getString()]) definitions[id.getString()] = this;
        }
        Array.from(node.childNodes).forEach((childNode)=>{
            if (childNode.nodeType === 1) this.addChild(childNode); // ELEMENT_NODE
            else if (captureTextNodes && (childNode.nodeType === 3 || childNode.nodeType === 4)) {
                var textNode = document1.createTextNode(childNode);
                if (textNode.getText().length > 0) this.addChild(textNode); // TEXT_NODE
            }
        });
    }
    getAttribute(name) {
        var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var attr = this.attributes[name];
        if (!attr && createIfNotExists) {
            var _attr = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, name, '');
            this.attributes[name] = _attr;
            return _attr;
        }
        return attr || $4034906a84e141fe$export$41b04b3a73e7216d.empty(this.document);
    }
    getHrefAttribute() {
        for(var key in this.attributes){
            if (key === 'href' || key.endsWith(':href')) return this.attributes[key];
        }
        return $4034906a84e141fe$export$41b04b3a73e7216d.empty(this.document);
    }
    getStyle(name) {
        var createIfNotExists = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var skipAncestors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var style = this.styles[name];
        if (style) return style;
        var attr = this.getAttribute(name);
        if (attr !== null && attr !== void 0 && attr.hasValue()) {
            this.styles[name] = attr; // move up to me to cache
            return attr;
        }
        if (!skipAncestors) {
            var { parent: parent } = this;
            if (parent) {
                var parentStyle = parent.getStyle(name);
                if (parentStyle !== null && parentStyle !== void 0 && parentStyle.hasValue()) return parentStyle;
            }
        }
        if (createIfNotExists) {
            var _style = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, name, '');
            this.styles[name] = _style;
            return _style;
        }
        return style || $4034906a84e141fe$export$41b04b3a73e7216d.empty(this.document);
    }
    render(ctx) {
        // don't render display=none
        // don't render visibility=hidden
        if (this.getStyle('display').getString() === 'none' || this.getStyle('visibility').getString() === 'hidden') return;
        ctx.save();
        if (this.getStyle('mask').hasValue()) {
            // mask
            var mask = this.getStyle('mask').getDefinition();
            if (mask) {
                this.applyEffects(ctx);
                mask.apply(ctx, this);
            }
        } else if (this.getStyle('filter').getValue('none') !== 'none') {
            // filter
            var filter = this.getStyle('filter').getDefinition();
            if (filter) {
                this.applyEffects(ctx);
                filter.apply(ctx, this);
            }
        } else {
            this.setContext(ctx);
            this.renderChildren(ctx);
            this.clearContext(ctx);
        }
        ctx.restore();
    }
    setContext(_) {}
    applyEffects(ctx) {
        // transform
        var transform = $4034906a84e141fe$export$563a914cafbdc389.fromElement(this.document, this);
        if (transform) transform.apply(ctx);
         // clip
        var clipPathStyleProp = this.getStyle('clip-path', false, true);
        if (clipPathStyleProp.hasValue()) {
            var clip = clipPathStyleProp.getDefinition();
            if (clip) clip.apply(ctx);
        }
    }
    clearContext(_) {}
    renderChildren(ctx) {
        this.children.forEach((child)=>{
            child.render(ctx);
        });
    }
    addChild(childNode) {
        var child = childNode instanceof $4034906a84e141fe$export$db77ccec0bb4ccac ? childNode : this.document.createElement(childNode);
        child.parent = this;
        if (!$4034906a84e141fe$export$db77ccec0bb4ccac.ignoreChildTypes.includes(child.type)) this.children.push(child);
    }
    matchesSelector(selector) {
        var _node$getAttribute;
        var { node: node } = this;
        if (typeof node.matches === 'function') return node.matches(selector);
        var styleClasses = (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'class');
        if (!styleClasses || styleClasses === '') return false;
        return styleClasses.split(' ').some((styleClass)=>".".concat(styleClass) === selector);
    }
    addStylesFromStyleDefinition() {
        var { styles: styles, stylesSpecificity: stylesSpecificity } = this.document;
        for(var selector in styles)if (!selector.startsWith('@') && this.matchesSelector(selector)) {
            var style = styles[selector];
            var specificity = stylesSpecificity[selector];
            if (style) for(var name in style){
                var existingSpecificity = this.stylesSpecificity[name];
                if (typeof existingSpecificity === 'undefined') existingSpecificity = '000';
                if (specificity >= existingSpecificity) {
                    this.styles[name] = style[name];
                    this.stylesSpecificity[name] = specificity;
                }
            }
        }
    }
    removeStyles(element, ignoreStyles) {
        var toRestore = ignoreStyles.reduce((toRestore, name)=>{
            var styleProp = element.getStyle(name);
            if (!styleProp.hasValue()) return toRestore;
            var value = styleProp.getString();
            styleProp.setValue('');
            return [
                ...toRestore,
                [
                    name,
                    value
                ]
            ];
        }, []);
        return toRestore;
    }
    restoreStyles(element, styles) {
        styles.forEach((_ref)=>{
            var [name, value] = _ref;
            element.getStyle(name, true).setValue(value);
        });
    }
    isFirstChild() {
        var _this$parent;
        return ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.children.indexOf(this)) === 0;
    }
}
$4034906a84e141fe$export$db77ccec0bb4ccac.ignoreChildTypes = [
    'title'
];
class $4034906a84e141fe$export$868534362d0f7d0f extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
    }
}
function $4034906a84e141fe$var$wrapFontFamily(fontFamily) {
    var trimmed = fontFamily.trim();
    return /^('|")/.test(trimmed) ? trimmed : "\"".concat(trimmed, "\"");
}
function $4034906a84e141fe$var$prepareFontFamily(fontFamily) {
    return fontFamily;
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-style
 * @param fontStyle
 * @returns CSS font style.
 */ function $4034906a84e141fe$var$prepareFontStyle(fontStyle) {
    if (!fontStyle) return '';
    var targetFontStyle = fontStyle.trim().toLowerCase();
    switch(targetFontStyle){
        case 'normal':
        case 'italic':
        case 'oblique':
        case 'inherit':
        case 'initial':
        case 'unset':
            return targetFontStyle;
        default:
            if (/^oblique\s+(-|)\d+deg$/.test(targetFontStyle)) return targetFontStyle;
            return '';
    }
}
/**
 * https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
 * @param fontWeight
 * @returns CSS font weight.
 */ function $4034906a84e141fe$var$prepareFontWeight(fontWeight) {
    if (!fontWeight) return '';
    var targetFontWeight = fontWeight.trim().toLowerCase();
    switch(targetFontWeight){
        case 'normal':
        case 'bold':
        case 'lighter':
        case 'bolder':
        case 'inherit':
        case 'initial':
        case 'unset':
            return targetFontWeight;
        default:
            if (/^[\d.]+$/.test(targetFontWeight)) return targetFontWeight;
            return '';
    }
}
class $4034906a84e141fe$export$89abf52a030e56ee {
    constructor(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit){
        var inheritFont = inherit ? typeof inherit === 'string' ? $4034906a84e141fe$export$89abf52a030e56ee.parse(inherit) : inherit : {};
        this.fontFamily = fontFamily || inheritFont.fontFamily;
        this.fontSize = fontSize || inheritFont.fontSize;
        this.fontStyle = fontStyle || inheritFont.fontStyle;
        this.fontWeight = fontWeight || inheritFont.fontWeight;
        this.fontVariant = fontVariant || inheritFont.fontVariant;
    }
    static parse() {
        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var inherit = arguments.length > 1 ? arguments[1] : undefined;
        var fontStyle = '';
        var fontVariant = '';
        var fontWeight = '';
        var fontSize = '';
        var fontFamily = '';
        var parts = $4034906a84e141fe$export$807f8f89b800558c(font).trim().split(' ');
        var set = {
            fontSize: false,
            fontStyle: false,
            fontWeight: false,
            fontVariant: false
        };
        parts.forEach((part)=>{
            switch(true){
                case !set.fontStyle && $4034906a84e141fe$export$89abf52a030e56ee.styles.includes(part):
                    if (part !== 'inherit') fontStyle = part;
                    set.fontStyle = true;
                    break;
                case !set.fontVariant && $4034906a84e141fe$export$89abf52a030e56ee.variants.includes(part):
                    if (part !== 'inherit') fontVariant = part;
                    set.fontStyle = true;
                    set.fontVariant = true;
                    break;
                case !set.fontWeight && $4034906a84e141fe$export$89abf52a030e56ee.weights.includes(part):
                    if (part !== 'inherit') fontWeight = part;
                    set.fontStyle = true;
                    set.fontVariant = true;
                    set.fontWeight = true;
                    break;
                case !set.fontSize:
                    if (part !== 'inherit') [fontSize] = part.split('/');
                    set.fontStyle = true;
                    set.fontVariant = true;
                    set.fontWeight = true;
                    set.fontSize = true;
                    break;
                default:
                    if (part !== 'inherit') fontFamily += part;
            }
        });
        return new $4034906a84e141fe$export$89abf52a030e56ee(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit);
    }
    toString() {
        return [
            $4034906a84e141fe$var$prepareFontStyle(this.fontStyle),
            this.fontVariant,
            $4034906a84e141fe$var$prepareFontWeight(this.fontWeight),
            this.fontSize,
            $4034906a84e141fe$var$prepareFontFamily(this.fontFamily)
        ].join(' ').trim();
    }
}
$4034906a84e141fe$export$89abf52a030e56ee.styles = 'normal|italic|oblique|inherit';
$4034906a84e141fe$export$89abf52a030e56ee.variants = 'normal|small-caps|inherit';
$4034906a84e141fe$export$89abf52a030e56ee.weights = 'normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';
class $4034906a84e141fe$export$63080c4de6cfc362 {
    constructor(){
        var x1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NaN;
        var y1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.NaN;
        var x2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.NaN;
        var y2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Number.NaN;
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.addPoint(x1, y1);
        this.addPoint(x2, y2);
    }
    get x() {
        return this.x1;
    }
    get y() {
        return this.y1;
    }
    get width() {
        return this.x2 - this.x1;
    }
    get height() {
        return this.y2 - this.y1;
    }
    addPoint(x, y) {
        if (typeof x !== 'undefined') {
            if (isNaN(this.x1) || isNaN(this.x2)) {
                this.x1 = x;
                this.x2 = x;
            }
            if (x < this.x1) this.x1 = x;
            if (x > this.x2) this.x2 = x;
        }
        if (typeof y !== 'undefined') {
            if (isNaN(this.y1) || isNaN(this.y2)) {
                this.y1 = y;
                this.y2 = y;
            }
            if (y < this.y1) this.y1 = y;
            if (y > this.y2) this.y2 = y;
        }
    }
    addX(x) {
        this.addPoint(x, null);
    }
    addY(y) {
        this.addPoint(null, y);
    }
    addBoundingBox(boundingBox) {
        if (!boundingBox) return;
        var { x1: x1, y1: y1, x2: x2, y2: y2 } = boundingBox;
        this.addPoint(x1, y1);
        this.addPoint(x2, y2);
    }
    sumCubic(t, p0, p1, p2, p3) {
        return Math.pow(1 - t, 3) * p0 + 3 * Math.pow(1 - t, 2) * t * p1 + 3 * (1 - t) * Math.pow(t, 2) * p2 + Math.pow(t, 3) * p3;
    }
    bezierCurveAdd(forX, p0, p1, p2, p3) {
        var b = 6 * p0 - 12 * p1 + 6 * p2;
        var a = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
        var c = 3 * p1 - 3 * p0;
        if (a === 0) {
            if (b === 0) return;
            var t = -c / b;
            if (0 < t && t < 1) {
                if (forX) this.addX(this.sumCubic(t, p0, p1, p2, p3));
                else this.addY(this.sumCubic(t, p0, p1, p2, p3));
            }
            return;
        }
        var b2ac = Math.pow(b, 2) - 4 * c * a;
        if (b2ac < 0) return;
        var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
        if (0 < t1 && t1 < 1) {
            if (forX) this.addX(this.sumCubic(t1, p0, p1, p2, p3));
            else this.addY(this.sumCubic(t1, p0, p1, p2, p3));
        }
        var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
        if (0 < t2 && t2 < 1) {
            if (forX) this.addX(this.sumCubic(t2, p0, p1, p2, p3));
            else this.addY(this.sumCubic(t2, p0, p1, p2, p3));
        }
    }
    addBezierCurve(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
        this.addPoint(p0x, p0y);
        this.addPoint(p3x, p3y);
        this.bezierCurveAdd(true, p0x, p1x, p2x, p3x);
        this.bezierCurveAdd(false, p0y, p1y, p2y, p3y);
    }
    addQuadraticCurve(p0x, p0y, p1x, p1y, p2x, p2y) {
        var cp1x = p0x + 2 / 3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
        var cp1y = p0y + 2 / 3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
        var cp2x = cp1x + 1 / 3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
        var cp2y = cp1y + 1 / 3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
        this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
    }
    isPointInBox(x, y) {
        var { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        return x1 <= x && x <= x2 && y1 <= y && y <= y2;
    }
}
class $4034906a84e141fe$export$2c011581dc2d802 extends (0, $68e7U.SVGPathData) {
    constructor(path){
        super(path // Fix spaces after signs.
        .replace(/([+\-.])\s+/gm, '$1') // Remove invalid part.
        .replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, ''));
        this.control = null;
        this.start = null;
        this.current = null;
        this.command = null;
        this.commands = this.commands;
        this.i = -1;
        this.previousCommand = null;
        this.points = [];
        this.angles = [];
    }
    reset() {
        this.i = -1;
        this.command = null;
        this.previousCommand = null;
        this.start = new $4034906a84e141fe$export$baf26146a414f24a(0, 0);
        this.control = new $4034906a84e141fe$export$baf26146a414f24a(0, 0);
        this.current = new $4034906a84e141fe$export$baf26146a414f24a(0, 0);
        this.points = [];
        this.angles = [];
    }
    isEnd() {
        var { i: i, commands: commands } = this;
        return i >= commands.length - 1;
    }
    next() {
        var command = this.commands[++this.i];
        this.previousCommand = this.command;
        this.command = command;
        return command;
    }
    getPoint() {
        var xProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'x';
        var yProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'y';
        var point = new $4034906a84e141fe$export$baf26146a414f24a(this.command[xProp], this.command[yProp]);
        return this.makeAbsolute(point);
    }
    getAsControlPoint(xProp, yProp) {
        var point = this.getPoint(xProp, yProp);
        this.control = point;
        return point;
    }
    getAsCurrentPoint(xProp, yProp) {
        var point = this.getPoint(xProp, yProp);
        this.current = point;
        return point;
    }
    getReflectedControlPoint() {
        var previousCommand = this.previousCommand.type;
        if (previousCommand !== (0, $68e7U.SVGPathData).CURVE_TO && previousCommand !== (0, $68e7U.SVGPathData).SMOOTH_CURVE_TO && previousCommand !== (0, $68e7U.SVGPathData).QUAD_TO && previousCommand !== (0, $68e7U.SVGPathData).SMOOTH_QUAD_TO) return this.current;
         // reflect point
        var { current: { x: cx, y: cy }, control: { x: ox, y: oy } } = this;
        var point = new $4034906a84e141fe$export$baf26146a414f24a(2 * cx - ox, 2 * cy - oy);
        return point;
    }
    makeAbsolute(point) {
        if (this.command.relative) {
            var { x: x, y: y } = this.current;
            point.x += x;
            point.y += y;
        }
        return point;
    }
    addMarker(point, from, priorTo) {
        var { points: points, angles: angles } = this; // if the last angle isn't filled in because we didn't have this point yet ...
        if (priorTo && angles.length > 0 && !angles[angles.length - 1]) angles[angles.length - 1] = points[points.length - 1].angleTo(priorTo);
        this.addMarkerAngle(point, from ? from.angleTo(point) : null);
    }
    addMarkerAngle(point, angle) {
        this.points.push(point);
        this.angles.push(angle);
    }
    getMarkerPoints() {
        return this.points;
    }
    getMarkerAngles() {
        var { angles: angles } = this;
        var len = angles.length;
        for(var i = 0; i < len; i++)if (!angles[i]) {
            for(var j = i + 1; j < len; j++)if (angles[j]) {
                angles[i] = angles[j];
                break;
            }
        }
        return angles;
    }
}
class $4034906a84e141fe$export$66cca51e2e9c1a33 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.modifiedEmSizeStack = false;
    }
    calculateOpacity() {
        var opacity = 1.0; // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
        var element = this;
        while(element){
            var opacityStyle = element.getStyle('opacity', false, true); // no ancestors on style call
            if (opacityStyle.hasValue(true)) opacity *= opacityStyle.getNumber();
            element = element.parent;
        }
        return opacity;
    }
    setContext(ctx) {
        var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!fromMeasure) {
            // causes stack overflow when measuring text with gradients
            // fill
            var fillStyleProp = this.getStyle('fill');
            var fillOpacityStyleProp = this.getStyle('fill-opacity');
            var strokeStyleProp = this.getStyle('stroke');
            var strokeOpacityProp = this.getStyle('stroke-opacity');
            if (fillStyleProp.isUrlDefinition()) {
                var fillStyle = fillStyleProp.getFillStyleDefinition(this, fillOpacityStyleProp);
                if (fillStyle) ctx.fillStyle = fillStyle;
            } else if (fillStyleProp.hasValue()) {
                if (fillStyleProp.getString() === 'currentColor') fillStyleProp.setValue(this.getStyle('color').getColor());
                var _fillStyle = fillStyleProp.getColor();
                if (_fillStyle !== 'inherit') ctx.fillStyle = _fillStyle === 'none' ? 'rgba(0,0,0,0)' : _fillStyle;
            }
            if (fillOpacityStyleProp.hasValue()) {
                var _fillStyle2 = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'fill', ctx.fillStyle).addOpacity(fillOpacityStyleProp).getColor();
                ctx.fillStyle = _fillStyle2;
            } // stroke
            if (strokeStyleProp.isUrlDefinition()) {
                var strokeStyle = strokeStyleProp.getFillStyleDefinition(this, strokeOpacityProp);
                if (strokeStyle) ctx.strokeStyle = strokeStyle;
            } else if (strokeStyleProp.hasValue()) {
                if (strokeStyleProp.getString() === 'currentColor') strokeStyleProp.setValue(this.getStyle('color').getColor());
                var _strokeStyle = strokeStyleProp.getString();
                if (_strokeStyle !== 'inherit') ctx.strokeStyle = _strokeStyle === 'none' ? 'rgba(0,0,0,0)' : _strokeStyle;
            }
            if (strokeOpacityProp.hasValue()) {
                var _strokeStyle2 = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'stroke', ctx.strokeStyle).addOpacity(strokeOpacityProp).getString();
                ctx.strokeStyle = _strokeStyle2;
            }
            var strokeWidthStyleProp = this.getStyle('stroke-width');
            if (strokeWidthStyleProp.hasValue()) {
                var newLineWidth = strokeWidthStyleProp.getPixels();
                ctx.lineWidth = !newLineWidth ? $4034906a84e141fe$export$8aefd221e087d814 // browsers don't respect 0 (or node-canvas? :-)
                 : newLineWidth;
            }
            var strokeLinecapStyleProp = this.getStyle('stroke-linecap');
            var strokeLinejoinStyleProp = this.getStyle('stroke-linejoin');
            var strokeMiterlimitProp = this.getStyle('stroke-miterlimit'); // NEED TEST
            // const pointOrderStyleProp = this.getStyle('paint-order');
            var strokeDasharrayStyleProp = this.getStyle('stroke-dasharray');
            var strokeDashoffsetProp = this.getStyle('stroke-dashoffset');
            if (strokeLinecapStyleProp.hasValue()) ctx.lineCap = strokeLinecapStyleProp.getString();
            if (strokeLinejoinStyleProp.hasValue()) ctx.lineJoin = strokeLinejoinStyleProp.getString();
            if (strokeMiterlimitProp.hasValue()) ctx.miterLimit = strokeMiterlimitProp.getNumber();
             // NEED TEST
            // if (pointOrderStyleProp.hasValue()) {
            // 	// ?
            // 	ctx.paintOrder = pointOrderStyleProp.getValue();
            // }
            if (strokeDasharrayStyleProp.hasValue() && strokeDasharrayStyleProp.getString() !== 'none') {
                var gaps = $4034906a84e141fe$export$39f594ce2cc17fac(strokeDasharrayStyleProp.getString());
                if (typeof ctx.setLineDash !== 'undefined') ctx.setLineDash(gaps);
                else if (typeof ctx.webkitLineDash !== 'undefined') // @ts-expect-error Handle browser prefix.
                ctx.webkitLineDash = gaps;
                else if (typeof ctx.mozDash !== 'undefined' && !(gaps.length === 1 && gaps[0] === 0)) // @ts-expect-error Handle browser prefix.
                ctx.mozDash = gaps;
                var offset = strokeDashoffsetProp.getPixels();
                if (typeof ctx.lineDashOffset !== 'undefined') ctx.lineDashOffset = offset;
                else if (typeof ctx.webkitLineDashOffset !== 'undefined') // @ts-expect-error Handle browser prefix.
                ctx.webkitLineDashOffset = offset;
                else if (typeof ctx.mozDashOffset !== 'undefined') // @ts-expect-error Handle browser prefix.
                ctx.mozDashOffset = offset;
            }
        } // font
        this.modifiedEmSizeStack = false;
        if (typeof ctx.font !== 'undefined') {
            var fontStyleProp = this.getStyle('font');
            var fontStyleStyleProp = this.getStyle('font-style');
            var fontVariantStyleProp = this.getStyle('font-variant');
            var fontWeightStyleProp = this.getStyle('font-weight');
            var fontSizeStyleProp = this.getStyle('font-size');
            var fontFamilyStyleProp = this.getStyle('font-family');
            var font = new $4034906a84e141fe$export$89abf52a030e56ee(fontStyleStyleProp.getString(), fontVariantStyleProp.getString(), fontWeightStyleProp.getString(), fontSizeStyleProp.hasValue() ? "".concat(fontSizeStyleProp.getPixels(true), "px") : '', fontFamilyStyleProp.getString(), $4034906a84e141fe$export$89abf52a030e56ee.parse(fontStyleProp.getString(), ctx.font));
            fontStyleStyleProp.setValue(font.fontStyle);
            fontVariantStyleProp.setValue(font.fontVariant);
            fontWeightStyleProp.setValue(font.fontWeight);
            fontSizeStyleProp.setValue(font.fontSize);
            fontFamilyStyleProp.setValue(font.fontFamily);
            ctx.font = font.toString();
            if (fontSizeStyleProp.isPixels()) {
                this.document.emSize = fontSizeStyleProp.getPixels();
                this.modifiedEmSizeStack = true;
            }
        }
        if (!fromMeasure) {
            // effects
            this.applyEffects(ctx); // opacity
            ctx.globalAlpha = this.calculateOpacity();
        }
    }
    clearContext(ctx) {
        super.clearContext(ctx);
        if (this.modifiedEmSizeStack) this.document.popEmSize();
    }
}
class $4034906a84e141fe$export$c1ed4714510a72ff extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'path';
        this.pathParser = null;
        this.pathParser = new $4034906a84e141fe$export$2c011581dc2d802(this.getAttribute('d').getString());
    }
    path(ctx) {
        var { pathParser: pathParser } = this;
        var boundingBox = new $4034906a84e141fe$export$63080c4de6cfc362();
        pathParser.reset();
        if (ctx) ctx.beginPath();
        while(!pathParser.isEnd())switch(pathParser.next().type){
            case $4034906a84e141fe$export$2c011581dc2d802.MOVE_TO:
                this.pathM(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.LINE_TO:
                this.pathL(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.HORIZ_LINE_TO:
                this.pathH(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.VERT_LINE_TO:
                this.pathV(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.CURVE_TO:
                this.pathC(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.SMOOTH_CURVE_TO:
                this.pathS(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.QUAD_TO:
                this.pathQ(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.SMOOTH_QUAD_TO:
                this.pathT(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.ARC:
                this.pathA(ctx, boundingBox);
                break;
            case $4034906a84e141fe$export$2c011581dc2d802.CLOSE_PATH:
                this.pathZ(ctx, boundingBox);
                break;
        }
        return boundingBox;
    }
    getBoundingBox(_) {
        return this.path();
    }
    getMarkers() {
        var { pathParser: pathParser } = this;
        var points = pathParser.getMarkerPoints();
        var angles = pathParser.getMarkerAngles();
        var markers = points.map((point, i)=>[
                point,
                angles[i]
            ]);
        return markers;
    }
    renderChildren(ctx) {
        this.path(ctx);
        this.document.screen.mouse.checkPath(this, ctx);
        var fillRuleStyleProp = this.getStyle('fill-rule');
        if (ctx.fillStyle !== '') {
            if (fillRuleStyleProp.getString('inherit') !== 'inherit') ctx.fill(fillRuleStyleProp.getString());
            else ctx.fill();
        }
        if (ctx.strokeStyle !== '') {
            if (this.getAttribute('vector-effect').getString() === 'non-scaling-stroke') {
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.stroke();
                ctx.restore();
            } else ctx.stroke();
        }
        var markers = this.getMarkers();
        if (markers) {
            var markersLastIndex = markers.length - 1;
            var markerStartStyleProp = this.getStyle('marker-start');
            var markerMidStyleProp = this.getStyle('marker-mid');
            var markerEndStyleProp = this.getStyle('marker-end');
            if (markerStartStyleProp.isUrlDefinition()) {
                var marker = markerStartStyleProp.getDefinition();
                var [point, angle] = markers[0];
                marker.render(ctx, point, angle);
            }
            if (markerMidStyleProp.isUrlDefinition()) {
                var _marker = markerMidStyleProp.getDefinition();
                for(var i = 1; i < markersLastIndex; i++){
                    var [_point, _angle] = markers[i];
                    _marker.render(ctx, _point, _angle);
                }
            }
            if (markerEndStyleProp.isUrlDefinition()) {
                var _marker2 = markerEndStyleProp.getDefinition();
                var [_point2, _angle2] = markers[markersLastIndex];
                _marker2.render(ctx, _point2, _angle2);
            }
        }
    }
    static pathM(pathParser) {
        var point = pathParser.getAsCurrentPoint();
        pathParser.start = pathParser.current;
        return {
            point: point
        };
    }
    pathM(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { point: point } = $4034906a84e141fe$export$c1ed4714510a72ff.pathM(pathParser);
        var { x: x, y: y } = point;
        pathParser.addMarker(point);
        boundingBox.addPoint(x, y);
        if (ctx) ctx.moveTo(x, y);
    }
    static pathL(pathParser) {
        var { current: current } = pathParser;
        var point = pathParser.getAsCurrentPoint();
        return {
            current: current,
            point: point
        };
    }
    pathL(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, point: point } = $4034906a84e141fe$export$c1ed4714510a72ff.pathL(pathParser);
        var { x: x, y: y } = point;
        pathParser.addMarker(point, current);
        boundingBox.addPoint(x, y);
        if (ctx) ctx.lineTo(x, y);
    }
    static pathH(pathParser) {
        var { current: current, command: command } = pathParser;
        var point = new $4034906a84e141fe$export$baf26146a414f24a((command.relative ? current.x : 0) + command.x, current.y);
        pathParser.current = point;
        return {
            current: current,
            point: point
        };
    }
    pathH(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, point: point } = $4034906a84e141fe$export$c1ed4714510a72ff.pathH(pathParser);
        var { x: x, y: y } = point;
        pathParser.addMarker(point, current);
        boundingBox.addPoint(x, y);
        if (ctx) ctx.lineTo(x, y);
    }
    static pathV(pathParser) {
        var { current: current, command: command } = pathParser;
        var point = new $4034906a84e141fe$export$baf26146a414f24a(current.x, (command.relative ? current.y : 0) + command.y);
        pathParser.current = point;
        return {
            current: current,
            point: point
        };
    }
    pathV(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, point: point } = $4034906a84e141fe$export$c1ed4714510a72ff.pathV(pathParser);
        var { x: x, y: y } = point;
        pathParser.addMarker(point, current);
        boundingBox.addPoint(x, y);
        if (ctx) ctx.lineTo(x, y);
    }
    static pathC(pathParser) {
        var { current: current } = pathParser;
        var point = pathParser.getPoint('x1', 'y1');
        var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
        var currentPoint = pathParser.getAsCurrentPoint();
        return {
            current: current,
            point: point,
            controlPoint: controlPoint,
            currentPoint: currentPoint
        };
    }
    pathC(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, point: point, controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathC(pathParser);
        pathParser.addMarker(currentPoint, controlPoint, point);
        boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        if (ctx) ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
    static pathS(pathParser) {
        var { current: current } = pathParser;
        var point = pathParser.getReflectedControlPoint();
        var controlPoint = pathParser.getAsControlPoint('x2', 'y2');
        var currentPoint = pathParser.getAsCurrentPoint();
        return {
            current: current,
            point: point,
            controlPoint: controlPoint,
            currentPoint: currentPoint
        };
    }
    pathS(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, point: point, controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathS(pathParser);
        pathParser.addMarker(currentPoint, controlPoint, point);
        boundingBox.addBezierCurve(current.x, current.y, point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        if (ctx) ctx.bezierCurveTo(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
    static pathQ(pathParser) {
        var { current: current } = pathParser;
        var controlPoint = pathParser.getAsControlPoint('x1', 'y1');
        var currentPoint = pathParser.getAsCurrentPoint();
        return {
            current: current,
            controlPoint: controlPoint,
            currentPoint: currentPoint
        };
    }
    pathQ(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathQ(pathParser);
        pathParser.addMarker(currentPoint, controlPoint, controlPoint);
        boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        if (ctx) ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
    static pathT(pathParser) {
        var { current: current } = pathParser;
        var controlPoint = pathParser.getReflectedControlPoint();
        pathParser.control = controlPoint;
        var currentPoint = pathParser.getAsCurrentPoint();
        return {
            current: current,
            controlPoint: controlPoint,
            currentPoint: currentPoint
        };
    }
    pathT(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { current: current, controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathT(pathParser);
        pathParser.addMarker(currentPoint, controlPoint, controlPoint);
        boundingBox.addQuadraticCurve(current.x, current.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        if (ctx) ctx.quadraticCurveTo(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
    static pathA(pathParser) {
        var { current: current, command: command } = pathParser;
        var { rX: rX, rY: rY, xRot: xRot, lArcFlag: lArcFlag, sweepFlag: sweepFlag } = command;
        var xAxisRotation = xRot * (Math.PI / 180.0);
        var currentPoint = pathParser.getAsCurrentPoint(); // Conversion from endpoint to center parameterization
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        // x1', y1'
        var currp = new $4034906a84e141fe$export$baf26146a414f24a(Math.cos(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.sin(xAxisRotation) * (current.y - currentPoint.y) / 2.0, -Math.sin(xAxisRotation) * (current.x - currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * (current.y - currentPoint.y) / 2.0); // adjust radii
        var l = Math.pow(currp.x, 2) / Math.pow(rX, 2) + Math.pow(currp.y, 2) / Math.pow(rY, 2);
        if (l > 1) {
            rX *= Math.sqrt(l);
            rY *= Math.sqrt(l);
        } // cx', cy'
        var s = (lArcFlag === sweepFlag ? -1 : 1) * Math.sqrt((Math.pow(rX, 2) * Math.pow(rY, 2) - Math.pow(rX, 2) * Math.pow(currp.y, 2) - Math.pow(rY, 2) * Math.pow(currp.x, 2)) / (Math.pow(rX, 2) * Math.pow(currp.y, 2) + Math.pow(rY, 2) * Math.pow(currp.x, 2)));
        if (isNaN(s)) s = 0;
        var cpp = new $4034906a84e141fe$export$baf26146a414f24a(s * rX * currp.y / rY, s * -rY * currp.x / rX); // cx, cy
        var centp = new $4034906a84e141fe$export$baf26146a414f24a((current.x + currentPoint.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y, (current.y + currentPoint.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y); // initial angle
        var a1 = $4034906a84e141fe$export$7796842e1d4b1fa5([
            1,
            0
        ], [
            (currp.x - cpp.x) / rX,
            (currp.y - cpp.y) / rY
        ]); // θ1
        // angle delta
        var u = [
            (currp.x - cpp.x) / rX,
            (currp.y - cpp.y) / rY
        ];
        var v = [
            (-currp.x - cpp.x) / rX,
            (-currp.y - cpp.y) / rY
        ];
        var ad = $4034906a84e141fe$export$7796842e1d4b1fa5(u, v); // Δθ
        if ($4034906a84e141fe$export$26217366fe93b305(u, v) <= -1) ad = Math.PI;
        if ($4034906a84e141fe$export$26217366fe93b305(u, v) >= 1) ad = 0;
        return {
            currentPoint: currentPoint,
            rX: rX,
            rY: rY,
            sweepFlag: sweepFlag,
            xAxisRotation: xAxisRotation,
            centp: centp,
            a1: a1,
            ad: ad
        };
    }
    pathA(ctx, boundingBox) {
        var { pathParser: pathParser } = this;
        var { currentPoint: currentPoint, rX: rX, rY: rY, sweepFlag: sweepFlag, xAxisRotation: xAxisRotation, centp: centp, a1: a1, ad: ad } = $4034906a84e141fe$export$c1ed4714510a72ff.pathA(pathParser); // for markers
        var dir = 1 - sweepFlag ? 1.0 : -1;
        var ah = a1 + dir * (ad / 2.0);
        var halfWay = new $4034906a84e141fe$export$baf26146a414f24a(centp.x + rX * Math.cos(ah), centp.y + rY * Math.sin(ah));
        pathParser.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
        pathParser.addMarkerAngle(currentPoint, ah - dir * Math.PI);
        boundingBox.addPoint(currentPoint.x, currentPoint.y); // TODO: this is too naive, make it better
        if (ctx && !isNaN(a1) && !isNaN(ad)) {
            var r = rX > rY ? rX : rY;
            var sx = rX > rY ? 1 : rX / rY;
            var sy = rX > rY ? rY / rX : 1;
            ctx.translate(centp.x, centp.y);
            ctx.rotate(xAxisRotation);
            ctx.scale(sx, sy);
            ctx.arc(0, 0, r, a1, a1 + ad, Boolean(1 - sweepFlag));
            ctx.scale(1 / sx, 1 / sy);
            ctx.rotate(-xAxisRotation);
            ctx.translate(-centp.x, -centp.y);
        }
    }
    static pathZ(pathParser) {
        pathParser.current = pathParser.start;
    }
    pathZ(ctx, boundingBox) {
        $4034906a84e141fe$export$c1ed4714510a72ff.pathZ(this.pathParser);
        if (ctx) // only close path if it is not a straight line
        {
            if (boundingBox.x1 !== boundingBox.x2 && boundingBox.y1 !== boundingBox.y2) ctx.closePath();
        }
    }
}
class $4034906a84e141fe$export$9f86a6657dbbe872 extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'glyph';
        this.horizAdvX = this.getAttribute('horiz-adv-x').getNumber();
        this.unicode = this.getAttribute('unicode').getString();
        this.arabicForm = this.getAttribute('arabic-form').getString();
    }
}
class $4034906a84e141fe$export$764077542c4bf9bd extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(document1, node, captureTextNodes){
        super(document1, node, new.target === $4034906a84e141fe$export$764077542c4bf9bd ? true : captureTextNodes);
        this.type = 'text';
        this.x = 0;
        this.y = 0;
        this.measureCache = -1;
    }
    setContext(ctx) {
        var fromMeasure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        super.setContext(ctx, fromMeasure);
        var textBaseline = this.getStyle('dominant-baseline').getTextBaseline() || this.getStyle('alignment-baseline').getTextBaseline();
        if (textBaseline) ctx.textBaseline = textBaseline;
    }
    initializeCoordinates() {
        this.x = 0;
        this.y = 0;
        this.leafTexts = [];
        this.textChunkStart = 0;
        this.minX = Number.POSITIVE_INFINITY;
        this.maxX = Number.NEGATIVE_INFINITY;
    }
    getBoundingBox(ctx) {
        if (this.type !== 'text') return this.getTElementBoundingBox(ctx);
         // first, calculate child positions
        this.initializeCoordinates();
        this.adjustChildCoordinatesRecursive(ctx);
        var boundingBox = null; // then calculate bounding box
        this.children.forEach((_, i)=>{
            var childBoundingBox = this.getChildBoundingBox(ctx, this, this, i);
            if (!boundingBox) boundingBox = childBoundingBox;
            else boundingBox.addBoundingBox(childBoundingBox);
        });
        return boundingBox;
    }
    getFontSize() {
        var { document: document1, parent: parent } = this;
        var inheritFontSize = $4034906a84e141fe$export$89abf52a030e56ee.parse(document1.ctx.font).fontSize;
        var fontSize = parent.getStyle('font-size').getNumber(inheritFontSize);
        return fontSize;
    }
    getTElementBoundingBox(ctx) {
        var fontSize = this.getFontSize();
        return new $4034906a84e141fe$export$63080c4de6cfc362(this.x, this.y - fontSize, this.x + this.measureText(ctx), this.y);
    }
    getGlyph(font, text, i) {
        var char = text[i];
        var glyph = null;
        if (font.isArabic) {
            var len = text.length;
            var prevChar = text[i - 1];
            var nextChar = text[i + 1];
            var arabicForm = 'isolated';
            if ((i === 0 || prevChar === ' ') && i < len - 1 && nextChar !== ' ') arabicForm = 'terminal';
            if (i > 0 && prevChar !== ' ' && i < len - 1 && nextChar !== ' ') arabicForm = 'medial';
            if (i > 0 && prevChar !== ' ' && (i === len - 1 || nextChar === ' ')) arabicForm = 'initial';
            if (typeof font.glyphs[char] !== 'undefined') {
                // NEED TEST
                var maybeGlyph = font.glyphs[char];
                glyph = maybeGlyph instanceof $4034906a84e141fe$export$9f86a6657dbbe872 ? maybeGlyph : maybeGlyph[arabicForm];
            }
        } else glyph = font.glyphs[char];
        if (!glyph) glyph = font.missingGlyph;
        return glyph;
    }
    getText() {
        return '';
    }
    getTextFromNode(node) {
        var textNode = node || this.node;
        var childNodes = Array.from(textNode.parentNode.childNodes);
        var index = childNodes.indexOf(textNode);
        var lastIndex = childNodes.length - 1;
        var text = $4034906a84e141fe$export$807f8f89b800558c(// || textNode.text
        textNode.textContent || '');
        if (index === 0) text = $4034906a84e141fe$export$c5557f40488c48ec(text);
        if (index === lastIndex) text = $4034906a84e141fe$export$da8e5da96e287379(text);
        return text;
    }
    renderChildren(ctx) {
        if (this.type !== 'text') {
            this.renderTElementChildren(ctx);
            return;
        } // first, calculate child positions
        this.initializeCoordinates();
        this.adjustChildCoordinatesRecursive(ctx); // then render
        this.children.forEach((_, i)=>{
            this.renderChild(ctx, this, this, i);
        });
        var { mouse: mouse } = this.document.screen; // Do not calc bounding box if mouse is not working.
        if (mouse.isWorking()) mouse.checkBoundingBox(this, this.getBoundingBox(ctx));
    }
    renderTElementChildren(ctx) {
        var { document: document1, parent: parent } = this;
        var renderText = this.getText();
        var customFont = parent.getStyle('font-family').getDefinition();
        if (customFont) {
            var { unitsPerEm: unitsPerEm } = customFont.fontFace;
            var ctxFont = $4034906a84e141fe$export$89abf52a030e56ee.parse(document1.ctx.font);
            var fontSize = parent.getStyle('font-size').getNumber(ctxFont.fontSize);
            var fontStyle = parent.getStyle('font-style').getString(ctxFont.fontStyle);
            var scale = fontSize / unitsPerEm;
            var text = customFont.isRTL ? renderText.split('').reverse().join('') : renderText;
            var dx = $4034906a84e141fe$export$39f594ce2cc17fac(parent.getAttribute('dx').getString());
            var len = text.length;
            for(var i = 0; i < len; i++){
                var glyph = this.getGlyph(customFont, text, i);
                ctx.translate(this.x, this.y);
                ctx.scale(scale, -scale);
                var lw = ctx.lineWidth;
                ctx.lineWidth = ctx.lineWidth * unitsPerEm / fontSize;
                if (fontStyle === 'italic') ctx.transform(1, 0, .4, 1, 0, 0);
                glyph.render(ctx);
                if (fontStyle === 'italic') ctx.transform(1, 0, -0.4, 1, 0, 0);
                ctx.lineWidth = lw;
                ctx.scale(1 / scale, -1 / scale);
                ctx.translate(-this.x, -this.y);
                this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / unitsPerEm;
                if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) this.x += dx[i];
            }
            return;
        }
        var { x: x, y: y } = this; // NEED TEST
        // if (ctx.paintOrder === 'stroke') {
        // 	if (ctx.strokeStyle) {
        // 		ctx.strokeText(renderText, x, y);
        // 	}
        // 	if (ctx.fillStyle) {
        // 		ctx.fillText(renderText, x, y);
        // 	}
        // } else {
        if (ctx.fillStyle) ctx.fillText(renderText, x, y);
        if (ctx.strokeStyle) ctx.strokeText(renderText, x, y);
         // }
    }
    applyAnchoring() {
        if (this.textChunkStart >= this.leafTexts.length) return;
         // This is basically the "Apply anchoring" part of https://www.w3.org/TR/SVG2/text.html#TextLayoutAlgorithm.
        // The difference is that we apply the anchoring as soon as a chunk is finished. This saves some extra looping.
        // Vertical text is not supported.
        var firstElement = this.leafTexts[this.textChunkStart];
        var textAnchor = firstElement.getStyle('text-anchor').getString('start');
        var isRTL = false; // we treat RTL like LTR
        var shift = 0;
        if (textAnchor === 'start' && !isRTL || textAnchor === 'end' && isRTL) shift = firstElement.x - this.minX;
        else if (textAnchor === 'end' && !isRTL || textAnchor === 'start' && isRTL) shift = firstElement.x - this.maxX;
        else shift = firstElement.x - (this.minX + this.maxX) / 2;
        for(var i = this.textChunkStart; i < this.leafTexts.length; i++)this.leafTexts[i].x += shift;
         // start new chunk
        this.minX = Number.POSITIVE_INFINITY;
        this.maxX = Number.NEGATIVE_INFINITY;
        this.textChunkStart = this.leafTexts.length;
    }
    adjustChildCoordinatesRecursive(ctx) {
        this.children.forEach((_, i)=>{
            this.adjustChildCoordinatesRecursiveCore(ctx, this, this, i);
        });
        this.applyAnchoring();
    }
    adjustChildCoordinatesRecursiveCore(ctx, textParent, parent, i) {
        var child = parent.children[i];
        if (child.children.length > 0) child.children.forEach((_, i)=>{
            textParent.adjustChildCoordinatesRecursiveCore(ctx, textParent, child, i);
        });
        else // only leafs are relevant
        this.adjustChildCoordinates(ctx, textParent, parent, i);
    }
    adjustChildCoordinates(ctx, textParent, parent, i) {
        var child = parent.children[i];
        if (typeof child.measureText !== 'function') return child;
        ctx.save();
        child.setContext(ctx, true);
        var xAttr = child.getAttribute('x');
        var yAttr = child.getAttribute('y');
        var dxAttr = child.getAttribute('dx');
        var dyAttr = child.getAttribute('dy');
        var customFont = child.getStyle('font-family').getDefinition();
        var isRTL = Boolean(customFont) && customFont.isRTL;
        if (i === 0) {
            // First children inherit attributes from parent(s). Positional attributes
            // are only inherited from a parent to it's first child.
            if (!xAttr.hasValue()) xAttr.setValue(child.getInheritedAttribute('x'));
            if (!yAttr.hasValue()) yAttr.setValue(child.getInheritedAttribute('y'));
            if (!dxAttr.hasValue()) dxAttr.setValue(child.getInheritedAttribute('dx'));
            if (!dyAttr.hasValue()) dyAttr.setValue(child.getInheritedAttribute('dy'));
        }
        var width = child.measureText(ctx);
        if (isRTL) textParent.x -= width;
        if (xAttr.hasValue()) {
            // an "x" attribute marks the start of a new chunk
            textParent.applyAnchoring();
            child.x = xAttr.getPixels('x');
            if (dxAttr.hasValue()) child.x += dxAttr.getPixels('x');
        } else {
            if (dxAttr.hasValue()) textParent.x += dxAttr.getPixels('x');
            child.x = textParent.x;
        }
        textParent.x = child.x;
        if (!isRTL) textParent.x += width;
        if (yAttr.hasValue()) {
            child.y = yAttr.getPixels('y');
            if (dyAttr.hasValue()) child.y += dyAttr.getPixels('y');
        } else {
            if (dyAttr.hasValue()) textParent.y += dyAttr.getPixels('y');
            child.y = textParent.y;
        }
        textParent.y = child.y; // update the current chunk and it's bounds
        textParent.leafTexts.push(child);
        textParent.minX = Math.min(textParent.minX, child.x, child.x + width);
        textParent.maxX = Math.max(textParent.maxX, child.x, child.x + width);
        child.clearContext(ctx);
        ctx.restore();
        return child;
    }
    getChildBoundingBox(ctx, textParent, parent, i) {
        var child = parent.children[i]; // not a text node?
        if (typeof child.getBoundingBox !== 'function') return null;
        var boundingBox = child.getBoundingBox(ctx);
        if (!boundingBox) return null;
        child.children.forEach((_, i)=>{
            var childBoundingBox = textParent.getChildBoundingBox(ctx, textParent, child, i);
            boundingBox.addBoundingBox(childBoundingBox);
        });
        return boundingBox;
    }
    renderChild(ctx, textParent, parent, i) {
        var child = parent.children[i];
        child.render(ctx);
        child.children.forEach((_, i)=>{
            textParent.renderChild(ctx, textParent, child, i);
        });
    }
    measureText(ctx) {
        var { measureCache: measureCache } = this;
        if (~measureCache) return measureCache;
        var renderText = this.getText();
        var measure = this.measureTargetText(ctx, renderText);
        this.measureCache = measure;
        return measure;
    }
    measureTargetText(ctx, targetText) {
        if (!targetText.length) return 0;
        var { parent: parent } = this;
        var customFont = parent.getStyle('font-family').getDefinition();
        if (customFont) {
            var fontSize = this.getFontSize();
            var text = customFont.isRTL ? targetText.split('').reverse().join('') : targetText;
            var dx = $4034906a84e141fe$export$39f594ce2cc17fac(parent.getAttribute('dx').getString());
            var len = text.length;
            var _measure = 0;
            for(var i = 0; i < len; i++){
                var glyph = this.getGlyph(customFont, text, i);
                _measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;
                if (typeof dx[i] !== 'undefined' && !isNaN(dx[i])) _measure += dx[i];
            }
            return _measure;
        }
        if (!ctx.measureText) return targetText.length * 10;
        ctx.save();
        this.setContext(ctx, true);
        var { width: measure } = ctx.measureText(targetText);
        this.clearContext(ctx);
        ctx.restore();
        return measure;
    }
    /**
   * Inherits positional attributes from {@link TextElement} parent(s). Attributes
   * are only inherited from a parent to its first child.
   * @param name - The attribute name.
   * @returns The attribute value or null.
   */ getInheritedAttribute(name) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias,consistent-this
        var current = this;
        while(current instanceof $4034906a84e141fe$export$764077542c4bf9bd && current.isFirstChild()){
            var parentAttr = current.parent.getAttribute(name);
            if (parentAttr.hasValue(true)) return parentAttr.getValue('0');
            current = current.parent;
        }
        return null;
    }
}
class $4034906a84e141fe$export$c433ff877cb33f94 extends $4034906a84e141fe$export$764077542c4bf9bd {
    constructor(document1, node, captureTextNodes){
        super(document1, node, new.target === $4034906a84e141fe$export$c433ff877cb33f94 ? true : captureTextNodes);
        this.type = 'tspan'; // if this node has children, then they own the text
        this.text = this.children.length > 0 ? '' : this.getTextFromNode();
    }
    getText() {
        return this.text;
    }
}
class $4034906a84e141fe$var$TextNode extends $4034906a84e141fe$export$c433ff877cb33f94 {
    constructor(){
        super(...arguments);
        this.type = 'textNode';
    }
}
class $4034906a84e141fe$export$1c514248cc7fa12c extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(){
        super(...arguments);
        this.type = 'svg';
        this.root = false;
    }
    setContext(ctx) {
        var _this$node$parentNode;
        var { document: document1 } = this;
        var { screen: screen, window: window1 } = document1;
        var canvas = ctx.canvas;
        screen.setDefaults(ctx);
        if (canvas.style && typeof ctx.font !== 'undefined' && window1 && typeof window1.getComputedStyle !== 'undefined') {
            ctx.font = window1.getComputedStyle(canvas).getPropertyValue('font');
            var fontSizeProp = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'fontSize', $4034906a84e141fe$export$89abf52a030e56ee.parse(ctx.font).fontSize);
            if (fontSizeProp.hasValue()) {
                document1.rootEmSize = fontSizeProp.getPixels('y');
                document1.emSize = document1.rootEmSize;
            }
        } // create new view port
        if (!this.getAttribute('x').hasValue()) this.getAttribute('x', true).setValue(0);
        if (!this.getAttribute('y').hasValue()) this.getAttribute('y', true).setValue(0);
        var { width: width, height: height } = screen.viewPort;
        if (!this.getStyle('width').hasValue()) this.getStyle('width', true).setValue('100%');
        if (!this.getStyle('height').hasValue()) this.getStyle('height', true).setValue('100%');
        if (!this.getStyle('color').hasValue()) this.getStyle('color', true).setValue('black');
        var refXAttr = this.getAttribute('refX');
        var refYAttr = this.getAttribute('refY');
        var viewBoxAttr = this.getAttribute('viewBox');
        var viewBox = viewBoxAttr.hasValue() ? $4034906a84e141fe$export$39f594ce2cc17fac(viewBoxAttr.getString()) : null;
        var clip = !this.root && this.getStyle('overflow').getValue('hidden') !== 'visible';
        var minX = 0;
        var minY = 0;
        var clipX = 0;
        var clipY = 0;
        if (viewBox) {
            minX = viewBox[0];
            minY = viewBox[1];
        }
        if (!this.root) {
            width = this.getStyle('width').getPixels('x');
            height = this.getStyle('height').getPixels('y');
            if (this.type === 'marker') {
                clipX = minX;
                clipY = minY;
                minX = 0;
                minY = 0;
            }
        }
        screen.viewPort.setCurrent(width, height); // Default value of transform-origin is center only for root SVG elements
        // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform-origin
        if (this.node // is not temporary SVGElement
         && (!this.parent || ((_this$node$parentNode = this.node.parentNode) === null || _this$node$parentNode === void 0 ? void 0 : _this$node$parentNode.nodeName) === 'foreignObject') && this.getStyle('transform', false, true).hasValue() && !this.getStyle('transform-origin', false, true).hasValue()) this.getStyle('transform-origin', true, true).setValue('50% 50%');
        super.setContext(ctx);
        ctx.translate(this.getAttribute('x').getPixels('x'), this.getAttribute('y').getPixels('y'));
        if (viewBox) {
            width = viewBox[2];
            height = viewBox[3];
        }
        document1.setViewBox({
            ctx: ctx,
            aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
            width: screen.viewPort.width,
            desiredWidth: width,
            height: screen.viewPort.height,
            desiredHeight: height,
            minX: minX,
            minY: minY,
            refX: refXAttr.getValue(),
            refY: refYAttr.getValue(),
            clip: clip,
            clipX: clipX,
            clipY: clipY
        });
        if (viewBox) {
            screen.viewPort.removeCurrent();
            screen.viewPort.setCurrent(width, height);
        }
    }
    clearContext(ctx) {
        super.clearContext(ctx);
        this.document.screen.viewPort.removeCurrent();
    }
    /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */ resize(width) {
        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
        var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var widthAttr = this.getAttribute('width', true);
        var heightAttr = this.getAttribute('height', true);
        var viewBoxAttr = this.getAttribute('viewBox');
        var styleAttr = this.getAttribute('style');
        var originWidth = widthAttr.getNumber(0);
        var originHeight = heightAttr.getNumber(0);
        if (preserveAspectRatio) {
            if (typeof preserveAspectRatio === 'string') this.getAttribute('preserveAspectRatio', true).setValue(preserveAspectRatio);
            else {
                var preserveAspectRatioAttr = this.getAttribute('preserveAspectRatio');
                if (preserveAspectRatioAttr.hasValue()) preserveAspectRatioAttr.setValue(preserveAspectRatioAttr.getString().replace(/^\s*(\S.*\S)\s*$/, '$1'));
            }
        }
        widthAttr.setValue(width);
        heightAttr.setValue(height);
        if (!viewBoxAttr.hasValue()) viewBoxAttr.setValue("0 0 ".concat(originWidth || width, " ").concat(originHeight || height));
        if (styleAttr.hasValue()) {
            var widthStyle = this.getStyle('width');
            var heightStyle = this.getStyle('height');
            if (widthStyle.hasValue()) widthStyle.setValue("".concat(width, "px"));
            if (heightStyle.hasValue()) heightStyle.setValue("".concat(height, "px"));
        }
    }
}
class $4034906a84e141fe$export$263978a7d84b5a3c extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(){
        super(...arguments);
        this.type = 'rect';
    }
    path(ctx) {
        var x = this.getAttribute('x').getPixels('x');
        var y = this.getAttribute('y').getPixels('y');
        var width = this.getStyle('width', false, true).getPixels('x');
        var height = this.getStyle('height', false, true).getPixels('y');
        var rxAttr = this.getAttribute('rx');
        var ryAttr = this.getAttribute('ry');
        var rx = rxAttr.getPixels('x');
        var ry = ryAttr.getPixels('y');
        if (rxAttr.hasValue() && !ryAttr.hasValue()) ry = rx;
        if (ryAttr.hasValue() && !rxAttr.hasValue()) rx = ry;
        rx = Math.min(rx, width / 2.0);
        ry = Math.min(ry, height / 2.0);
        if (ctx) {
            var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
            ctx.beginPath(); // always start the path so we don't fill prior paths
            if (height > 0 && width > 0) {
                ctx.moveTo(x + rx, y);
                ctx.lineTo(x + width - rx, y);
                ctx.bezierCurveTo(x + width - rx + KAPPA * rx, y, x + width, y + ry - KAPPA * ry, x + width, y + ry);
                ctx.lineTo(x + width, y + height - ry);
                ctx.bezierCurveTo(x + width, y + height - ry + KAPPA * ry, x + width - rx + KAPPA * rx, y + height, x + width - rx, y + height);
                ctx.lineTo(x + rx, y + height);
                ctx.bezierCurveTo(x + rx - KAPPA * rx, y + height, x, y + height - ry + KAPPA * ry, x, y + height - ry);
                ctx.lineTo(x, y + ry);
                ctx.bezierCurveTo(x, y + ry - KAPPA * ry, x + rx - KAPPA * rx, y, x + rx, y);
                ctx.closePath();
            }
        }
        return new $4034906a84e141fe$export$63080c4de6cfc362(x, y, x + width, y + height);
    }
    getMarkers() {
        return null;
    }
}
class $4034906a84e141fe$export$adbac4af9c5f9fe3 extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(){
        super(...arguments);
        this.type = 'circle';
    }
    path(ctx) {
        var cx = this.getAttribute('cx').getPixels('x');
        var cy = this.getAttribute('cy').getPixels('y');
        var r = this.getAttribute('r').getPixels();
        if (ctx && r > 0) {
            ctx.beginPath();
            ctx.arc(cx, cy, r, 0, Math.PI * 2, false);
            ctx.closePath();
        }
        return new $4034906a84e141fe$export$63080c4de6cfc362(cx - r, cy - r, cx + r, cy + r);
    }
    getMarkers() {
        return null;
    }
}
class $4034906a84e141fe$export$44c88df001c2e0c9 extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(){
        super(...arguments);
        this.type = 'ellipse';
    }
    path(ctx) {
        var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
        var rx = this.getAttribute('rx').getPixels('x');
        var ry = this.getAttribute('ry').getPixels('y');
        var cx = this.getAttribute('cx').getPixels('x');
        var cy = this.getAttribute('cy').getPixels('y');
        if (ctx && rx > 0 && ry > 0) {
            ctx.beginPath();
            ctx.moveTo(cx + rx, cy);
            ctx.bezierCurveTo(cx + rx, cy + KAPPA * ry, cx + KAPPA * rx, cy + ry, cx, cy + ry);
            ctx.bezierCurveTo(cx - KAPPA * rx, cy + ry, cx - rx, cy + KAPPA * ry, cx - rx, cy);
            ctx.bezierCurveTo(cx - rx, cy - KAPPA * ry, cx - KAPPA * rx, cy - ry, cx, cy - ry);
            ctx.bezierCurveTo(cx + KAPPA * rx, cy - ry, cx + rx, cy - KAPPA * ry, cx + rx, cy);
            ctx.closePath();
        }
        return new $4034906a84e141fe$export$63080c4de6cfc362(cx - rx, cy - ry, cx + rx, cy + ry);
    }
    getMarkers() {
        return null;
    }
}
class $4034906a84e141fe$export$55e463fa7bcd3469 extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(){
        super(...arguments);
        this.type = 'line';
    }
    getPoints() {
        return [
            new $4034906a84e141fe$export$baf26146a414f24a(this.getAttribute('x1').getPixels('x'), this.getAttribute('y1').getPixels('y')),
            new $4034906a84e141fe$export$baf26146a414f24a(this.getAttribute('x2').getPixels('x'), this.getAttribute('y2').getPixels('y'))
        ];
    }
    path(ctx) {
        var [{ x: x0, y: y0 }, { x: x1, y: y1 }] = this.getPoints();
        if (ctx) {
            ctx.beginPath();
            ctx.moveTo(x0, y0);
            ctx.lineTo(x1, y1);
        }
        return new $4034906a84e141fe$export$63080c4de6cfc362(x0, y0, x1, y1);
    }
    getMarkers() {
        var [p0, p1] = this.getPoints();
        var a = p0.angleTo(p1);
        return [
            [
                p0,
                a
            ],
            [
                p1,
                a
            ]
        ];
    }
}
class $4034906a84e141fe$export$809f53f9291c2b68 extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'polyline';
        this.points = [];
        this.points = $4034906a84e141fe$export$baf26146a414f24a.parsePath(this.getAttribute('points').getString());
    }
    path(ctx) {
        var { points: points } = this;
        var [{ x: x0, y: y0 }] = points;
        var boundingBox = new $4034906a84e141fe$export$63080c4de6cfc362(x0, y0);
        if (ctx) {
            ctx.beginPath();
            ctx.moveTo(x0, y0);
        }
        points.forEach((_ref)=>{
            var { x: x, y: y } = _ref;
            boundingBox.addPoint(x, y);
            if (ctx) ctx.lineTo(x, y);
        });
        return boundingBox;
    }
    getMarkers() {
        var { points: points } = this;
        var lastIndex = points.length - 1;
        var markers = [];
        points.forEach((point, i)=>{
            if (i === lastIndex) return;
            markers.push([
                point,
                point.angleTo(points[i + 1])
            ]);
        });
        if (markers.length > 0) markers.push([
            points[points.length - 1],
            markers[markers.length - 1][1]
        ]);
        return markers;
    }
}
class $4034906a84e141fe$export$d2c42f21e401c1a extends $4034906a84e141fe$export$809f53f9291c2b68 {
    constructor(){
        super(...arguments);
        this.type = 'polygon';
    }
    path(ctx) {
        var boundingBox = super.path(ctx);
        var [{ x: x, y: y }] = this.points;
        if (ctx) {
            ctx.lineTo(x, y);
            ctx.closePath();
        }
        return boundingBox;
    }
}
class $4034906a84e141fe$export$5216db53c3c8c1fb extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'pattern';
    }
    createPattern(ctx, _, parentOpacityProp) {
        var width = this.getStyle('width').getPixels('x', true);
        var height = this.getStyle('height').getPixels('y', true); // render me using a temporary svg element
        var patternSvg = new $4034906a84e141fe$export$1c514248cc7fa12c(this.document, null);
        patternSvg.attributes.viewBox = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
        patternSvg.attributes.width = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'width', "".concat(width, "px"));
        patternSvg.attributes.height = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'height', "".concat(height, "px"));
        patternSvg.attributes.transform = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'transform', this.getAttribute('patternTransform').getValue());
        patternSvg.children = this.children;
        var patternCanvas = this.document.createCanvas(width, height);
        var patternCtx = patternCanvas.getContext('2d');
        var xAttr = this.getAttribute('x');
        var yAttr = this.getAttribute('y');
        if (xAttr.hasValue() && yAttr.hasValue()) patternCtx.translate(xAttr.getPixels('x', true), yAttr.getPixels('y', true));
        if (parentOpacityProp.hasValue()) this.styles['fill-opacity'] = parentOpacityProp;
        else Reflect.deleteProperty(this.styles, 'fill-opacity');
         // render 3x3 grid so when we transform there's no white space on edges
        for(var x = -1; x <= 1; x++)for(var y = -1; y <= 1; y++){
            patternCtx.save();
            patternSvg.attributes.x = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'x', x * patternCanvas.width);
            patternSvg.attributes.y = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'y', y * patternCanvas.height);
            patternSvg.render(patternCtx);
            patternCtx.restore();
        }
        var pattern = ctx.createPattern(patternCanvas, 'repeat');
        return pattern;
    }
}
class $4034906a84e141fe$export$81ddf2cd10cb96db extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'marker';
    }
    render(ctx, point, angle) {
        if (!point) return;
        var { x: x, y: y } = point;
        var orient = this.getAttribute('orient').getString('auto');
        var markerUnits = this.getAttribute('markerUnits').getString('strokeWidth');
        ctx.translate(x, y);
        if (orient === 'auto') ctx.rotate(angle);
        if (markerUnits === 'strokeWidth') ctx.scale(ctx.lineWidth, ctx.lineWidth);
        ctx.save(); // render me using a temporary svg element
        var markerSvg = new $4034906a84e141fe$export$1c514248cc7fa12c(this.document, null);
        markerSvg.type = this.type;
        markerSvg.attributes.viewBox = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'viewBox', this.getAttribute('viewBox').getValue());
        markerSvg.attributes.refX = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'refX', this.getAttribute('refX').getValue());
        markerSvg.attributes.refY = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'refY', this.getAttribute('refY').getValue());
        markerSvg.attributes.width = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'width', this.getAttribute('markerWidth').getValue());
        markerSvg.attributes.height = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'height', this.getAttribute('markerHeight').getValue());
        markerSvg.attributes.overflow = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'overflow', this.getAttribute('overflow').getValue());
        markerSvg.attributes.fill = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'fill', this.getAttribute('fill').getColor('black'));
        markerSvg.attributes.stroke = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'stroke', this.getAttribute('stroke').getValue('none'));
        markerSvg.children = this.children;
        markerSvg.render(ctx);
        ctx.restore();
        if (markerUnits === 'strokeWidth') ctx.scale(1 / ctx.lineWidth, 1 / ctx.lineWidth);
        if (orient === 'auto') ctx.rotate(-angle);
        ctx.translate(-x, -y);
    }
}
class $4034906a84e141fe$export$ebdb3435ac0bd33d extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'defs';
    }
    render() {}
}
class $4034906a84e141fe$export$6266fb18b118dc8f extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(){
        super(...arguments);
        this.type = 'g';
    }
    getBoundingBox(ctx) {
        var boundingBox = new $4034906a84e141fe$export$63080c4de6cfc362();
        this.children.forEach((child)=>{
            boundingBox.addBoundingBox(child.getBoundingBox(ctx));
        });
        return boundingBox;
    }
}
class $4034906a84e141fe$export$a28828aea105bf34 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.attributesToInherit = [
            'gradientUnits'
        ];
        this.stops = [];
        var { stops: stops, children: children } = this;
        children.forEach((child)=>{
            if (child.type === 'stop') stops.push(child);
        });
    }
    getGradientUnits() {
        return this.getAttribute('gradientUnits').getString('objectBoundingBox');
    }
    createGradient(ctx, element, parentOpacityProp) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
        var stopsContainer = this;
        if (this.getHrefAttribute().hasValue()) {
            stopsContainer = this.getHrefAttribute().getDefinition();
            this.inheritStopContainer(stopsContainer);
        }
        var { stops: stops } = stopsContainer;
        var gradient = this.getGradient(ctx, element);
        if (!gradient) return this.addParentOpacity(parentOpacityProp, stops[stops.length - 1].color);
        stops.forEach((stop)=>{
            gradient.addColorStop(stop.offset, this.addParentOpacity(parentOpacityProp, stop.color));
        });
        if (this.getAttribute('gradientTransform').hasValue()) {
            // render as transformed pattern on temporary canvas
            var { document: document1 } = this;
            var { MAX_VIRTUAL_PIXELS: MAX_VIRTUAL_PIXELS, viewPort: viewPort } = document1.screen;
            var [rootView] = viewPort.viewPorts;
            var rect = new $4034906a84e141fe$export$263978a7d84b5a3c(document1, null);
            rect.attributes.x = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'x', -MAX_VIRTUAL_PIXELS / 3.0);
            rect.attributes.y = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'y', -MAX_VIRTUAL_PIXELS / 3.0);
            rect.attributes.width = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'width', MAX_VIRTUAL_PIXELS);
            rect.attributes.height = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'height', MAX_VIRTUAL_PIXELS);
            var group = new $4034906a84e141fe$export$6266fb18b118dc8f(document1, null);
            group.attributes.transform = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'transform', this.getAttribute('gradientTransform').getValue());
            group.children = [
                rect
            ];
            var patternSvg = new $4034906a84e141fe$export$1c514248cc7fa12c(document1, null);
            patternSvg.attributes.x = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'x', 0);
            patternSvg.attributes.y = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'y', 0);
            patternSvg.attributes.width = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'width', rootView.width);
            patternSvg.attributes.height = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'height', rootView.height);
            patternSvg.children = [
                group
            ];
            var patternCanvas = document1.createCanvas(rootView.width, rootView.height);
            var patternCtx = patternCanvas.getContext('2d');
            patternCtx.fillStyle = gradient;
            patternSvg.render(patternCtx);
            return patternCtx.createPattern(patternCanvas, 'no-repeat');
        }
        return gradient;
    }
    inheritStopContainer(stopsContainer) {
        this.attributesToInherit.forEach((attributeToInherit)=>{
            if (!this.getAttribute(attributeToInherit).hasValue() && stopsContainer.getAttribute(attributeToInherit).hasValue()) this.getAttribute(attributeToInherit, true).setValue(stopsContainer.getAttribute(attributeToInherit).getValue());
        });
    }
    addParentOpacity(parentOpacityProp, color) {
        if (parentOpacityProp.hasValue()) {
            var colorProp = new $4034906a84e141fe$export$41b04b3a73e7216d(this.document, 'color', color);
            return colorProp.addOpacity(parentOpacityProp).getColor();
        }
        return color;
    }
}
class $4034906a84e141fe$export$2c94155b281d2a65 extends $4034906a84e141fe$export$a28828aea105bf34 {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'linearGradient';
        this.attributesToInherit.push('x1', 'y1', 'x2', 'y2');
    }
    getGradient(ctx, element) {
        var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
        var boundingBox = isBoundingBoxUnits ? element.getBoundingBox(ctx) : null;
        if (isBoundingBoxUnits && !boundingBox) return null;
        if (!this.getAttribute('x1').hasValue() && !this.getAttribute('y1').hasValue() && !this.getAttribute('x2').hasValue() && !this.getAttribute('y2').hasValue()) {
            this.getAttribute('x1', true).setValue(0);
            this.getAttribute('y1', true).setValue(0);
            this.getAttribute('x2', true).setValue(1);
            this.getAttribute('y2', true).setValue(0);
        }
        var x1 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x1').getNumber() : this.getAttribute('x1').getPixels('x');
        var y1 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y1').getNumber() : this.getAttribute('y1').getPixels('y');
        var x2 = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('x2').getNumber() : this.getAttribute('x2').getPixels('x');
        var y2 = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('y2').getNumber() : this.getAttribute('y2').getPixels('y');
        if (x1 === x2 && y1 === y2) return null;
        return ctx.createLinearGradient(x1, y1, x2, y2);
    }
}
class $4034906a84e141fe$export$c701c9794d8ff39a extends $4034906a84e141fe$export$a28828aea105bf34 {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'radialGradient';
        this.attributesToInherit.push('cx', 'cy', 'r', 'fx', 'fy', 'fr');
    }
    getGradient(ctx, element) {
        var isBoundingBoxUnits = this.getGradientUnits() === 'objectBoundingBox';
        var boundingBox = element.getBoundingBox(ctx);
        if (isBoundingBoxUnits && !boundingBox) return null;
        if (!this.getAttribute('cx').hasValue()) this.getAttribute('cx', true).setValue('50%');
        if (!this.getAttribute('cy').hasValue()) this.getAttribute('cy', true).setValue('50%');
        if (!this.getAttribute('r').hasValue()) this.getAttribute('r', true).setValue('50%');
        var cx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('cx').getNumber() : this.getAttribute('cx').getPixels('x');
        var cy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('cy').getNumber() : this.getAttribute('cy').getPixels('y');
        var fx = cx;
        var fy = cy;
        if (this.getAttribute('fx').hasValue()) fx = isBoundingBoxUnits ? boundingBox.x + boundingBox.width * this.getAttribute('fx').getNumber() : this.getAttribute('fx').getPixels('x');
        if (this.getAttribute('fy').hasValue()) fy = isBoundingBoxUnits ? boundingBox.y + boundingBox.height * this.getAttribute('fy').getNumber() : this.getAttribute('fy').getPixels('y');
        var r = isBoundingBoxUnits ? (boundingBox.width + boundingBox.height) / 2.0 * this.getAttribute('r').getNumber() : this.getAttribute('r').getPixels();
        var fr = this.getAttribute('fr').getPixels();
        return ctx.createRadialGradient(fx, fy, fr, cx, cy, r);
    }
}
class $4034906a84e141fe$export$935706179ceb26b7 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'stop';
        var offset = Math.max(0, Math.min(1, this.getAttribute('offset').getNumber()));
        var stopOpacity = this.getStyle('stop-opacity');
        var stopColor = this.getStyle('stop-color', true);
        if (stopColor.getString() === '') stopColor.setValue('#000');
        if (stopOpacity.hasValue()) stopColor = stopColor.addOpacity(stopOpacity);
        this.offset = offset;
        this.color = stopColor.getColor();
    }
}
class $4034906a84e141fe$export$5ad74a1ea4543e04 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'animate';
        this.duration = 0;
        this.initialValue = null;
        this.initialUnits = '';
        this.removed = false;
        this.frozen = false;
        document1.screen.animations.push(this);
        this.begin = this.getAttribute('begin').getMilliseconds();
        this.maxDuration = this.begin + this.getAttribute('dur').getMilliseconds();
        this.from = this.getAttribute('from');
        this.to = this.getAttribute('to');
        this.values = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'values', null);
        var valuesAttr = this.getAttribute('values');
        if (valuesAttr.hasValue()) this.values.setValue(valuesAttr.getString().split(';'));
    }
    getProperty() {
        var attributeType = this.getAttribute('attributeType').getString();
        var attributeName = this.getAttribute('attributeName').getString();
        if (attributeType === 'CSS') return this.parent.getStyle(attributeName, true);
        return this.parent.getAttribute(attributeName, true);
    }
    calcValue() {
        var { initialUnits: initialUnits } = this;
        var { progress: progress, from: from, to: to } = this.getProgress(); // tween value linearly
        var newValue = from.getNumber() + (to.getNumber() - from.getNumber()) * progress;
        if (initialUnits === '%') newValue *= 100.0; // numValue() returns 0-1 whereas properties are 0-100
        return "".concat(newValue).concat(initialUnits);
    }
    update(delta) {
        var { parent: parent } = this;
        var prop = this.getProperty(); // set initial value
        if (!this.initialValue) {
            this.initialValue = prop.getString();
            this.initialUnits = prop.getUnits();
        } // if we're past the end time
        if (this.duration > this.maxDuration) {
            var fill = this.getAttribute('fill').getString('remove'); // loop for indefinitely repeating animations
            if (this.getAttribute('repeatCount').getString() === 'indefinite' || this.getAttribute('repeatDur').getString() === 'indefinite') this.duration = 0;
            else if (fill === 'freeze' && !this.frozen) {
                this.frozen = true;
                parent.animationFrozen = true;
                parent.animationFrozenValue = prop.getString();
            } else if (fill === 'remove' && !this.removed) {
                this.removed = true;
                prop.setValue(parent.animationFrozen ? parent.animationFrozenValue : this.initialValue);
                return true;
            }
            return false;
        }
        this.duration += delta; // if we're past the begin time
        var updated = false;
        if (this.begin < this.duration) {
            var newValue = this.calcValue(); // tween
            var typeAttr = this.getAttribute('type');
            if (typeAttr.hasValue()) {
                // for transform, etc.
                var type = typeAttr.getString();
                newValue = "".concat(type, "(").concat(newValue, ")");
            }
            prop.setValue(newValue);
            updated = true;
        }
        return updated;
    }
    getProgress() {
        var { document: document1, values: values } = this;
        var result = {
            progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
        };
        if (values.hasValue()) {
            var p = result.progress * (values.getValue().length - 1);
            var lb = Math.floor(p);
            var ub = Math.ceil(p);
            result.from = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'from', parseFloat(values.getValue()[lb]));
            result.to = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'to', parseFloat(values.getValue()[ub]));
            result.progress = (p - lb) / (ub - lb);
        } else {
            result.from = this.from;
            result.to = this.to;
        }
        return result;
    }
}
class $4034906a84e141fe$export$1a8c178571a10fd8 extends $4034906a84e141fe$export$5ad74a1ea4543e04 {
    constructor(){
        super(...arguments);
        this.type = 'animateColor';
    }
    calcValue() {
        var { progress: progress, from: from, to: to } = this.getProgress();
        var colorFrom = new (0, (/*@__PURE__*/$parcel$interopDefault($4VIYO)))(from.getColor());
        var colorTo = new (0, (/*@__PURE__*/$parcel$interopDefault($4VIYO)))(to.getColor());
        if (colorFrom.ok && colorTo.ok) {
            // tween color linearly
            var r = colorFrom.r + (colorTo.r - colorFrom.r) * progress;
            var g = colorFrom.g + (colorTo.g - colorFrom.g) * progress;
            var b = colorFrom.b + (colorTo.b - colorFrom.b) * progress; // ? alpha
            return "rgb(".concat(Math.floor(r), ", ").concat(Math.floor(g), ", ").concat(Math.floor(b), ")");
        }
        return this.getAttribute('from').getColor();
    }
}
class $4034906a84e141fe$export$33212fc20d66cba8 extends $4034906a84e141fe$export$5ad74a1ea4543e04 {
    constructor(){
        super(...arguments);
        this.type = 'animateTransform';
    }
    calcValue() {
        var { progress: progress, from: from, to: to } = this.getProgress(); // tween value linearly
        var transformFrom = $4034906a84e141fe$export$39f594ce2cc17fac(from.getString());
        var transformTo = $4034906a84e141fe$export$39f594ce2cc17fac(to.getString());
        var newValue = transformFrom.map((from, i)=>{
            var to = transformTo[i];
            return from + (to - from) * progress;
        }).join(' ');
        return newValue;
    }
}
class $4034906a84e141fe$export$950f494922cd7f64 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'font';
        this.glyphs = Object.create(null);
        this.horizAdvX = this.getAttribute('horiz-adv-x').getNumber();
        var { definitions: definitions } = document1;
        var { children: children } = this;
        for (var child of children)switch(child.type){
            case 'font-face':
                this.fontFace = child;
                var fontFamilyStyle = child.getStyle('font-family');
                if (fontFamilyStyle.hasValue()) definitions[fontFamilyStyle.getString()] = this;
                break;
            case 'missing-glyph':
                this.missingGlyph = child;
                break;
            case 'glyph':
                var glyph = child;
                if (glyph.arabicForm) {
                    this.isRTL = true;
                    this.isArabic = true;
                    if (typeof this.glyphs[glyph.unicode] === 'undefined') this.glyphs[glyph.unicode] = Object.create(null);
                    this.glyphs[glyph.unicode][glyph.arabicForm] = glyph;
                } else this.glyphs[glyph.unicode] = glyph;
                break;
        }
    }
    render() {}
}
class $4034906a84e141fe$export$4e49cc5aca2dcd2 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'font-face';
        this.ascent = this.getAttribute('ascent').getNumber();
        this.descent = this.getAttribute('descent').getNumber();
        this.unitsPerEm = this.getAttribute('units-per-em').getNumber();
    }
}
class $4034906a84e141fe$export$f7e8c9808bb1f18e extends $4034906a84e141fe$export$c1ed4714510a72ff {
    constructor(){
        super(...arguments);
        this.type = 'missing-glyph';
        this.horizAdvX = 0;
    }
}
class $4034906a84e141fe$export$e3818feda1216434 extends $4034906a84e141fe$export$764077542c4bf9bd {
    constructor(){
        super(...arguments);
        this.type = 'tref';
    }
    getText() {
        var element = this.getHrefAttribute().getDefinition();
        if (element) {
            var firstChild = element.children[0];
            if (firstChild) return firstChild.getText();
        }
        return '';
    }
}
class $4034906a84e141fe$export$750c958a3d844280 extends $4034906a84e141fe$export$764077542c4bf9bd {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'a';
        var { childNodes: childNodes } = node;
        var firstChild = childNodes[0];
        var hasText = childNodes.length > 0 && Array.from(childNodes).every((node)=>node.nodeType === 3);
        this.hasText = hasText;
        this.text = hasText ? this.getTextFromNode(firstChild) : '';
    }
    getText() {
        return this.text;
    }
    renderChildren(ctx) {
        if (this.hasText) {
            // render as text element
            super.renderChildren(ctx);
            var { document: document1, x: x, y: y } = this;
            var { mouse: mouse } = document1.screen;
            var fontSize = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'fontSize', $4034906a84e141fe$export$89abf52a030e56ee.parse(document1.ctx.font).fontSize); // Do not calc bounding box if mouse is not working.
            if (mouse.isWorking()) mouse.checkBoundingBox(this, new $4034906a84e141fe$export$63080c4de6cfc362(x, y - fontSize.getPixels('y'), x + this.measureText(ctx), y));
        } else if (this.children.length > 0) {
            // render as temporary group
            var g = new $4034906a84e141fe$export$6266fb18b118dc8f(this.document, null);
            g.children = this.children;
            g.parent = this;
            g.render(ctx);
        }
    }
    onClick() {
        var { window: window1 } = this.document;
        if (window1) window1.open(this.getHrefAttribute().getString());
    }
    onMouseMove() {
        var ctx = this.document.ctx;
        ctx.canvas.style.cursor = 'pointer';
    }
}
function $4034906a84e141fe$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4034906a84e141fe$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4034906a84e141fe$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4034906a84e141fe$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class $4034906a84e141fe$export$ed2570164d72b374 extends $4034906a84e141fe$export$764077542c4bf9bd {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'textPath';
        this.textWidth = 0;
        this.textHeight = 0;
        this.pathLength = -1;
        this.glyphInfo = null;
        this.letterSpacingCache = [];
        this.measuresCache = new Map([
            [
                '',
                0
            ]
        ]);
        var pathElement = this.getHrefAttribute().getDefinition();
        this.text = this.getTextFromNode();
        this.dataArray = this.parsePathData(pathElement);
    }
    getText() {
        return this.text;
    }
    path(ctx) {
        var { dataArray: dataArray } = this;
        if (ctx) ctx.beginPath();
        dataArray.forEach((_ref)=>{
            var { type: type, points: points } = _ref;
            switch(type){
                case $4034906a84e141fe$export$2c011581dc2d802.LINE_TO:
                    if (ctx) ctx.lineTo(points[0], points[1]);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.MOVE_TO:
                    if (ctx) ctx.moveTo(points[0], points[1]);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.CURVE_TO:
                    if (ctx) ctx.bezierCurveTo(points[0], points[1], points[2], points[3], points[4], points[5]);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.QUAD_TO:
                    if (ctx) ctx.quadraticCurveTo(points[0], points[1], points[2], points[3]);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.ARC:
                    var [cx, cy, rx, ry, theta, dTheta, psi, fs] = points;
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    if (ctx) {
                        ctx.translate(cx, cy);
                        ctx.rotate(psi);
                        ctx.scale(scaleX, scaleY);
                        ctx.arc(0, 0, r, theta, theta + dTheta, Boolean(1 - fs));
                        ctx.scale(1 / scaleX, 1 / scaleY);
                        ctx.rotate(-psi);
                        ctx.translate(-cx, -cy);
                    }
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.CLOSE_PATH:
                    if (ctx) ctx.closePath();
                    break;
            }
        });
    }
    renderChildren(ctx) {
        this.setTextData(ctx);
        ctx.save();
        var textDecoration = this.parent.getStyle('text-decoration').getString();
        var fontSize = this.getFontSize();
        var { glyphInfo: glyphInfo } = this;
        var fill = ctx.fillStyle;
        if (textDecoration === 'underline') ctx.beginPath();
        glyphInfo.forEach((glyph, i)=>{
            var { p0: p0, p1: p1, rotation: rotation, text: partialText } = glyph;
            ctx.save();
            ctx.translate(p0.x, p0.y);
            ctx.rotate(rotation);
            if (ctx.fillStyle) ctx.fillText(partialText, 0, 0);
            if (ctx.strokeStyle) ctx.strokeText(partialText, 0, 0);
            ctx.restore();
            if (textDecoration === 'underline') {
                if (i === 0) ctx.moveTo(p0.x, p0.y + fontSize / 8);
                ctx.lineTo(p1.x, p1.y + fontSize / 5);
            } // // To assist with debugging visually, uncomment following
        //
        // ctx.beginPath();
        // if (i % 2)
        // 	ctx.strokeStyle = 'red';
        // else
        // 	ctx.strokeStyle = 'green';
        // ctx.moveTo(p0.x, p0.y);
        // ctx.lineTo(p1.x, p1.y);
        // ctx.stroke();
        // ctx.closePath();
        });
        if (textDecoration === 'underline') {
            ctx.lineWidth = fontSize / 20;
            ctx.strokeStyle = fill;
            ctx.stroke();
            ctx.closePath();
        }
        ctx.restore();
    }
    getLetterSpacingAt() {
        var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return this.letterSpacingCache[idx] || 0;
    }
    findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, inputOffset, dy, c, charI) {
        var offset = inputOffset;
        var glyphWidth = this.measureText(ctx, c);
        if (c === ' ' && anchor === 'justify' && textFullWidth < fullPathWidth) glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
        if (charI > -1) offset += this.getLetterSpacingAt(charI);
        var splineStep = this.textHeight / 20;
        var p0 = this.getEquidistantPointOnPath(offset, splineStep, 0);
        var p1 = this.getEquidistantPointOnPath(offset + glyphWidth, splineStep, 0);
        var segment = {
            p0: p0,
            p1: p1
        };
        var rotation = p0 && p1 ? Math.atan2(p1.y - p0.y, p1.x - p0.x) : 0;
        if (dy) {
            var dyX = Math.cos(Math.PI / 2 + rotation) * dy;
            var dyY = Math.cos(-rotation) * dy;
            segment.p0 = $4034906a84e141fe$var$_objectSpread$2($4034906a84e141fe$var$_objectSpread$2({}, p0), {}, {
                x: p0.x + dyX,
                y: p0.y + dyY
            });
            segment.p1 = $4034906a84e141fe$var$_objectSpread$2($4034906a84e141fe$var$_objectSpread$2({}, p1), {}, {
                x: p1.x + dyX,
                y: p1.y + dyY
            });
        }
        offset += glyphWidth;
        return {
            offset: offset,
            segment: segment,
            rotation: rotation
        };
    }
    measureText(ctx, text) {
        var { measuresCache: measuresCache } = this;
        var targetText = text || this.getText();
        if (measuresCache.has(targetText)) return measuresCache.get(targetText);
        var measure = this.measureTargetText(ctx, targetText);
        measuresCache.set(targetText, measure);
        return measure;
    }
    // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
    // You need to call this method manually to update glyphs cache.
    setTextData(ctx) {
        if (this.glyphInfo) return;
        var renderText = this.getText();
        var chars = renderText.split('');
        var spacesNumber = renderText.split(' ').length - 1;
        var dx = this.parent.getAttribute('dx').split().map((_)=>_.getPixels('x'));
        var dy = this.parent.getAttribute('dy').getPixels('y');
        var anchor = this.parent.getStyle('text-anchor').getString('start');
        var thisSpacing = this.getStyle('letter-spacing');
        var parentSpacing = this.parent.getStyle('letter-spacing');
        var letterSpacing = 0;
        if (!thisSpacing.hasValue() || thisSpacing.getValue() === 'inherit') letterSpacing = parentSpacing.getPixels();
        else if (thisSpacing.hasValue()) {
            if (thisSpacing.getValue() !== 'initial' && thisSpacing.getValue() !== 'unset') letterSpacing = thisSpacing.getPixels();
        } // fill letter-spacing cache
        var letterSpacingCache = [];
        var textLen = renderText.length;
        this.letterSpacingCache = letterSpacingCache;
        for(var i = 0; i < textLen; i++)letterSpacingCache.push(typeof dx[i] !== 'undefined' ? dx[i] : letterSpacing);
        var dxSum = letterSpacingCache.reduce((acc, cur, i)=>i === 0 ? 0 : acc + cur || 0, 0);
        var textWidth = this.measureText(ctx);
        var textFullWidth = Math.max(textWidth + dxSum, 0);
        this.textWidth = textWidth;
        this.textHeight = this.getFontSize();
        this.glyphInfo = [];
        var fullPathWidth = this.getPathLength();
        var startOffset = this.getStyle('startOffset').getNumber(0) * fullPathWidth;
        var offset = 0;
        if (anchor === 'middle' || anchor === 'center') offset = -textFullWidth / 2;
        if (anchor === 'end' || anchor === 'right') offset = -textFullWidth;
        offset += startOffset;
        chars.forEach((char, i)=>{
            // Find such segment what distance between p0 and p1 is approx. width of glyph
            var { offset: nextOffset, segment: segment, rotation: rotation } = this.findSegmentToFitChar(ctx, anchor, textFullWidth, fullPathWidth, spacesNumber, offset, dy, char, i);
            offset = nextOffset;
            if (!segment.p0 || !segment.p1) return;
             // const width = this.getLineLength(
            // 	segment.p0.x,
            // 	segment.p0.y,
            // 	segment.p1.x,
            // 	segment.p1.y
            // );
            // Note: Since glyphs are rendered one at a time, any kerning pair data built into the font will not be used.
            // Can foresee having a rough pair table built in that the developer can override as needed.
            // Or use "dx" attribute of the <text> node as a naive replacement
            // const kern = 0;
            // placeholder for future implementation
            // const midpoint = this.getPointOnLine(
            // 	kern + width / 2.0,
            // 	segment.p0.x, segment.p0.y, segment.p1.x, segment.p1.y
            // );
            this.glyphInfo.push({
                // transposeX: midpoint.x,
                // transposeY: midpoint.y,
                text: chars[i],
                p0: segment.p0,
                p1: segment.p1,
                rotation: rotation
            });
        });
    }
    parsePathData(path) {
        this.pathLength = -1; // reset path length
        if (!path) return [];
        var pathCommands = [];
        var { pathParser: pathParser } = path;
        pathParser.reset(); // convert l, H, h, V, and v to L
        while(!pathParser.isEnd()){
            var { current: current } = pathParser;
            var startX = current ? current.x : 0;
            var startY = current ? current.y : 0;
            var command = pathParser.next();
            var nextCommandType = command.type;
            var points = [];
            switch(command.type){
                case $4034906a84e141fe$export$2c011581dc2d802.MOVE_TO:
                    this.pathM(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.LINE_TO:
                    nextCommandType = this.pathL(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.HORIZ_LINE_TO:
                    nextCommandType = this.pathH(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.VERT_LINE_TO:
                    nextCommandType = this.pathV(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.CURVE_TO:
                    this.pathC(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.SMOOTH_CURVE_TO:
                    nextCommandType = this.pathS(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.QUAD_TO:
                    this.pathQ(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.SMOOTH_QUAD_TO:
                    nextCommandType = this.pathT(pathParser, points);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.ARC:
                    points = this.pathA(pathParser);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.CLOSE_PATH:
                    $4034906a84e141fe$export$c1ed4714510a72ff.pathZ(pathParser);
                    break;
            }
            if (command.type !== $4034906a84e141fe$export$2c011581dc2d802.CLOSE_PATH) pathCommands.push({
                type: nextCommandType,
                points: points,
                start: {
                    x: startX,
                    y: startY
                },
                pathLength: this.calcLength(startX, startY, nextCommandType, points)
            });
            else pathCommands.push({
                type: $4034906a84e141fe$export$2c011581dc2d802.CLOSE_PATH,
                points: [],
                pathLength: 0
            });
        }
        return pathCommands;
    }
    pathM(pathParser, points) {
        var { x: x, y: y } = $4034906a84e141fe$export$c1ed4714510a72ff.pathM(pathParser).point;
        points.push(x, y);
    }
    pathL(pathParser, points) {
        var { x: x, y: y } = $4034906a84e141fe$export$c1ed4714510a72ff.pathL(pathParser).point;
        points.push(x, y);
        return $4034906a84e141fe$export$2c011581dc2d802.LINE_TO;
    }
    pathH(pathParser, points) {
        var { x: x, y: y } = $4034906a84e141fe$export$c1ed4714510a72ff.pathH(pathParser).point;
        points.push(x, y);
        return $4034906a84e141fe$export$2c011581dc2d802.LINE_TO;
    }
    pathV(pathParser, points) {
        var { x: x, y: y } = $4034906a84e141fe$export$c1ed4714510a72ff.pathV(pathParser).point;
        points.push(x, y);
        return $4034906a84e141fe$export$2c011581dc2d802.LINE_TO;
    }
    pathC(pathParser, points) {
        var { point: point, controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathC(pathParser);
        points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
    pathS(pathParser, points) {
        var { point: point, controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathS(pathParser);
        points.push(point.x, point.y, controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        return $4034906a84e141fe$export$2c011581dc2d802.CURVE_TO;
    }
    pathQ(pathParser, points) {
        var { controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathQ(pathParser);
        points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
    }
    pathT(pathParser, points) {
        var { controlPoint: controlPoint, currentPoint: currentPoint } = $4034906a84e141fe$export$c1ed4714510a72ff.pathT(pathParser);
        points.push(controlPoint.x, controlPoint.y, currentPoint.x, currentPoint.y);
        return $4034906a84e141fe$export$2c011581dc2d802.QUAD_TO;
    }
    pathA(pathParser) {
        var { rX: rX, rY: rY, sweepFlag: sweepFlag, xAxisRotation: xAxisRotation, centp: centp, a1: a1, ad: ad } = $4034906a84e141fe$export$c1ed4714510a72ff.pathA(pathParser);
        if (sweepFlag === 0 && ad > 0) ad -= 2 * Math.PI;
        if (sweepFlag === 1 && ad < 0) ad += 2 * Math.PI;
        return [
            centp.x,
            centp.y,
            rX,
            rY,
            a1,
            ad,
            xAxisRotation,
            sweepFlag
        ];
    }
    calcLength(x, y, commandType, points) {
        var len = 0;
        var p1 = null;
        var p2 = null;
        var t = 0;
        switch(commandType){
            case $4034906a84e141fe$export$2c011581dc2d802.LINE_TO:
                return this.getLineLength(x, y, points[0], points[1]);
            case $4034906a84e141fe$export$2c011581dc2d802.CURVE_TO:
                // Approximates by breaking curve into 100 line segments
                len = 0.0;
                p1 = this.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = this.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case $4034906a84e141fe$export$2c011581dc2d802.QUAD_TO:
                // Approximates by breaking curve into 100 line segments
                len = 0.0;
                p1 = this.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                for(t = 0.01; t <= 1; t += 0.01){
                    p2 = this.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case $4034906a84e141fe$export$2c011581dc2d802.ARC:
                // Approximates by breaking curve into line segments
                len = 0.0;
                var start = points[4]; // 4 = theta
                var dTheta = points[5]; // 5 = dTheta
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0; // 1 degree resolution
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                 // Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi
                p1 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) // clockwise
                for(t = start - inc; t > end; t -= inc){
                    p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else // counter-clockwise
                for(t = start + inc; t < end; t += inc){
                    p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = this.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += this.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    getPointOnLine(dist, p1x, p1y, p2x, p2y) {
        var fromX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : p1x;
        var fromY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : p1y;
        var m = (p2y - p1y) / (p2x - p1x + $4034906a84e141fe$export$8aefd221e087d814);
        var run = Math.sqrt(dist * dist / (1 + m * m));
        if (p2x < p1x) run *= -1;
        var rise = m * run;
        var pt = null;
        if (p2x === p1x) // vertical line
        pt = {
            x: fromX,
            y: fromY + rise
        };
        else if ((fromY - p1y) / (fromX - p1x + $4034906a84e141fe$export$8aefd221e087d814) === m) pt = {
            x: fromX + run,
            y: fromY + rise
        };
        else {
            var ix = 0;
            var iy = 0;
            var len = this.getLineLength(p1x, p1y, p2x, p2y);
            if (len < $4034906a84e141fe$export$8aefd221e087d814) return null;
            var u = (fromX - p1x) * (p2x - p1x) + (fromY - p1y) * (p2y - p1y);
            u /= len * len;
            ix = p1x + u * (p2x - p1x);
            iy = p1y + u * (p2y - p1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt(pRun * pRun / (1 + m * m));
            if (p2x < p1x) run *= -1;
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    }
    getPointOnPath(distance) {
        var fullLen = this.getPathLength();
        var cumulativePathLength = 0;
        var p = null;
        if (distance < -0.00005 || distance - 0.00005 > fullLen) return null;
        var { dataArray: dataArray } = this;
        for (var command of dataArray){
            if (command && (command.pathLength < 0.00005 || cumulativePathLength + command.pathLength + 0.00005 < distance)) {
                cumulativePathLength += command.pathLength;
                continue;
            }
            var delta = distance - cumulativePathLength;
            var currentT = 0;
            switch(command.type){
                case $4034906a84e141fe$export$2c011581dc2d802.LINE_TO:
                    p = this.getPointOnLine(delta, command.start.x, command.start.y, command.points[0], command.points[1], command.start.x, command.start.y);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.ARC:
                    var start = command.points[4]; // 4 = theta
                    var dTheta = command.points[5]; // 5 = dTheta
                    var end = command.points[4] + dTheta;
                    currentT = start + delta / command.pathLength * dTheta;
                    if (dTheta < 0 && currentT < end || dTheta >= 0 && currentT > end) break;
                    p = this.getPointOnEllipticalArc(command.points[0], command.points[1], command.points[2], command.points[3], currentT, command.points[6]);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.CURVE_TO:
                    currentT = delta / command.pathLength;
                    if (currentT > 1) currentT = 1;
                    p = this.getPointOnCubicBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3], command.points[4], command.points[5]);
                    break;
                case $4034906a84e141fe$export$2c011581dc2d802.QUAD_TO:
                    currentT = delta / command.pathLength;
                    if (currentT > 1) currentT = 1;
                    p = this.getPointOnQuadraticBezier(currentT, command.start.x, command.start.y, command.points[0], command.points[1], command.points[2], command.points[3]);
                    break;
            }
            if (p) return p;
            break;
        }
        return null;
    }
    getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    getPathLength() {
        if (this.pathLength === -1) this.pathLength = this.dataArray.reduce((length, command)=>command.pathLength > 0 ? length + command.pathLength : length, 0);
        return this.pathLength;
    }
    getPointOnCubicBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
        var x = p4x * $4034906a84e141fe$export$9e530b7c1b7c1200(pct) + p3x * $4034906a84e141fe$export$eaadfcb9a27922af(pct) + p2x * $4034906a84e141fe$export$7e5f271a1479ae46(pct) + p1x * $4034906a84e141fe$export$60426d27d140e174(pct);
        var y = p4y * $4034906a84e141fe$export$9e530b7c1b7c1200(pct) + p3y * $4034906a84e141fe$export$eaadfcb9a27922af(pct) + p2y * $4034906a84e141fe$export$7e5f271a1479ae46(pct) + p1y * $4034906a84e141fe$export$60426d27d140e174(pct);
        return {
            x: x,
            y: y
        };
    }
    getPointOnQuadraticBezier(pct, p1x, p1y, p2x, p2y, p3x, p3y) {
        var x = p3x * $4034906a84e141fe$export$1d72cc358c390964(pct) + p2x * $4034906a84e141fe$export$e0e2e9099da349e2(pct) + p1x * $4034906a84e141fe$export$6a0be4a5e8765c00(pct);
        var y = p3y * $4034906a84e141fe$export$1d72cc358c390964(pct) + p2y * $4034906a84e141fe$export$e0e2e9099da349e2(pct) + p1y * $4034906a84e141fe$export$6a0be4a5e8765c00(pct);
        return {
            x: x,
            y: y
        };
    }
    getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi);
        var sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    buildEquidistantCache(inputStep, inputPrecision) {
        var fullLen = this.getPathLength();
        var precision = inputPrecision || 0.25; // accuracy vs performance
        var step = inputStep || fullLen / 100;
        if (!this.equidistantCache || this.equidistantCache.step !== step || this.equidistantCache.precision !== precision) {
            // Prepare cache
            this.equidistantCache = {
                step: step,
                precision: precision,
                points: []
            }; // Calculate points
            var s = 0;
            for(var l = 0; l <= fullLen; l += precision){
                var p0 = this.getPointOnPath(l);
                var p1 = this.getPointOnPath(l + precision);
                if (!p0 || !p1) continue;
                s += this.getLineLength(p0.x, p0.y, p1.x, p1.y);
                if (s >= step) {
                    this.equidistantCache.points.push({
                        x: p0.x,
                        y: p0.y,
                        distance: l
                    });
                    s -= step;
                }
            }
        }
    }
    getEquidistantPointOnPath(targetDistance, step, precision) {
        this.buildEquidistantCache(step, precision);
        if (targetDistance < 0 || targetDistance - this.getPathLength() > 0.00005) return null;
        var idx = Math.round(targetDistance / this.getPathLength() * (this.equidistantCache.points.length - 1));
        return this.equidistantCache.points[idx] || null;
    }
}
var $4034906a84e141fe$var$dataUriRegex = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class $4034906a84e141fe$export$c78ad754952d364a extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'image';
        this.loaded = false;
        var href = this.getHrefAttribute().getString();
        if (!href) return;
        var isSvg = href.endsWith('.svg') || /^\s*data:image\/svg\+xml/i.test(href);
        document1.images.push(this);
        if (!isSvg) this.loadImage(href);
        else this.loadSvg(href);
        this.isSvg = isSvg;
    }
    loadImage(href) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            try {
                var image = yield _this.document.createImage(href);
                _this.image = image;
            } catch (err) {
                console.error("Error while loading image \"".concat(href, "\":"), err);
            }
            _this.loaded = true;
        })();
    }
    loadSvg(href) {
        var _this2 = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            var match = $4034906a84e141fe$var$dataUriRegex.exec(href);
            if (match) {
                var data = match[5];
                if (match[4] === 'base64') _this2.image = atob(data);
                else _this2.image = decodeURIComponent(data);
            } else try {
                var response = yield _this2.document.fetch(href);
                var svg = yield response.text();
                _this2.image = svg;
            } catch (err) {
                console.error("Error while loading image \"".concat(href, "\":"), err);
            }
            _this2.loaded = true;
        })();
    }
    renderChildren(ctx) {
        var { document: document1, image: image, loaded: loaded } = this;
        var x = this.getAttribute('x').getPixels('x');
        var y = this.getAttribute('y').getPixels('y');
        var width = this.getStyle('width').getPixels('x');
        var height = this.getStyle('height').getPixels('y');
        if (!loaded || !image || !width || !height) return;
        ctx.save();
        ctx.translate(x, y);
        if (this.isSvg) {
            var subDocument = document1.canvg.forkString(ctx, this.image, {
                ignoreMouse: true,
                ignoreAnimation: true,
                ignoreDimensions: true,
                ignoreClear: true,
                offsetX: 0,
                offsetY: 0,
                scaleWidth: width,
                scaleHeight: height
            });
            subDocument.document.documentElement.parent = this;
            subDocument.render();
        } else {
            var _image = this.image;
            document1.setViewBox({
                ctx: ctx,
                aspectRatio: this.getAttribute('preserveAspectRatio').getString(),
                width: width,
                desiredWidth: _image.width,
                height: height,
                desiredHeight: _image.height
            });
            if (this.loaded) {
                if (typeof _image.complete === 'undefined' || _image.complete) ctx.drawImage(_image, 0, 0);
            }
        }
        ctx.restore();
    }
    getBoundingBox() {
        var x = this.getAttribute('x').getPixels('x');
        var y = this.getAttribute('y').getPixels('y');
        var width = this.getStyle('width').getPixels('x');
        var height = this.getStyle('height').getPixels('y');
        return new $4034906a84e141fe$export$63080c4de6cfc362(x, y, x + width, y + height);
    }
}
class $4034906a84e141fe$export$cf2a8e13e8b6e2d6 extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(){
        super(...arguments);
        this.type = 'symbol';
    }
    render(_) {}
}
class $4034906a84e141fe$export$9d6567569ea197f5 {
    constructor(document1){
        this.document = document1;
        this.loaded = false;
        document1.fonts.push(this);
    }
    load(fontFamily, url) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            try {
                var { document: document1 } = _this;
                var svgDocument = yield document1.canvg.parser.load(url);
                var fonts = svgDocument.getElementsByTagName('font');
                Array.from(fonts).forEach((fontNode)=>{
                    var font = document1.createElement(fontNode);
                    document1.definitions[fontFamily] = font;
                });
            } catch (err) {
                console.error("Error while loading font \"".concat(url, "\":"), err);
            }
            _this.loaded = true;
        })();
    }
}
class $4034906a84e141fe$export$921cd41ee3a8205e extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'style';
        var css = $4034906a84e141fe$export$807f8f89b800558c(Array.from(node.childNodes) // NEED TEST
        .map((_)=>_.textContent).join('').replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, '') // remove comments
        .replace(/@import.*;/g, '') // remove imports
        );
        var cssDefs = css.split('}');
        cssDefs.forEach((_)=>{
            var def = _.trim();
            if (!def) return;
            var cssParts = def.split('{');
            var cssClasses = cssParts[0].split(',');
            var cssProps = cssParts[1].split(';');
            cssClasses.forEach((_)=>{
                var cssClass = _.trim();
                if (!cssClass) return;
                var props = document1.styles[cssClass] || {};
                cssProps.forEach((cssProp)=>{
                    var prop = cssProp.indexOf(':');
                    var name = cssProp.substr(0, prop).trim();
                    var value = cssProp.substr(prop + 1, cssProp.length - prop).trim();
                    if (name && value) props[name] = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, name, value);
                });
                document1.styles[cssClass] = props;
                document1.stylesSpecificity[cssClass] = $4034906a84e141fe$export$df1c50e5e34679bb(cssClass);
                if (cssClass === '@font-face') {
                    //  && !nodeEnv
                    var fontFamily = props['font-family'].getString().replace(/"|'/g, '');
                    var srcs = props.src.getString().split(',');
                    srcs.forEach((src)=>{
                        if (src.indexOf('format("svg")') > 0) {
                            var url = $4034906a84e141fe$export$3255a1f681144687(src);
                            if (url) new $4034906a84e141fe$export$9d6567569ea197f5(document1).load(fontFamily, url);
                        }
                    });
                }
            });
        });
    }
}
$4034906a84e141fe$export$921cd41ee3a8205e.parseExternalUrl = $4034906a84e141fe$export$3255a1f681144687;
class $4034906a84e141fe$export$5cc2b6e34b733075 extends $4034906a84e141fe$export$66cca51e2e9c1a33 {
    constructor(){
        super(...arguments);
        this.type = 'use';
    }
    setContext(ctx) {
        super.setContext(ctx);
        var xAttr = this.getAttribute('x');
        var yAttr = this.getAttribute('y');
        if (xAttr.hasValue()) ctx.translate(xAttr.getPixels('x'), 0);
        if (yAttr.hasValue()) ctx.translate(0, yAttr.getPixels('y'));
    }
    path(ctx) {
        var { element: element } = this;
        if (element) element.path(ctx);
    }
    renderChildren(ctx) {
        var { document: document1, element: element } = this;
        if (element) {
            var tempSvg = element;
            if (element.type === 'symbol') {
                // render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
                tempSvg = new $4034906a84e141fe$export$1c514248cc7fa12c(document1, null);
                tempSvg.attributes.viewBox = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'viewBox', element.getAttribute('viewBox').getString());
                tempSvg.attributes.preserveAspectRatio = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'preserveAspectRatio', element.getAttribute('preserveAspectRatio').getString());
                tempSvg.attributes.overflow = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'overflow', element.getAttribute('overflow').getString());
                tempSvg.children = element.children; // element is still the parent of the children
                element.styles.opacity = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'opacity', this.calculateOpacity());
            }
            if (tempSvg.type === 'svg') {
                var widthStyle = this.getStyle('width', false, true);
                var heightStyle = this.getStyle('height', false, true); // if symbol or svg, inherit width/height from me
                if (widthStyle.hasValue()) tempSvg.attributes.width = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'width', widthStyle.getString());
                if (heightStyle.hasValue()) tempSvg.attributes.height = new $4034906a84e141fe$export$41b04b3a73e7216d(document1, 'height', heightStyle.getString());
            }
            var oldParent = tempSvg.parent;
            tempSvg.parent = this;
            tempSvg.render(ctx);
            tempSvg.parent = oldParent;
        }
    }
    getBoundingBox(ctx) {
        var { element: element } = this;
        if (element) return element.getBoundingBox(ctx);
        return null;
    }
    elementTransform() {
        var { document: document1, element: element } = this;
        return $4034906a84e141fe$export$563a914cafbdc389.fromElement(document1, element);
    }
    get element() {
        if (!this.cachedElement) this.cachedElement = this.getHrefAttribute().getDefinition();
        return this.cachedElement;
    }
}
function $4034906a84e141fe$var$imGet(img, x, y, width, _height, rgba) {
    return img[y * width * 4 + x * 4 + rgba];
}
function $4034906a84e141fe$var$imSet(img, x, y, width, _height, rgba, val) {
    img[y * width * 4 + x * 4 + rgba] = val;
}
function $4034906a84e141fe$var$m(matrix, i, v) {
    var mi = matrix[i];
    return mi * v;
}
function $4034906a84e141fe$var$c(a, m1, m2, m3) {
    return m1 + Math.cos(a) * m2 + Math.sin(a) * m3;
}
class $4034906a84e141fe$export$9ef846fb34710785 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'feColorMatrix';
        var matrix = $4034906a84e141fe$export$39f594ce2cc17fac(this.getAttribute('values').getString());
        switch(this.getAttribute('type').getString('matrix')){
            // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
            case 'saturate':
                var s = matrix[0];
                /* eslint-disable array-element-newline */ matrix = [
                    0.213 + 0.787 * s,
                    0.715 - 0.715 * s,
                    0.072 - 0.072 * s,
                    0,
                    0,
                    0.213 - 0.213 * s,
                    0.715 + 0.285 * s,
                    0.072 - 0.072 * s,
                    0,
                    0,
                    0.213 - 0.213 * s,
                    0.715 - 0.715 * s,
                    0.072 + 0.928 * s,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ];
                break;
            case 'hueRotate':
                var a = matrix[0] * Math.PI / 180.0;
                /* eslint-disable array-element-newline */ matrix = [
                    $4034906a84e141fe$var$c(a, 0.213, 0.787, -0.213),
                    $4034906a84e141fe$var$c(a, 0.715, -0.715, -0.715),
                    $4034906a84e141fe$var$c(a, 0.072, -0.072, 0.928),
                    0,
                    0,
                    $4034906a84e141fe$var$c(a, 0.213, -0.213, 0.143),
                    $4034906a84e141fe$var$c(a, 0.715, 0.285, 0.140),
                    $4034906a84e141fe$var$c(a, 0.072, -0.072, -0.283),
                    0,
                    0,
                    $4034906a84e141fe$var$c(a, 0.213, -0.213, -0.787),
                    $4034906a84e141fe$var$c(a, 0.715, -0.715, 0.715),
                    $4034906a84e141fe$var$c(a, 0.072, 0.928, 0.072),
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ];
                break;
            case 'luminanceToAlpha':
                /* eslint-disable array-element-newline */ matrix = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0.2125,
                    0.7154,
                    0.0721,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ];
                break;
        }
        this.matrix = matrix;
        this.includeOpacity = this.getAttribute('includeOpacity').hasValue();
    }
    apply(ctx, _x, _y, width, height) {
        // assuming x==0 && y==0 for now
        var { includeOpacity: includeOpacity, matrix: matrix } = this;
        var srcData = ctx.getImageData(0, 0, width, height);
        for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
            var r = $4034906a84e141fe$var$imGet(srcData.data, x, y, width, height, 0);
            var g = $4034906a84e141fe$var$imGet(srcData.data, x, y, width, height, 1);
            var b = $4034906a84e141fe$var$imGet(srcData.data, x, y, width, height, 2);
            var a = $4034906a84e141fe$var$imGet(srcData.data, x, y, width, height, 3);
            var nr = $4034906a84e141fe$var$m(matrix, 0, r) + $4034906a84e141fe$var$m(matrix, 1, g) + $4034906a84e141fe$var$m(matrix, 2, b) + $4034906a84e141fe$var$m(matrix, 3, a) + $4034906a84e141fe$var$m(matrix, 4, 1);
            var ng = $4034906a84e141fe$var$m(matrix, 5, r) + $4034906a84e141fe$var$m(matrix, 6, g) + $4034906a84e141fe$var$m(matrix, 7, b) + $4034906a84e141fe$var$m(matrix, 8, a) + $4034906a84e141fe$var$m(matrix, 9, 1);
            var nb = $4034906a84e141fe$var$m(matrix, 10, r) + $4034906a84e141fe$var$m(matrix, 11, g) + $4034906a84e141fe$var$m(matrix, 12, b) + $4034906a84e141fe$var$m(matrix, 13, a) + $4034906a84e141fe$var$m(matrix, 14, 1);
            var na = $4034906a84e141fe$var$m(matrix, 15, r) + $4034906a84e141fe$var$m(matrix, 16, g) + $4034906a84e141fe$var$m(matrix, 17, b) + $4034906a84e141fe$var$m(matrix, 18, a) + $4034906a84e141fe$var$m(matrix, 19, 1);
            if (includeOpacity) {
                nr = 0;
                ng = 0;
                nb = 0;
                na *= a / 255;
            }
            $4034906a84e141fe$var$imSet(srcData.data, x, y, width, height, 0, nr);
            $4034906a84e141fe$var$imSet(srcData.data, x, y, width, height, 1, ng);
            $4034906a84e141fe$var$imSet(srcData.data, x, y, width, height, 2, nb);
            $4034906a84e141fe$var$imSet(srcData.data, x, y, width, height, 3, na);
        }
        ctx.clearRect(0, 0, width, height);
        ctx.putImageData(srcData, 0, 0);
    }
}
class $4034906a84e141fe$export$9b061fea64b209bc extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'mask';
    }
    apply(ctx, element) {
        var { document: document1 } = this; // render as temp svg
        var x = this.getAttribute('x').getPixels('x');
        var y = this.getAttribute('y').getPixels('y');
        var width = this.getStyle('width').getPixels('x');
        var height = this.getStyle('height').getPixels('y');
        if (!width && !height) {
            var boundingBox = new $4034906a84e141fe$export$63080c4de6cfc362();
            this.children.forEach((child)=>{
                boundingBox.addBoundingBox(child.getBoundingBox(ctx));
            });
            x = Math.floor(boundingBox.x1);
            y = Math.floor(boundingBox.y1);
            width = Math.floor(boundingBox.width);
            height = Math.floor(boundingBox.height);
        }
        var ignoredStyles = this.removeStyles(element, $4034906a84e141fe$export$9b061fea64b209bc.ignoreStyles);
        var maskCanvas = document1.createCanvas(x + width, y + height);
        var maskCtx = maskCanvas.getContext('2d');
        document1.screen.setDefaults(maskCtx);
        this.renderChildren(maskCtx); // convert mask to alpha with a fake node
        // TODO: refactor out apply from feColorMatrix
        new $4034906a84e141fe$export$9ef846fb34710785(document1, {
            nodeType: 1,
            childNodes: [],
            attributes: [
                {
                    nodeName: 'type',
                    value: 'luminanceToAlpha'
                },
                {
                    nodeName: 'includeOpacity',
                    value: 'true'
                }
            ]
        }).apply(maskCtx, 0, 0, x + width, y + height);
        var tmpCanvas = document1.createCanvas(x + width, y + height);
        var tmpCtx = tmpCanvas.getContext('2d');
        document1.screen.setDefaults(tmpCtx);
        element.render(tmpCtx);
        tmpCtx.globalCompositeOperation = 'destination-in';
        tmpCtx.fillStyle = maskCtx.createPattern(maskCanvas, 'no-repeat');
        tmpCtx.fillRect(0, 0, x + width, y + height);
        ctx.fillStyle = tmpCtx.createPattern(tmpCanvas, 'no-repeat');
        ctx.fillRect(0, 0, x + width, y + height); // reassign mask
        this.restoreStyles(element, ignoredStyles);
    }
    render(_) {}
}
$4034906a84e141fe$export$9b061fea64b209bc.ignoreStyles = [
    'mask',
    'transform',
    'clip-path'
];
var $4034906a84e141fe$var$noop = ()=>{};
class $4034906a84e141fe$export$7080ac466fc109c8 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'clipPath';
    }
    apply(ctx) {
        var { document: document1 } = this;
        var contextProto = Reflect.getPrototypeOf(ctx);
        var { beginPath: beginPath, closePath: closePath } = ctx;
        if (contextProto) {
            contextProto.beginPath = $4034906a84e141fe$var$noop;
            contextProto.closePath = $4034906a84e141fe$var$noop;
        }
        Reflect.apply(beginPath, ctx, []);
        this.children.forEach((child)=>{
            if (typeof child.path === 'undefined') return;
            var transform = typeof child.elementTransform !== 'undefined' ? child.elementTransform() : null; // handle <use />
            if (!transform) transform = $4034906a84e141fe$export$563a914cafbdc389.fromElement(document1, child);
            if (transform) transform.apply(ctx);
            child.path(ctx);
            if (contextProto) contextProto.closePath = closePath;
            if (transform) transform.unapply(ctx);
        });
        Reflect.apply(closePath, ctx, []);
        ctx.clip();
        if (contextProto) {
            contextProto.beginPath = beginPath;
            contextProto.closePath = closePath;
        }
    }
    render(_) {}
}
class $4034906a84e141fe$export$8b8c5dbc2df0a942 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'filter';
    }
    apply(ctx, element) {
        // render as temp svg
        var { document: document1, children: children } = this;
        var boundingBox = element.getBoundingBox(ctx);
        if (!boundingBox) return;
        var px = 0;
        var py = 0;
        children.forEach((child)=>{
            var efd = child.extraFilterDistance || 0;
            px = Math.max(px, efd);
            py = Math.max(py, efd);
        });
        var width = Math.floor(boundingBox.width);
        var height = Math.floor(boundingBox.height);
        var tmpCanvasWidth = width + 2 * px;
        var tmpCanvasHeight = height + 2 * py;
        if (tmpCanvasWidth < 1 || tmpCanvasHeight < 1) return;
        var x = Math.floor(boundingBox.x);
        var y = Math.floor(boundingBox.y);
        var ignoredStyles = this.removeStyles(element, $4034906a84e141fe$export$8b8c5dbc2df0a942.ignoreStyles);
        var tmpCanvas = document1.createCanvas(tmpCanvasWidth, tmpCanvasHeight);
        var tmpCtx = tmpCanvas.getContext('2d');
        document1.screen.setDefaults(tmpCtx);
        tmpCtx.translate(-x + px, -y + py);
        element.render(tmpCtx); // apply filters
        children.forEach((child)=>{
            if (typeof child.apply === 'function') child.apply(tmpCtx, 0, 0, tmpCanvasWidth, tmpCanvasHeight);
        }); // render on me
        ctx.drawImage(tmpCanvas, 0, 0, tmpCanvasWidth, tmpCanvasHeight, x - px, y - py, tmpCanvasWidth, tmpCanvasHeight);
        this.restoreStyles(element, ignoredStyles);
    }
    render(_) {}
}
$4034906a84e141fe$export$8b8c5dbc2df0a942.ignoreStyles = [
    'filter',
    'transform',
    'clip-path'
];
class $4034906a84e141fe$export$b2c131cc4f80c8c6 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'feDropShadow';
        this.addStylesFromStyleDefinition();
    }
    apply(_, _x, _y, _width, _height) {}
}
class $4034906a84e141fe$export$6bc5f062490f15a6 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'feMorphology';
    }
    apply(_, _x, _y, _width, _height) {}
}
class $4034906a84e141fe$export$e739314f59309bc7 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'feComposite';
    }
    apply(_, _x, _y, _width, _height) {}
}
class $4034906a84e141fe$export$3b1b99bc1cbb9f0 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(document1, node, captureTextNodes){
        super(document1, node, captureTextNodes);
        this.type = 'feGaussianBlur';
        this.blurRadius = Math.floor(this.getAttribute('stdDeviation').getNumber());
        this.extraFilterDistance = this.blurRadius;
    }
    apply(ctx, x, y, width, height) {
        var { document: document1, blurRadius: blurRadius } = this;
        var body = document1.window ? document1.window.document.body : null;
        var canvas = ctx.canvas; // StackBlur requires canvas be on document
        canvas.id = document1.getUniqueId();
        if (body) {
            canvas.style.display = 'none';
            body.appendChild(canvas);
        }
        (0, $dKQCx.canvasRGBA)(canvas, x, y, width, height, blurRadius);
        if (body) body.removeChild(canvas);
    }
}
class $4034906a84e141fe$export$56726d258a7004ee extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'title';
    }
}
class $4034906a84e141fe$export$e5e7007b6c523b20 extends $4034906a84e141fe$export$db77ccec0bb4ccac {
    constructor(){
        super(...arguments);
        this.type = 'desc';
    }
}
var $4034906a84e141fe$var$elements = {
    'svg': $4034906a84e141fe$export$1c514248cc7fa12c,
    'rect': $4034906a84e141fe$export$263978a7d84b5a3c,
    'circle': $4034906a84e141fe$export$adbac4af9c5f9fe3,
    'ellipse': $4034906a84e141fe$export$44c88df001c2e0c9,
    'line': $4034906a84e141fe$export$55e463fa7bcd3469,
    'polyline': $4034906a84e141fe$export$809f53f9291c2b68,
    'polygon': $4034906a84e141fe$export$d2c42f21e401c1a,
    'path': $4034906a84e141fe$export$c1ed4714510a72ff,
    'pattern': $4034906a84e141fe$export$5216db53c3c8c1fb,
    'marker': $4034906a84e141fe$export$81ddf2cd10cb96db,
    'defs': $4034906a84e141fe$export$ebdb3435ac0bd33d,
    'linearGradient': $4034906a84e141fe$export$2c94155b281d2a65,
    'radialGradient': $4034906a84e141fe$export$c701c9794d8ff39a,
    'stop': $4034906a84e141fe$export$935706179ceb26b7,
    'animate': $4034906a84e141fe$export$5ad74a1ea4543e04,
    'animateColor': $4034906a84e141fe$export$1a8c178571a10fd8,
    'animateTransform': $4034906a84e141fe$export$33212fc20d66cba8,
    'font': $4034906a84e141fe$export$950f494922cd7f64,
    'font-face': $4034906a84e141fe$export$4e49cc5aca2dcd2,
    'missing-glyph': $4034906a84e141fe$export$f7e8c9808bb1f18e,
    'glyph': $4034906a84e141fe$export$9f86a6657dbbe872,
    'text': $4034906a84e141fe$export$764077542c4bf9bd,
    'tspan': $4034906a84e141fe$export$c433ff877cb33f94,
    'tref': $4034906a84e141fe$export$e3818feda1216434,
    'a': $4034906a84e141fe$export$750c958a3d844280,
    'textPath': $4034906a84e141fe$export$ed2570164d72b374,
    'image': $4034906a84e141fe$export$c78ad754952d364a,
    'g': $4034906a84e141fe$export$6266fb18b118dc8f,
    'symbol': $4034906a84e141fe$export$cf2a8e13e8b6e2d6,
    'style': $4034906a84e141fe$export$921cd41ee3a8205e,
    'use': $4034906a84e141fe$export$5cc2b6e34b733075,
    'mask': $4034906a84e141fe$export$9b061fea64b209bc,
    'clipPath': $4034906a84e141fe$export$7080ac466fc109c8,
    'filter': $4034906a84e141fe$export$8b8c5dbc2df0a942,
    'feDropShadow': $4034906a84e141fe$export$b2c131cc4f80c8c6,
    'feMorphology': $4034906a84e141fe$export$6bc5f062490f15a6,
    'feComposite': $4034906a84e141fe$export$e739314f59309bc7,
    'feColorMatrix': $4034906a84e141fe$export$9ef846fb34710785,
    'feGaussianBlur': $4034906a84e141fe$export$3b1b99bc1cbb9f0,
    'title': $4034906a84e141fe$export$56726d258a7004ee,
    'desc': $4034906a84e141fe$export$e5e7007b6c523b20
};
function $4034906a84e141fe$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4034906a84e141fe$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4034906a84e141fe$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4034906a84e141fe$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4034906a84e141fe$var$createCanvas(width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
}
function $4034906a84e141fe$var$createImage(_x) {
    return $4034906a84e141fe$var$_createImage.apply(this, arguments);
}
function $4034906a84e141fe$var$_createImage() {
    $4034906a84e141fe$var$_createImage = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*(src) {
        var anonymousCrossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var image = document.createElement('img');
        if (anonymousCrossOrigin) image.crossOrigin = 'Anonymous';
        return new Promise((resolve, reject)=>{
            image.onload = ()=>{
                resolve(image);
            };
            image.onerror = (_event, _source, _lineno, _colno, error)=>{
                reject(error);
            };
            image.src = src;
        });
    });
    return $4034906a84e141fe$var$_createImage.apply(this, arguments);
}
class $4034906a84e141fe$export$b34a105447964f9f {
    constructor(canvg){
        var { rootEmSize: rootEmSize = 12, emSize: emSize = 12, createCanvas: createCanvas = $4034906a84e141fe$export$b34a105447964f9f.createCanvas, createImage: createImage = $4034906a84e141fe$export$b34a105447964f9f.createImage, anonymousCrossOrigin: anonymousCrossOrigin } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.canvg = canvg;
        this.definitions = Object.create(null);
        this.styles = Object.create(null);
        this.stylesSpecificity = Object.create(null);
        this.images = [];
        this.fonts = [];
        this.emSizeStack = [];
        this.uniqueId = 0;
        this.screen = canvg.screen;
        this.rootEmSize = rootEmSize;
        this.emSize = emSize;
        this.createCanvas = createCanvas;
        this.createImage = this.bindCreateImage(createImage, anonymousCrossOrigin);
        this.screen.wait(this.isImagesLoaded.bind(this));
        this.screen.wait(this.isFontsLoaded.bind(this));
    }
    bindCreateImage(createImage, anonymousCrossOrigin) {
        if (typeof anonymousCrossOrigin === 'boolean') return (source, forceAnonymousCrossOrigin)=>createImage(source, typeof forceAnonymousCrossOrigin === 'boolean' ? forceAnonymousCrossOrigin : anonymousCrossOrigin);
        return createImage;
    }
    get window() {
        return this.screen.window;
    }
    get fetch() {
        return this.screen.fetch;
    }
    get ctx() {
        return this.screen.ctx;
    }
    get emSize() {
        var { emSizeStack: emSizeStack } = this;
        return emSizeStack[emSizeStack.length - 1];
    }
    set emSize(value) {
        var { emSizeStack: emSizeStack } = this;
        emSizeStack.push(value);
    }
    popEmSize() {
        var { emSizeStack: emSizeStack } = this;
        emSizeStack.pop();
    }
    getUniqueId() {
        return "canvg".concat(++this.uniqueId);
    }
    isImagesLoaded() {
        return this.images.every((_)=>_.loaded);
    }
    isFontsLoaded() {
        return this.fonts.every((_)=>_.loaded);
    }
    createDocumentElement(document1) {
        var documentElement = this.createElement(document1.documentElement);
        documentElement.root = true;
        documentElement.addStylesFromStyleDefinition();
        this.documentElement = documentElement;
        return documentElement;
    }
    createElement(node) {
        var elementType = node.nodeName.replace(/^[^:]+:/, '');
        var ElementType = $4034906a84e141fe$export$b34a105447964f9f.elementTypes[elementType];
        if (typeof ElementType !== 'undefined') return new ElementType(this, node);
        return new $4034906a84e141fe$export$868534362d0f7d0f(this, node);
    }
    createTextNode(node) {
        return new $4034906a84e141fe$var$TextNode(this, node);
    }
    setViewBox(config) {
        this.screen.setViewBox($4034906a84e141fe$var$_objectSpread$1({
            document: this
        }, config));
    }
}
$4034906a84e141fe$export$b34a105447964f9f.createCanvas = $4034906a84e141fe$var$createCanvas;
$4034906a84e141fe$export$b34a105447964f9f.createImage = $4034906a84e141fe$var$createImage;
$4034906a84e141fe$export$b34a105447964f9f.elementTypes = $4034906a84e141fe$var$elements;
function $4034906a84e141fe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4034906a84e141fe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4034906a84e141fe$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4034906a84e141fe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * SVG renderer on canvas.
 */ class $4034906a84e141fe$export$c401b789680a0e53 {
    /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */ constructor(ctx, svg){
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.parser = new $4034906a84e141fe$export$7acfa6ed01010e37(options);
        this.screen = new $4034906a84e141fe$export$a98515d67472a41f(ctx, options);
        this.options = options;
        var document1 = new $4034906a84e141fe$export$b34a105447964f9f(this, options);
        var documentElement = document1.createDocumentElement(svg);
        this.document = document1;
        this.documentElement = documentElement;
    }
    /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ static from(ctx, svg) {
        var _arguments = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            var options = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : {};
            var parser = new $4034906a84e141fe$export$7acfa6ed01010e37(options);
            var svgDocument = yield parser.parse(svg);
            return new $4034906a84e141fe$export$c401b789680a0e53(ctx, svgDocument, options);
        })();
    }
    /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ static fromString(ctx, svg) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var parser = new $4034906a84e141fe$export$7acfa6ed01010e37(options);
        var svgDocument = parser.parseFromString(svg);
        return new $4034906a84e141fe$export$c401b789680a0e53(ctx, svgDocument, options);
    }
    /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ fork(ctx, svg) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return $4034906a84e141fe$export$c401b789680a0e53.from(ctx, svg, $4034906a84e141fe$var$_objectSpread($4034906a84e141fe$var$_objectSpread({}, this.options), options));
    }
    /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */ forkString(ctx, svg) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return $4034906a84e141fe$export$c401b789680a0e53.fromString(ctx, svg, $4034906a84e141fe$var$_objectSpread($4034906a84e141fe$var$_objectSpread({}, this.options), options));
    }
    /**
   * Document is ready promise.
   * @returns Ready promise.
   */ ready() {
        return this.screen.ready();
    }
    /**
   * Document is ready value.
   * @returns Is ready or not.
   */ isReady() {
        return this.screen.isReady();
    }
    /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */ render() {
        var _arguments2 = arguments, _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(function*() {
            var options = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
            _this.start($4034906a84e141fe$var$_objectSpread({
                enableRedraw: true,
                ignoreAnimation: true,
                ignoreMouse: true
            }, options));
            yield _this.ready();
            _this.stop();
        })();
    }
    /**
   * Start rendering.
   * @param options - Render options.
   */ start() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var { documentElement: documentElement, screen: screen, options: baseOptions } = this;
        screen.start(documentElement, $4034906a84e141fe$var$_objectSpread($4034906a84e141fe$var$_objectSpread({
            enableRedraw: true
        }, baseOptions), options));
    }
    /**
   * Stop rendering.
   */ stop() {
        this.screen.stop();
    }
    /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */ resize(width) {
        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : width;
        var preserveAspectRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        this.documentElement.resize(width, height, preserveAspectRatio);
    }
}

});
parcelRegister("7nzI4", function(module, exports) {
'use strict';
parcelRequire("1osSO");
parcelRequire("6I15I");
parcelRequire("dC3pu");
parcelRequire("liswE");
parcelRequire("fKCV2");
parcelRequire("aYvpg");

});
parcelRegister("1osSO", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $jfGLK = parcelRequire("jfGLK");

var $bKnXw = parcelRequire("bKnXw");

var $5tjRy = parcelRequire("5tjRy");

var $isAV7 = parcelRequire("isAV7");

var $bGtV7 = parcelRequire("bGtV7");

var $5zwnU = parcelRequire("5zwnU");

var $86ypM = parcelRequire("86ypM");

var $4W9Kw = parcelRequire("4W9Kw");

var $1ckZt = parcelRequire("1ckZt");

var $eXHxq = parcelRequire("eXHxq");

var $9GTLg = parcelRequire("9GTLg");

var $96Da4 = parcelRequire("96Da4");

var $buzFA = parcelRequire("buzFA");

var $4IYe9 = parcelRequire("4IYe9");

var $e2IBw = parcelRequire("e2IBw");
var $103e6fe3d48715a5$require$task = $e2IBw.set;

var $03kzj = parcelRequire("03kzj");

var $64ukH = parcelRequire("64ukH");

var $n6J5m = parcelRequire("n6J5m");

var $egLvO = parcelRequire("egLvO");

var $51DEQ = parcelRequire("51DEQ");

var $iyCTW = parcelRequire("iyCTW");

var $dYPYH = parcelRequire("dYPYH");

var $2J5Wx = parcelRequire("2J5Wx");
var $103e6fe3d48715a5$var$PROMISE = 'Promise';
var $103e6fe3d48715a5$var$FORCED_PROMISE_CONSTRUCTOR = $dYPYH.CONSTRUCTOR;
var $103e6fe3d48715a5$var$NATIVE_PROMISE_REJECTION_EVENT = $dYPYH.REJECTION_EVENT;
var $103e6fe3d48715a5$var$NATIVE_PROMISE_SUBCLASSING = $dYPYH.SUBCLASSING;
var $103e6fe3d48715a5$var$getInternalPromiseState = $51DEQ.getterFor($103e6fe3d48715a5$var$PROMISE);
var $103e6fe3d48715a5$var$setInternalState = $51DEQ.set;
var $103e6fe3d48715a5$var$NativePromisePrototype = $iyCTW && $iyCTW.prototype;
var $103e6fe3d48715a5$var$PromiseConstructor = $iyCTW;
var $103e6fe3d48715a5$var$PromisePrototype = $103e6fe3d48715a5$var$NativePromisePrototype;
var $103e6fe3d48715a5$var$TypeError = $5tjRy.TypeError;
var $103e6fe3d48715a5$var$document = $5tjRy.document;
var $103e6fe3d48715a5$var$process = $5tjRy.process;
var $103e6fe3d48715a5$var$newPromiseCapability = $2J5Wx.f;
var $103e6fe3d48715a5$var$newGenericPromiseCapability = $103e6fe3d48715a5$var$newPromiseCapability;
var $103e6fe3d48715a5$var$DISPATCH_EVENT = !!($103e6fe3d48715a5$var$document && $103e6fe3d48715a5$var$document.createEvent && $5tjRy.dispatchEvent);
var $103e6fe3d48715a5$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $103e6fe3d48715a5$var$REJECTION_HANDLED = 'rejectionhandled';
var $103e6fe3d48715a5$var$PENDING = 0;
var $103e6fe3d48715a5$var$FULFILLED = 1;
var $103e6fe3d48715a5$var$REJECTED = 2;
var $103e6fe3d48715a5$var$HANDLED = 1;
var $103e6fe3d48715a5$var$UNHANDLED = 2;
var $103e6fe3d48715a5$var$Internal, $103e6fe3d48715a5$var$OwnPromiseCapability, $103e6fe3d48715a5$var$PromiseWrapper, $103e6fe3d48715a5$var$nativeThen;
// helpers
var $103e6fe3d48715a5$var$isThenable = function(it) {
    var then;
    return $96Da4(it) && $9GTLg(then = it.then) ? then : false;
};
var $103e6fe3d48715a5$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state === $103e6fe3d48715a5$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $103e6fe3d48715a5$var$UNHANDLED) $103e6fe3d48715a5$var$onHandleUnhandled(state);
                state.rejection = $103e6fe3d48715a5$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $103e6fe3d48715a5$var$TypeError('Promise-chain cycle'));
            else if (then = $103e6fe3d48715a5$var$isThenable(result)) $bGtV7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $103e6fe3d48715a5$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $03kzj(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$103e6fe3d48715a5$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $103e6fe3d48715a5$var$onUnhandled(state);
    });
};
var $103e6fe3d48715a5$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($103e6fe3d48715a5$var$DISPATCH_EVENT) {
        event = $103e6fe3d48715a5$var$document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $5tjRy.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$103e6fe3d48715a5$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $5tjRy['on' + name])) handler(event);
    else if (name === $103e6fe3d48715a5$var$UNHANDLED_REJECTION) $64ukH('Unhandled promise rejection', reason);
};
var $103e6fe3d48715a5$var$onUnhandled = function(state) {
    $bGtV7($103e6fe3d48715a5$require$task, $5tjRy, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $103e6fe3d48715a5$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $n6J5m(function() {
                if ($bKnXw) $103e6fe3d48715a5$var$process.emit('unhandledRejection', value, promise);
                else $103e6fe3d48715a5$var$dispatchEvent($103e6fe3d48715a5$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $bKnXw || $103e6fe3d48715a5$var$isUnhandled(state) ? $103e6fe3d48715a5$var$UNHANDLED : $103e6fe3d48715a5$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $103e6fe3d48715a5$var$isUnhandled = function(state) {
    return state.rejection !== $103e6fe3d48715a5$var$HANDLED && !state.parent;
};
var $103e6fe3d48715a5$var$onHandleUnhandled = function(state) {
    $bGtV7($103e6fe3d48715a5$require$task, $5tjRy, function() {
        var promise = state.facade;
        if ($bKnXw) $103e6fe3d48715a5$var$process.emit('rejectionHandled', promise);
        else $103e6fe3d48715a5$var$dispatchEvent($103e6fe3d48715a5$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $103e6fe3d48715a5$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $103e6fe3d48715a5$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $103e6fe3d48715a5$var$REJECTED;
    $103e6fe3d48715a5$var$notify(state, true);
};
var $103e6fe3d48715a5$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $103e6fe3d48715a5$var$TypeError("Promise can't be resolved itself");
        var then = $103e6fe3d48715a5$var$isThenable(value);
        if (then) $03kzj(function() {
            var wrapper = {
                done: false
            };
            try {
                $bGtV7(then, value, $103e6fe3d48715a5$var$bind($103e6fe3d48715a5$var$internalResolve, wrapper, state), $103e6fe3d48715a5$var$bind($103e6fe3d48715a5$var$internalReject, wrapper, state));
            } catch (error) {
                $103e6fe3d48715a5$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $103e6fe3d48715a5$var$FULFILLED;
            $103e6fe3d48715a5$var$notify(state, false);
        }
    } catch (error) {
        $103e6fe3d48715a5$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($103e6fe3d48715a5$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $103e6fe3d48715a5$var$PromiseConstructor = function Promise(executor) {
        $buzFA(this, $103e6fe3d48715a5$var$PromisePrototype);
        $eXHxq(executor);
        $bGtV7($103e6fe3d48715a5$var$Internal, this);
        var state = $103e6fe3d48715a5$var$getInternalPromiseState(this);
        try {
            executor($103e6fe3d48715a5$var$bind($103e6fe3d48715a5$var$internalResolve, state), $103e6fe3d48715a5$var$bind($103e6fe3d48715a5$var$internalReject, state));
        } catch (error) {
            $103e6fe3d48715a5$var$internalReject(state, error);
        }
    };
    $103e6fe3d48715a5$var$PromisePrototype = $103e6fe3d48715a5$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $103e6fe3d48715a5$var$Internal = function Promise(executor) {
        $103e6fe3d48715a5$var$setInternalState(this, {
            type: $103e6fe3d48715a5$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $egLvO(),
            rejection: false,
            state: $103e6fe3d48715a5$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $103e6fe3d48715a5$var$Internal.prototype = $5zwnU($103e6fe3d48715a5$var$PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = $103e6fe3d48715a5$var$getInternalPromiseState(this);
        var reaction = $103e6fe3d48715a5$var$newPromiseCapability($4IYe9(this, $103e6fe3d48715a5$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $9GTLg(onFulfilled) ? onFulfilled : true;
        reaction.fail = $9GTLg(onRejected) && onRejected;
        reaction.domain = $bKnXw ? $103e6fe3d48715a5$var$process.domain : undefined;
        if (state.state === $103e6fe3d48715a5$var$PENDING) state.reactions.add(reaction);
        else $03kzj(function() {
            $103e6fe3d48715a5$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $103e6fe3d48715a5$var$OwnPromiseCapability = function() {
        var promise = new $103e6fe3d48715a5$var$Internal();
        var state = $103e6fe3d48715a5$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $103e6fe3d48715a5$var$bind($103e6fe3d48715a5$var$internalResolve, state);
        this.reject = $103e6fe3d48715a5$var$bind($103e6fe3d48715a5$var$internalReject, state);
    };
    $2J5Wx.f = $103e6fe3d48715a5$var$newPromiseCapability = function(C) {
        return C === $103e6fe3d48715a5$var$PromiseConstructor || C === $103e6fe3d48715a5$var$PromiseWrapper ? new $103e6fe3d48715a5$var$OwnPromiseCapability(C) : $103e6fe3d48715a5$var$newGenericPromiseCapability(C);
    };
    if (!$jfGLK && $9GTLg($iyCTW) && $103e6fe3d48715a5$var$NativePromisePrototype !== Object.prototype) {
        $103e6fe3d48715a5$var$nativeThen = $103e6fe3d48715a5$var$NativePromisePrototype.then;
        if (!$103e6fe3d48715a5$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $5zwnU($103e6fe3d48715a5$var$NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var that = this;
            return new $103e6fe3d48715a5$var$PromiseConstructor(function(resolve, reject) {
                $bGtV7($103e6fe3d48715a5$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $103e6fe3d48715a5$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($86ypM) $86ypM($103e6fe3d48715a5$var$NativePromisePrototype, $103e6fe3d48715a5$var$PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$hmx0d({
    global: true,
    constructor: true,
    wrap: true,
    forced: $103e6fe3d48715a5$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $103e6fe3d48715a5$var$PromiseConstructor
});
$103e6fe3d48715a5$var$PromiseWrapper = $isAV7.Promise;
$4W9Kw($103e6fe3d48715a5$var$PromiseConstructor, $103e6fe3d48715a5$var$PROMISE, false, true);
$1ckZt($103e6fe3d48715a5$var$PROMISE);

});
parcelRegister("hmx0d", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $9po1L = parcelRequire("9po1L");
var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $9po1L.f;

var $bylnm = parcelRequire("bylnm");

var $5zwnU = parcelRequire("5zwnU");

var $6BhPC = parcelRequire("6BhPC");

var $kwCyx = parcelRequire("kwCyx");

var $hm2ET = parcelRequire("hm2ET");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $5tjRy;
    else if (STATIC) target = $5tjRy[TARGET] || $6BhPC(TARGET, {});
    else target = $5tjRy[TARGET] && $5tjRy[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $hm2ET(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $kwCyx(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $bylnm(sourceProperty, 'sham', true);
        $5zwnU(target, key, sourceProperty, options);
    }
};

});
parcelRegister("5tjRy", function(module, exports) {
'use strict';
var $3fbf1185731afe2b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
$3fbf1185731afe2b$var$check(typeof globalThis == 'object' && globalThis) || $3fbf1185731afe2b$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3fbf1185731afe2b$var$check(typeof self == 'object' && self) || $3fbf1185731afe2b$var$check(typeof $parcel$global == 'object' && $parcel$global) || $3fbf1185731afe2b$var$check(typeof module.exports == 'object' && module.exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

});

parcelRegister("9po1L", function(module, exports) {

$parcel$export(module.exports, "f", () => $6d99163b6684d050$export$2d1720544b23b823, (v) => $6d99163b6684d050$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
'use strict';

var $kxexm = parcelRequire("kxexm");

var $bGtV7 = parcelRequire("bGtV7");

var $2zQpY = parcelRequire("2zQpY");

var $fEYls = parcelRequire("fEYls");

var $6CGth = parcelRequire("6CGth");

var $aUydt = parcelRequire("aUydt");

var $2HOcD = parcelRequire("2HOcD");

var $ieeYC = parcelRequire("ieeYC");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $kxexm ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $6CGth(O);
    P = $aUydt(P);
    if ($ieeYC) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($2HOcD(O, P)) return $fEYls(!$bGtV7($2zQpY.f, O, P), O[P]);
};

});
parcelRegister("kxexm", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");
// Detect IE8's incomplete defineProperty implementation
module.exports = !$8lFU3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

});
parcelRegister("8lFU3", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

});


parcelRegister("bGtV7", function(module, exports) {
'use strict';

var $gcG3g = parcelRequire("gcG3g");
var $881ad37dbe259e8f$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = $gcG3g ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};

});
parcelRegister("gcG3g", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");
module.exports = !$8lFU3(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

});


parcelRegister("2zQpY", function(module, exports) {

$parcel$export(module.exports, "f", () => $1e0782be6903ea7b$export$2d1720544b23b823, (v) => $1e0782be6903ea7b$export$2d1720544b23b823 = v);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
'use strict';
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;

});

parcelRegister("fEYls", function(module, exports) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});

parcelRegister("6CGth", function(module, exports) {
'use strict';

var $bbbU8 = parcelRequire("bbbU8");

var $gMtBp = parcelRequire("gMtBp");
module.exports = function(it) {
    return $bbbU8($gMtBp(it));
};

});
parcelRegister("bbbU8", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $8lFU3 = parcelRequire("8lFU3");

var $faIBy = parcelRequire("faIBy");
var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $5Okwt(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = $8lFU3(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $faIBy(it) === 'String' ? $8239f4c7c6082668$var$split(it, '') : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;

});
parcelRegister("5Okwt", function(module, exports) {
'use strict';

var $gcG3g = parcelRequire("gcG3g");
var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $43b18aa2f1faac44$var$uncurryThisWithBind = $gcG3g && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
module.exports = $gcG3g ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};

});

parcelRegister("faIBy", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");
var $b0ba63bfbfb16088$var$toString = $5Okwt({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $5Okwt(''.slice);
module.exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};

});


parcelRegister("gMtBp", function(module, exports) {
'use strict';

var $aIKND = parcelRequire("aIKND");
var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if ($aIKND(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};

});
parcelRegister("aIKND", function(module, exports) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

});



parcelRegister("aUydt", function(module, exports) {
'use strict';

var $cmpCY = parcelRequire("cmpCY");

var $XW8Vm = parcelRequire("XW8Vm");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = $cmpCY(argument, 'string');
    return $XW8Vm(key) ? key : key + '';
};

});
parcelRegister("cmpCY", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $96Da4 = parcelRequire("96Da4");

var $XW8Vm = parcelRequire("XW8Vm");

var $kdzTk = parcelRequire("kdzTk");

var $fc07P = parcelRequire("fc07P");

var $blCy8 = parcelRequire("blCy8");
var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $blCy8('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!$96Da4(input) || $XW8Vm(input)) return input;
    var exoticToPrim = $kdzTk(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $bGtV7(exoticToPrim, input, pref);
        if (!$96Da4(result) || $XW8Vm(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $fc07P(input, pref);
};

});
parcelRegister("96Da4", function(module, exports) {
'use strict';

var $9GTLg = parcelRequire("9GTLg");
module.exports = function(it) {
    return typeof it == 'object' ? it !== null : $9GTLg(it);
};

});
parcelRegister("9GTLg", function(module, exports) {
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof $70e34a5a2021f756$var$documentAll == 'undefined' && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

});


parcelRegister("XW8Vm", function(module, exports) {
'use strict';

var $eaZdY = parcelRequire("eaZdY");

var $9GTLg = parcelRequire("9GTLg");

var $5Ef1u = parcelRequire("5Ef1u");

var $6aX88 = parcelRequire("6aX88");
var $0b429cc7792c7d26$var$$Object = Object;
module.exports = $6aX88 ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $eaZdY('Symbol');
    return $9GTLg($Symbol) && $5Ef1u($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};

});
parcelRegister("eaZdY", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $9GTLg = parcelRequire("9GTLg");
var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $9GTLg(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($5tjRy[namespace]) : $5tjRy[namespace] && $5tjRy[namespace][method];
};

});

parcelRegister("5Ef1u", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");
module.exports = $5Okwt({}.isPrototypeOf);

});

parcelRegister("6aX88", function(module, exports) {
'use strict';

var $6n5Js = parcelRequire("6n5Js");
module.exports = $6n5Js && !Symbol.sham && typeof Symbol.iterator == 'symbol';

});
parcelRegister("6n5Js", function(module, exports) {
'use strict';

var $fkVCI = parcelRequire("fkVCI");

var $8lFU3 = parcelRequire("8lFU3");

var $5tjRy = parcelRequire("5tjRy");
var $4a39565fee8fe980$var$$String = $5tjRy.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !$8lFU3(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $fkVCI && $fkVCI < 41;
});

});
parcelRegister("fkVCI", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $4xZMd = parcelRequire("4xZMd");
var $b2a56c1a090208a5$var$process = $5tjRy.process;
var $b2a56c1a090208a5$var$Deno = $5tjRy.Deno;
var $b2a56c1a090208a5$var$versions = $b2a56c1a090208a5$var$process && $b2a56c1a090208a5$var$process.versions || $b2a56c1a090208a5$var$Deno && $b2a56c1a090208a5$var$Deno.version;
var $b2a56c1a090208a5$var$v8 = $b2a56c1a090208a5$var$versions && $b2a56c1a090208a5$var$versions.v8;
var $b2a56c1a090208a5$var$match, $b2a56c1a090208a5$var$version;
if ($b2a56c1a090208a5$var$v8) {
    $b2a56c1a090208a5$var$match = $b2a56c1a090208a5$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b2a56c1a090208a5$var$version = $b2a56c1a090208a5$var$match[0] > 0 && $b2a56c1a090208a5$var$match[0] < 4 ? 1 : +($b2a56c1a090208a5$var$match[0] + $b2a56c1a090208a5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b2a56c1a090208a5$var$version && $4xZMd) {
    $b2a56c1a090208a5$var$match = $4xZMd.match(/Edge\/(\d+)/);
    if (!$b2a56c1a090208a5$var$match || $b2a56c1a090208a5$var$match[1] >= 74) {
        $b2a56c1a090208a5$var$match = $4xZMd.match(/Chrome\/(\d+)/);
        if ($b2a56c1a090208a5$var$match) $b2a56c1a090208a5$var$version = +$b2a56c1a090208a5$var$match[1];
    }
}
module.exports = $b2a56c1a090208a5$var$version;

});
parcelRegister("4xZMd", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");
var $34fa2a1382dc63c1$var$navigator = $5tjRy.navigator;
var $34fa2a1382dc63c1$var$userAgent = $34fa2a1382dc63c1$var$navigator && $34fa2a1382dc63c1$var$navigator.userAgent;
module.exports = $34fa2a1382dc63c1$var$userAgent ? String($34fa2a1382dc63c1$var$userAgent) : '';

});





parcelRegister("kdzTk", function(module, exports) {
'use strict';

var $eXHxq = parcelRequire("eXHxq");

var $aIKND = parcelRequire("aIKND");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return $aIKND(func) ? undefined : $eXHxq(func);
};

});
parcelRegister("eXHxq", function(module, exports) {
'use strict';

var $9GTLg = parcelRequire("9GTLg");

var $chuuX = parcelRequire("chuuX");
var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if ($9GTLg(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($chuuX(argument) + ' is not a function');
};

});
parcelRegister("chuuX", function(module, exports) {
'use strict';
var $8f0ebae34f61e14c$var$$String = String;
module.exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};

});



parcelRegister("fc07P", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $9GTLg = parcelRequire("9GTLg");

var $96Da4 = parcelRequire("96Da4");
var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $9GTLg(fn = input.toString) && !$96Da4(val = $bGtV7(fn, input))) return val;
    if ($9GTLg(fn = input.valueOf) && !$96Da4(val = $bGtV7(fn, input))) return val;
    if (pref !== 'string' && $9GTLg(fn = input.toString) && !$96Da4(val = $bGtV7(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};

});

parcelRegister("blCy8", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $2axMY = parcelRequire("2axMY");

var $2HOcD = parcelRequire("2HOcD");

var $84zlK = parcelRequire("84zlK");

var $6n5Js = parcelRequire("6n5Js");

var $6aX88 = parcelRequire("6aX88");
var $842f8f0a18746212$var$Symbol = $5tjRy.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $2axMY('wks');
var $842f8f0a18746212$var$createWellKnownSymbol = $6aX88 ? $842f8f0a18746212$var$Symbol['for'] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $84zlK;
module.exports = function(name) {
    if (!$2HOcD($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $6n5Js && $2HOcD($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol('Symbol.' + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};

});
parcelRegister("2axMY", function(module, exports) {
'use strict';

var $hRrSO = parcelRequire("hRrSO");
// eslint-disable-next-line es/no-object-create -- safe
var $1946b9b54b48e7fd$var$create = Object.create || Object;
module.exports = function(key, value) {
    return $hRrSO[key] || ($hRrSO[key] = value || $1946b9b54b48e7fd$var$create(null));
};

});
parcelRegister("hRrSO", function(module, exports) {
'use strict';

var $jfGLK = parcelRequire("jfGLK");

var $5tjRy = parcelRequire("5tjRy");

var $6BhPC = parcelRequire("6BhPC");
var $d00d03e557d638db$var$SHARED = '__core-js_shared__';
var $d00d03e557d638db$var$store = module.exports = $5tjRy[$d00d03e557d638db$var$SHARED] || $6BhPC($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: '3.50.0',
    mode: $jfGLK ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.50.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

});
parcelRegister("jfGLK", function(module, exports) {
'use strict';
module.exports = false;

});

parcelRegister("6BhPC", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($5tjRy, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $5tjRy[key] = value;
    }
    return value;
};

});



parcelRegister("2HOcD", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $dZoqA = parcelRequire("dZoqA");
var $1f868a26fd901990$var$hasOwnProperty = $5Okwt({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($dZoqA(it), key);
};

});
parcelRegister("dZoqA", function(module, exports) {
'use strict';

var $gMtBp = parcelRequire("gMtBp");
var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($gMtBp(argument));
};

});


parcelRegister("84zlK", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");
var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $5Okwt(1.1.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};

});




parcelRegister("ieeYC", function(module, exports) {
'use strict';

var $kxexm = parcelRequire("kxexm");

var $8lFU3 = parcelRequire("8lFU3");

var $1RN1j = parcelRequire("1RN1j");
// Thanks to IE8 for its funny defineProperty
module.exports = !$kxexm && !$8lFU3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($1RN1j('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

});
parcelRegister("1RN1j", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $96Da4 = parcelRequire("96Da4");
var $15c0c414b89100b1$var$document = $5tjRy.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $96Da4($15c0c414b89100b1$var$document) && $96Da4($15c0c414b89100b1$var$document.createElement);
module.exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};

});



parcelRegister("bylnm", function(module, exports) {
'use strict';

var $kxexm = parcelRequire("kxexm");

var $3RKYQ = parcelRequire("3RKYQ");

var $fEYls = parcelRequire("fEYls");
module.exports = $kxexm ? function(object, key, value) {
    return $3RKYQ.f(object, key, $fEYls(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("3RKYQ", function(module, exports) {

$parcel$export(module.exports, "f", () => $2d0ac3aa5e39584b$export$2d1720544b23b823, (v) => $2d0ac3aa5e39584b$export$2d1720544b23b823 = v);
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
'use strict';

var $kxexm = parcelRequire("kxexm");

var $ieeYC = parcelRequire("ieeYC");

var $1TEKD = parcelRequire("1TEKD");

var $hc2VB = parcelRequire("hc2VB");

var $aUydt = parcelRequire("aUydt");
var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = 'enumerable';
var $2d0ac3aa5e39584b$var$CONFIGURABLE = 'configurable';
var $2d0ac3aa5e39584b$var$WRITABLE = 'writable';
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $kxexm ? $1TEKD ? function defineProperty(O, P, Attributes) {
    $hc2VB(O);
    P = $aUydt(P);
    $hc2VB(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $hc2VB(O);
    P = $aUydt(P);
    $hc2VB(Attributes);
    if ($ieeYC) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("1TEKD", function(module, exports) {
'use strict';

var $kxexm = parcelRequire("kxexm");

var $8lFU3 = parcelRequire("8lFU3");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = $kxexm && $8lFU3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

});

parcelRegister("hc2VB", function(module, exports) {
'use strict';

var $96Da4 = parcelRequire("96Da4");
var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if ($96Da4(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + ' is not an object');
};

});



parcelRegister("5zwnU", function(module, exports) {
'use strict';

var $9GTLg = parcelRequire("9GTLg");

var $3RKYQ = parcelRequire("3RKYQ");

var $Q0KqA = parcelRequire("Q0KqA");

var $6BhPC = parcelRequire("6BhPC");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($9GTLg(value)) $Q0KqA(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $6BhPC(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $3RKYQ.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

});
parcelRegister("Q0KqA", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $8lFU3 = parcelRequire("8lFU3");

var $9GTLg = parcelRequire("9GTLg");

var $2HOcD = parcelRequire("2HOcD");

var $kxexm = parcelRequire("kxexm");

var $b8MME = parcelRequire("b8MME");
var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $b8MME.CONFIGURABLE;

var $dbqDy = parcelRequire("dbqDy");

var $51DEQ = parcelRequire("51DEQ");
var $09c56ff2ae09b2d7$var$enforceInternalState = $51DEQ.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $51DEQ.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $5Okwt(''.slice);
var $09c56ff2ae09b2d7$var$replace = $5Okwt(''.replace);
var $09c56ff2ae09b2d7$var$join = $5Okwt([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $kxexm && !$8lFU3(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split('String');
var $09c56ff2ae09b2d7$var$makeBuiltIn = module.exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$2HOcD(value, 'name') || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($kxexm) $09c56ff2ae09b2d7$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $2HOcD(options, 'arity') && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $2HOcD(options, 'constructor') && options.constructor) {
            if ($kxexm) $09c56ff2ae09b2d7$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$2HOcD(state, 'source')) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $9GTLg(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $dbqDy(this);
}, 'toString');

});
parcelRegister("b8MME", function(module, exports) {
'use strict';

var $kxexm = parcelRequire("kxexm");

var $2HOcD = parcelRequire("2HOcD");
var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $kxexm && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $2HOcD($81c64883d194e3b4$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === 'something';
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$kxexm || $kxexm && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};

});

parcelRegister("dbqDy", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $9GTLg = parcelRequire("9GTLg");

var $hRrSO = parcelRequire("hRrSO");
var $9990f6f719f26a96$var$functionToString = $5Okwt(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$9GTLg($hRrSO.inspectSource)) $hRrSO.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
module.exports = $hRrSO.inspectSource;

});

parcelRegister("51DEQ", function(module, exports) {
'use strict';

var $6amDj = parcelRequire("6amDj");

var $5tjRy = parcelRequire("5tjRy");

var $96Da4 = parcelRequire("96Da4");

var $bylnm = parcelRequire("bylnm");

var $2HOcD = parcelRequire("2HOcD");

var $hRrSO = parcelRequire("hRrSO");

var $bgRz0 = parcelRequire("bgRz0");

var $dGabS = parcelRequire("dGabS");
var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $3a8bcef306e86159$var$TypeError = $5tjRy.TypeError;
var $3a8bcef306e86159$var$WeakMap = $5tjRy.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$96Da4(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($6amDj || $hRrSO.state) {
    var $3a8bcef306e86159$var$store = $hRrSO.state || ($hRrSO.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $bgRz0('state');
    $dGabS[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($2HOcD(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $bylnm(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $2HOcD(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $2HOcD(it, $3a8bcef306e86159$var$STATE);
    };
}
module.exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};

});
parcelRegister("6amDj", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $9GTLg = parcelRequire("9GTLg");
var $47d53bb84a8f3c5b$var$WeakMap = $5tjRy.WeakMap;
module.exports = $9GTLg($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));

});

parcelRegister("bgRz0", function(module, exports) {
'use strict';

var $2axMY = parcelRequire("2axMY");

var $84zlK = parcelRequire("84zlK");
var $834abcf0f8f3f871$var$keys = $2axMY('keys');
module.exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $84zlK(key));
};

});

parcelRegister("dGabS", function(module, exports) {
'use strict';
module.exports = {};

});




parcelRegister("kwCyx", function(module, exports) {
'use strict';

var $2HOcD = parcelRequire("2HOcD");

var $4qMpp = parcelRequire("4qMpp");

var $9po1L = parcelRequire("9po1L");

var $3RKYQ = parcelRequire("3RKYQ");
module.exports = function(target, source, exceptions) {
    var keys = $4qMpp(source);
    var defineProperty = $3RKYQ.f;
    var getOwnPropertyDescriptor = $9po1L.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$2HOcD(target, key) && !(exceptions && $2HOcD(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

});
parcelRegister("4qMpp", function(module, exports) {
'use strict';

var $eaZdY = parcelRequire("eaZdY");

var $5Okwt = parcelRequire("5Okwt");

var $lbvB0 = parcelRequire("lbvB0");

var $1gYLQ = parcelRequire("1gYLQ");

var $hc2VB = parcelRequire("hc2VB");
var $339f2419d379e6c2$var$concat = $5Okwt([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = $eaZdY('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $lbvB0.f($hc2VB(it));
    var getOwnPropertySymbols = $1gYLQ.f;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};

});
parcelRegister("lbvB0", function(module, exports) {

$parcel$export(module.exports, "f", () => $f6c32256739dd9b5$export$2d1720544b23b823, (v) => $f6c32256739dd9b5$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
'use strict';

var $gUxdt = parcelRequire("gUxdt");

var $jQUZd = parcelRequire("jQUZd");
var $f6c32256739dd9b5$var$hiddenKeys = $jQUZd.concat('length', 'prototype');
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $gUxdt(O, $f6c32256739dd9b5$var$hiddenKeys);
};

});
parcelRegister("gUxdt", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $2HOcD = parcelRequire("2HOcD");

var $6CGth = parcelRequire("6CGth");

var $kBDFQ = parcelRequire("kBDFQ");
var $c4fba4611365c4f5$require$indexOf = $kBDFQ.indexOf;

var $dGabS = parcelRequire("dGabS");
var $c4fba4611365c4f5$var$push = $5Okwt([].push);
module.exports = function(object, names) {
    var O = $6CGth(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$2HOcD($dGabS, key) && $2HOcD(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($2HOcD(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};

});
parcelRegister("kBDFQ", function(module, exports) {
'use strict';

var $6CGth = parcelRequire("6CGth");

var $2ES4E = parcelRequire("2ES4E");

var $ptmgx = parcelRequire("ptmgx");
// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6CGth($this);
        var length = $ptmgx(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $2ES4E(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};

});
parcelRegister("2ES4E", function(module, exports) {
'use strict';

var $fBlGn = parcelRequire("fBlGn");
var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = $fBlGn(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};

});
parcelRegister("fBlGn", function(module, exports) {
'use strict';

var $7aV2g = parcelRequire("7aV2g");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $7aV2g(number);
};

});
parcelRegister("7aV2g", function(module, exports) {
'use strict';
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};

});



parcelRegister("ptmgx", function(module, exports) {
'use strict';

var $6pMmI = parcelRequire("6pMmI");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return $6pMmI(obj.length);
};

});
parcelRegister("6pMmI", function(module, exports) {
'use strict';

var $fBlGn = parcelRequire("fBlGn");
var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = $fBlGn(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

});




parcelRegister("jQUZd", function(module, exports) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

});


parcelRegister("1gYLQ", function(module, exports) {

$parcel$export(module.exports, "f", () => $0ed66cde5c449819$export$2d1720544b23b823, (v) => $0ed66cde5c449819$export$2d1720544b23b823 = v);
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
'use strict';
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});



parcelRegister("hm2ET", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");

var $9GTLg = parcelRequire("9GTLg");
var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $9GTLg(detection) ? $8lFU3(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, '.').toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = 'N';
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = 'P';
module.exports = $ca268db110e9e457$var$isForced;

});


parcelRegister("bKnXw", function(module, exports) {
'use strict';

var $bFiMb = parcelRequire("bFiMb");
module.exports = $bFiMb === 'NODE';

});
parcelRegister("bFiMb", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $4xZMd = parcelRequire("4xZMd");

var $faIBy = parcelRequire("faIBy");
var $87e21695405add0a$var$userAgentStartsWith = function(string) {
    return $4xZMd.slice(0, string.length) === string;
};
module.exports = function() {
    if ($87e21695405add0a$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($87e21695405add0a$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($87e21695405add0a$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($87e21695405add0a$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($5tjRy.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($5tjRy.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($faIBy($5tjRy.process) === 'process') return 'NODE';
    if ($5tjRy.window && $5tjRy.document) return 'BROWSER';
    return 'REST';
}();

});


parcelRegister("isAV7", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");
module.exports = $5tjRy;

});

parcelRegister("86ypM", function(module, exports) {
'use strict';

var $eH2QD = parcelRequire("eH2QD");

var $96Da4 = parcelRequire("96Da4");

var $gMtBp = parcelRequire("gMtBp");

var $igRk2 = parcelRequire("igRk2");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $eH2QD(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $gMtBp(O);
        $igRk2(proto);
        if (!$96Da4(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

});
parcelRegister("eH2QD", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $eXHxq = parcelRequire("eXHxq");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $5Okwt($eXHxq(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

});

parcelRegister("igRk2", function(module, exports) {
'use strict';

var $64ANw = parcelRequire("64ANw");
var $d4d31549cf7c058b$var$$String = String;
var $d4d31549cf7c058b$var$$TypeError = TypeError;
module.exports = function(argument) {
    if ($64ANw(argument)) return argument;
    throw new $d4d31549cf7c058b$var$$TypeError("Can't set " + $d4d31549cf7c058b$var$$String(argument) + ' as a prototype');
};

});
parcelRegister("64ANw", function(module, exports) {
'use strict';

var $96Da4 = parcelRequire("96Da4");
module.exports = function(argument) {
    return $96Da4(argument) || argument === null;
};

});



parcelRegister("4W9Kw", function(module, exports) {
'use strict';

var $3RKYQ = parcelRequire("3RKYQ");
var $3984243ae29093af$require$defineProperty = $3RKYQ.f;

var $2HOcD = parcelRequire("2HOcD");

var $blCy8 = parcelRequire("blCy8");
var $3984243ae29093af$var$TO_STRING_TAG = $blCy8('toStringTag');
module.exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$2HOcD(target, $3984243ae29093af$var$TO_STRING_TAG)) $3984243ae29093af$require$defineProperty(target, $3984243ae29093af$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

});

parcelRegister("1ckZt", function(module, exports) {
'use strict';

var $eaZdY = parcelRequire("eaZdY");

var $a0W74 = parcelRequire("a0W74");

var $blCy8 = parcelRequire("blCy8");

var $kxexm = parcelRequire("kxexm");
var $0df731b64ad8eead$var$SPECIES = $blCy8('species');
module.exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $eaZdY(CONSTRUCTOR_NAME);
    if ($kxexm && Constructor && !Constructor[$0df731b64ad8eead$var$SPECIES]) $a0W74(Constructor, $0df731b64ad8eead$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});
parcelRegister("a0W74", function(module, exports) {
'use strict';

var $Q0KqA = parcelRequire("Q0KqA");

var $3RKYQ = parcelRequire("3RKYQ");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) $Q0KqA(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $Q0KqA(descriptor.set, name, {
        setter: true
    });
    return $3RKYQ.f(target, name, descriptor);
};

});


parcelRegister("buzFA", function(module, exports) {
'use strict';

var $5Ef1u = parcelRequire("5Ef1u");
var $85de2a4f93f1c485$var$$TypeError = TypeError;
module.exports = function(it, Prototype) {
    if ($5Ef1u(Prototype, it)) return it;
    throw new $85de2a4f93f1c485$var$$TypeError('Incorrect invocation');
};

});

parcelRegister("4IYe9", function(module, exports) {
'use strict';

var $hc2VB = parcelRequire("hc2VB");

var $lW6NZ = parcelRequire("lW6NZ");

var $aIKND = parcelRequire("aIKND");

var $blCy8 = parcelRequire("blCy8");
var $3709fd5be38943d8$var$SPECIES = $blCy8('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function(O, defaultConstructor) {
    var C = $hc2VB(O).constructor;
    var S;
    return C === undefined || $aIKND(S = $hc2VB(C)[$3709fd5be38943d8$var$SPECIES]) ? defaultConstructor : $lW6NZ(S);
};

});
parcelRegister("lW6NZ", function(module, exports) {
'use strict';

var $2ihFE = parcelRequire("2ihFE");

var $chuuX = parcelRequire("chuuX");
var $ff844b26993549ea$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
module.exports = function(argument) {
    if ($2ihFE(argument)) return argument;
    throw new $ff844b26993549ea$var$$TypeError($chuuX(argument) + ' is not a constructor');
};

});
parcelRegister("2ihFE", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $8lFU3 = parcelRequire("8lFU3");

var $9GTLg = parcelRequire("9GTLg");

var $f9qXf = parcelRequire("f9qXf");

var $eaZdY = parcelRequire("eaZdY");

var $dbqDy = parcelRequire("dbqDy");
var $1abaf8429012df1f$var$noop = function() {};
var $1abaf8429012df1f$var$construct = $eaZdY('Reflect', 'construct');
var $1abaf8429012df1f$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $1abaf8429012df1f$var$exec = $5Okwt($1abaf8429012df1f$var$constructorRegExp.exec);
var $1abaf8429012df1f$var$INCORRECT_TO_STRING = !$1abaf8429012df1f$var$constructorRegExp.test($1abaf8429012df1f$var$noop);
var $1abaf8429012df1f$var$isConstructorModern = function isConstructor(argument) {
    if (!$9GTLg(argument)) return false;
    try {
        $1abaf8429012df1f$var$construct($1abaf8429012df1f$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $1abaf8429012df1f$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$9GTLg(argument)) return false;
    switch($f9qXf(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $1abaf8429012df1f$var$INCORRECT_TO_STRING || !!$1abaf8429012df1f$var$exec($1abaf8429012df1f$var$constructorRegExp, $dbqDy(argument));
    } catch (error) {
        return true;
    }
};
$1abaf8429012df1f$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !$1abaf8429012df1f$var$construct || $8lFU3(function() {
    var called;
    return $1abaf8429012df1f$var$isConstructorModern($1abaf8429012df1f$var$isConstructorModern.call) || !$1abaf8429012df1f$var$isConstructorModern(Object) || !$1abaf8429012df1f$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $1abaf8429012df1f$var$isConstructorLegacy : $1abaf8429012df1f$var$isConstructorModern;

});
parcelRegister("f9qXf", function(module, exports) {
'use strict';

var $dYl9B = parcelRequire("dYl9B");

var $9GTLg = parcelRequire("9GTLg");

var $faIBy = parcelRequire("faIBy");

var $blCy8 = parcelRequire("blCy8");
var $b07c9aec2f9c74e4$var$TO_STRING_TAG = $blCy8('toStringTag');
var $b07c9aec2f9c74e4$var$$Object = Object;
// ES3 wrong here
var $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS = $faIBy(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $b07c9aec2f9c74e4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = $dYl9B ? $faIBy : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $b07c9aec2f9c74e4$var$tryGet(O = $b07c9aec2f9c74e4$var$$Object(it), $b07c9aec2f9c74e4$var$TO_STRING_TAG)) == 'string' ? tag : $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS ? $faIBy(O) : (result = $faIBy(O)) === 'Object' && $9GTLg(O.callee) ? 'Arguments' : result;
};

});
parcelRegister("dYl9B", function(module, exports) {
'use strict';

var $blCy8 = parcelRequire("blCy8");
var $a2c149aaa14cc75b$var$TO_STRING_TAG = $blCy8('toStringTag');
var $a2c149aaa14cc75b$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$a2c149aaa14cc75b$var$test[$a2c149aaa14cc75b$var$TO_STRING_TAG] = 'z';
module.exports = String($a2c149aaa14cc75b$var$test) === '[object z]';

});





parcelRegister("e2IBw", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $5dW2a = parcelRequire("5dW2a");

var $5LtBJ = parcelRequire("5LtBJ");

var $9GTLg = parcelRequire("9GTLg");

var $2HOcD = parcelRequire("2HOcD");

var $8lFU3 = parcelRequire("8lFU3");

var $fRIdv = parcelRequire("fRIdv");

var $BsNAl = parcelRequire("BsNAl");

var $1RN1j = parcelRequire("1RN1j");

var $aM51J = parcelRequire("aM51J");

var $3ToQ1 = parcelRequire("3ToQ1");

var $bKnXw = parcelRequire("bKnXw");
var $a393da0e05d61ed1$var$set = $5tjRy.setImmediate;
var $a393da0e05d61ed1$var$clear = $5tjRy.clearImmediate;
var $a393da0e05d61ed1$var$process = $5tjRy.process;
var $a393da0e05d61ed1$var$Dispatch = $5tjRy.Dispatch;
var $a393da0e05d61ed1$var$Function = $5tjRy.Function;
var $a393da0e05d61ed1$var$MessageChannel = $5tjRy.MessageChannel;
var $a393da0e05d61ed1$var$String = $5tjRy.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$8lFU3(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $5tjRy.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($2HOcD($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $5tjRy.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + '//' + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $aM51J(arguments.length, 1);
        var fn = $9GTLg(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $BsNAl(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $5dW2a(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($bKnXw) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$3ToQ1) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $5LtBJ($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($5tjRy.addEventListener && $9GTLg($5tjRy.postMessage) && !$5tjRy.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== 'file:' && !$8lFU3($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $5tjRy.addEventListener('message', $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $1RN1j('script')) $a393da0e05d61ed1$var$defer = function(id) {
        $fRIdv.appendChild($1RN1j('script'))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $fRIdv.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
module.exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};

});
parcelRegister("5dW2a", function(module, exports) {
'use strict';

var $gcG3g = parcelRequire("gcG3g");
var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || ($gcG3g ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});

});

parcelRegister("5LtBJ", function(module, exports) {
'use strict';

var $6c6m5 = parcelRequire("6c6m5");

var $eXHxq = parcelRequire("eXHxq");

var $gcG3g = parcelRequire("gcG3g");
var $43284f0171045916$var$bind = $6c6m5($6c6m5.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    $eXHxq(fn);
    return that === undefined ? fn : $gcG3g ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("6c6m5", function(module, exports) {
'use strict';

var $faIBy = parcelRequire("faIBy");

var $5Okwt = parcelRequire("5Okwt");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($faIBy(fn) === 'Function') return $5Okwt(fn);
};

});


parcelRegister("fRIdv", function(module, exports) {
'use strict';

var $eaZdY = parcelRequire("eaZdY");
module.exports = $eaZdY('document', 'documentElement');

});

parcelRegister("BsNAl", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");
module.exports = $5Okwt([].slice);

});

parcelRegister("aM51J", function(module, exports) {
'use strict';
var $7d824954c5058f7d$var$$TypeError = TypeError;
module.exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError('Not enough arguments');
    return passed;
};

});

parcelRegister("3ToQ1", function(module, exports) {
'use strict';

var $4xZMd = parcelRequire("4xZMd");
module.exports = /ipad|iphone|ipod/i.test($4xZMd) && /applewebkit/i.test($4xZMd);

});


parcelRegister("03kzj", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $dvdWd = parcelRequire("dvdWd");

var $5LtBJ = parcelRequire("5LtBJ");

var $e2IBw = parcelRequire("e2IBw");
var $00a03c6e72e51ed6$require$macrotask = $e2IBw.set;

var $egLvO = parcelRequire("egLvO");

var $3ToQ1 = parcelRequire("3ToQ1");

var $1Dk4E = parcelRequire("1Dk4E");

var $69zMM = parcelRequire("69zMM");

var $bKnXw = parcelRequire("bKnXw");
var $00a03c6e72e51ed6$var$MutationObserver = $5tjRy.MutationObserver || $5tjRy.WebKitMutationObserver;
var $00a03c6e72e51ed6$var$document = $5tjRy.document;
var $00a03c6e72e51ed6$var$process = $5tjRy.process;
var $00a03c6e72e51ed6$var$Promise = $5tjRy.Promise;
var $00a03c6e72e51ed6$var$microtask = $dvdWd('queueMicrotask');
var $00a03c6e72e51ed6$var$notify, $00a03c6e72e51ed6$var$toggle, $00a03c6e72e51ed6$var$node, $00a03c6e72e51ed6$var$promise, $00a03c6e72e51ed6$var$then;
// modern engines have queueMicrotask method
if (!$00a03c6e72e51ed6$var$microtask) {
    var $00a03c6e72e51ed6$var$queue = new $egLvO();
    var $00a03c6e72e51ed6$var$flush = function() {
        var parent, fn;
        if ($bKnXw && (parent = $00a03c6e72e51ed6$var$process.domain)) parent.exit();
        while(fn = $00a03c6e72e51ed6$var$queue.get())try {
            fn();
        } catch (error) {
            if ($00a03c6e72e51ed6$var$queue.head) $00a03c6e72e51ed6$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$3ToQ1 && !$bKnXw && !$69zMM && $00a03c6e72e51ed6$var$MutationObserver && $00a03c6e72e51ed6$var$document) {
        $00a03c6e72e51ed6$var$toggle = true;
        $00a03c6e72e51ed6$var$node = $00a03c6e72e51ed6$var$document.createTextNode('');
        new $00a03c6e72e51ed6$var$MutationObserver($00a03c6e72e51ed6$var$flush).observe($00a03c6e72e51ed6$var$node, {
            characterData: true
        });
        $00a03c6e72e51ed6$var$notify = function() {
            $00a03c6e72e51ed6$var$node.data = $00a03c6e72e51ed6$var$toggle = !$00a03c6e72e51ed6$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$1Dk4E && $00a03c6e72e51ed6$var$Promise && $00a03c6e72e51ed6$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $00a03c6e72e51ed6$var$promise = $00a03c6e72e51ed6$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $00a03c6e72e51ed6$var$promise.constructor = $00a03c6e72e51ed6$var$Promise;
        $00a03c6e72e51ed6$var$then = $5LtBJ($00a03c6e72e51ed6$var$promise.then, $00a03c6e72e51ed6$var$promise);
        $00a03c6e72e51ed6$var$notify = function() {
            $00a03c6e72e51ed6$var$then($00a03c6e72e51ed6$var$flush);
        };
    // Node.js without promises
    } else if ($bKnXw) $00a03c6e72e51ed6$var$notify = function() {
        $00a03c6e72e51ed6$var$process.nextTick($00a03c6e72e51ed6$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $00a03c6e72e51ed6$require$macrotask = $5LtBJ($00a03c6e72e51ed6$require$macrotask, $5tjRy);
        $00a03c6e72e51ed6$var$notify = function() {
            $00a03c6e72e51ed6$require$macrotask($00a03c6e72e51ed6$var$flush);
        };
    }
    $00a03c6e72e51ed6$var$microtask = function(fn) {
        if (!$00a03c6e72e51ed6$var$queue.head) $00a03c6e72e51ed6$var$notify();
        $00a03c6e72e51ed6$var$queue.add(fn);
    };
}
module.exports = $00a03c6e72e51ed6$var$microtask;

});
parcelRegister("dvdWd", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $kxexm = parcelRequire("kxexm");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $9d48fb6c713c2219$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
module.exports = function(name) {
    if (!$kxexm) return $5tjRy[name];
    var descriptor = $9d48fb6c713c2219$var$getOwnPropertyDescriptor($5tjRy, name);
    return descriptor && descriptor.value;
};

});

parcelRegister("egLvO", function(module, exports) {
'use strict';
var $a6376a3b41d6f5b4$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$a6376a3b41d6f5b4$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
module.exports = $a6376a3b41d6f5b4$var$Queue;

});

parcelRegister("1Dk4E", function(module, exports) {
'use strict';

var $4xZMd = parcelRequire("4xZMd");
module.exports = /ipad|iphone|ipod/i.test($4xZMd) && typeof Pebble != 'undefined';

});

parcelRegister("69zMM", function(module, exports) {
'use strict';

var $4xZMd = parcelRequire("4xZMd");
module.exports = /web0s(?!.*chrome)/i.test($4xZMd);

});


parcelRegister("64ukH", function(module, exports) {
'use strict';
module.exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};

});

parcelRegister("n6J5m", function(module, exports) {
'use strict';
module.exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};

});

parcelRegister("iyCTW", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");
module.exports = $5tjRy.Promise;

});

parcelRegister("dYPYH", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $iyCTW = parcelRequire("iyCTW");

var $9GTLg = parcelRequire("9GTLg");

var $hm2ET = parcelRequire("hm2ET");

var $dbqDy = parcelRequire("dbqDy");

var $blCy8 = parcelRequire("blCy8");

var $bFiMb = parcelRequire("bFiMb");

var $jfGLK = parcelRequire("jfGLK");

var $fkVCI = parcelRequire("fkVCI");
var $a2d932b437222d4b$var$NativePromisePrototype = $iyCTW && $iyCTW.prototype;
var $a2d932b437222d4b$var$SPECIES = $blCy8('species');
var $a2d932b437222d4b$var$SUBCLASSING = false;
var $a2d932b437222d4b$var$NATIVE_PROMISE_REJECTION_EVENT = $9GTLg($5tjRy.PromiseRejectionEvent);
var $a2d932b437222d4b$var$FORCED_PROMISE_CONSTRUCTOR = $hm2ET('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $dbqDy($iyCTW);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($iyCTW);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $fkVCI === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($jfGLK && !($a2d932b437222d4b$var$NativePromisePrototype['catch'] && $a2d932b437222d4b$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$fkVCI || $fkVCI < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $iyCTW(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$a2d932b437222d4b$var$SPECIES] = FakePromise;
        $a2d932b437222d4b$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$a2d932b437222d4b$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($bFiMb === 'BROWSER' || $bFiMb === 'DENO') && !$a2d932b437222d4b$var$NATIVE_PROMISE_REJECTION_EVENT;
});
module.exports = {
    CONSTRUCTOR: $a2d932b437222d4b$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $a2d932b437222d4b$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $a2d932b437222d4b$var$SUBCLASSING
};

});

parcelRegister("2J5Wx", function(module, exports) {

$parcel$export(module.exports, "f", () => $1fc464e952e6a79f$export$2d1720544b23b823, (v) => $1fc464e952e6a79f$export$2d1720544b23b823 = v);
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $1fc464e952e6a79f$export$2d1720544b23b823;
'use strict';

var $eXHxq = parcelRequire("eXHxq");
var $1fc464e952e6a79f$var$$TypeError = TypeError;
var $1fc464e952e6a79f$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $1fc464e952e6a79f$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $eXHxq(resolve);
    this.reject = $eXHxq(reject);
};
$1fc464e952e6a79f$export$2d1720544b23b823 = function(C) {
    return new $1fc464e952e6a79f$var$PromiseCapability(C);
};

});


parcelRegister("6I15I", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $bGtV7 = parcelRequire("bGtV7");

var $eXHxq = parcelRequire("eXHxq");

var $2J5Wx = parcelRequire("2J5Wx");

var $n6J5m = parcelRequire("n6J5m");

var $enLsu = parcelRequire("enLsu");

var $eDyVp = parcelRequire("eDyVp");
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$hmx0d({
    target: 'Promise',
    stat: true,
    forced: $eDyVp
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $2J5Wx.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $n6J5m(function() {
            var $promiseResolve = $eXHxq(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $enLsu(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $bGtV7($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});
parcelRegister("enLsu", function(module, exports) {
'use strict';

var $5LtBJ = parcelRequire("5LtBJ");

var $bGtV7 = parcelRequire("bGtV7");

var $hc2VB = parcelRequire("hc2VB");

var $chuuX = parcelRequire("chuuX");

var $7tjA0 = parcelRequire("7tjA0");

var $ptmgx = parcelRequire("ptmgx");

var $5Ef1u = parcelRequire("5Ef1u");

var $kLdhi = parcelRequire("kLdhi");

var $14Gze = parcelRequire("14Gze");

var $5A6El = parcelRequire("5A6El");
var $a78806ef4ebb6167$var$$TypeError = TypeError;
var $a78806ef4ebb6167$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a78806ef4ebb6167$var$ResultPrototype = $a78806ef4ebb6167$var$Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $5LtBJ(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        var $iterator = iterator;
        iterator = undefined;
        if ($iterator) $5A6El($iterator, 'normal');
        return new $a78806ef4ebb6167$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $hc2VB(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $14Gze(iterable);
        if (!iterFn) throw new $a78806ef4ebb6167$var$$TypeError($chuuX(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($7tjA0(iterFn)) {
            for(index = 0, length = $ptmgx(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5Ef1u($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
            }
            return new $a78806ef4ebb6167$var$Result(false);
        }
        iterator = $kLdhi(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $bGtV7(next, iterator)).done){
        // `IteratorValue` errors should propagate without closing the iterator
        var value = step.value;
        try {
            result = callFn(value);
        } catch (error) {
            if (iterator) $5A6El(iterator, 'throw', error);
            else throw error;
        }
        if (typeof result == 'object' && result && $5Ef1u($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
    }
    return new $a78806ef4ebb6167$var$Result(false);
};

});
parcelRegister("7tjA0", function(module, exports) {
'use strict';

var $blCy8 = parcelRequire("blCy8");

var $1mwfF = parcelRequire("1mwfF");
var $570a6df80758b4be$var$ITERATOR = $blCy8('iterator');
var $570a6df80758b4be$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && ($1mwfF.Array === it || $570a6df80758b4be$var$ArrayPrototype[$570a6df80758b4be$var$ITERATOR] === it);
};

});
parcelRegister("1mwfF", function(module, exports) {
'use strict';
module.exports = Object.create ? Object.create(null) : {};

});


parcelRegister("kLdhi", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $9GTLg = parcelRequire("9GTLg");

var $hc2VB = parcelRequire("hc2VB");

var $chuuX = parcelRequire("chuuX");

var $14Gze = parcelRequire("14Gze");
var $f1d27f279e608ff8$var$$TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $14Gze(argument) : usingIterator;
    if ($9GTLg(iteratorMethod)) return $hc2VB($bGtV7(iteratorMethod, argument));
    throw new $f1d27f279e608ff8$var$$TypeError($chuuX(argument) + ' is not iterable');
};

});
parcelRegister("14Gze", function(module, exports) {
'use strict';

var $faIBy = parcelRequire("faIBy");

var $aIKND = parcelRequire("aIKND");

var $kdzTk = parcelRequire("kdzTk");

var $blCy8 = parcelRequire("blCy8");
var $0c872f28c5035676$var$ITERATOR = $blCy8('iterator');
var $0c872f28c5035676$var$ArrayPrototype = Array.prototype;
module.exports = function(it) {
    if (!$aIKND(it)) return $kdzTk(it, $0c872f28c5035676$var$ITERATOR) || $kdzTk(it, '@@iterator') || ($faIBy(it) === 'Arguments' ? $0c872f28c5035676$var$ArrayPrototype[$0c872f28c5035676$var$ITERATOR] : undefined);
};

});


parcelRegister("5A6El", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $hc2VB = parcelRequire("hc2VB");

var $kdzTk = parcelRequire("kdzTk");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $hc2VB(iterator);
    try {
        innerResult = $kdzTk(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $bGtV7(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $hc2VB(innerResult);
    return value;
};

});


parcelRegister("eDyVp", function(module, exports) {
'use strict';

var $iyCTW = parcelRequire("iyCTW");

var $1R2tK = parcelRequire("1R2tK");

var $dYPYH = parcelRequire("dYPYH");
var $aa7fcc920ce05a79$require$FORCED_PROMISE_CONSTRUCTOR = $dYPYH.CONSTRUCTOR;
module.exports = $aa7fcc920ce05a79$require$FORCED_PROMISE_CONSTRUCTOR || !$1R2tK(function(iterable) {
    $iyCTW.all(iterable).then(undefined, function() {});
});

});
parcelRegister("1R2tK", function(module, exports) {
'use strict';

var $blCy8 = parcelRequire("blCy8");
var $159ca9ebcc568d56$var$ITERATOR = $blCy8('iterator');
var $159ca9ebcc568d56$var$SAFE_CLOSING = false;
try {
    var $159ca9ebcc568d56$var$called = 0;
    var $159ca9ebcc568d56$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$159ca9ebcc568d56$var$called++
            };
        },
        'return': function() {
            $159ca9ebcc568d56$var$SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    $159ca9ebcc568d56$var$iteratorWithReturn[$159ca9ebcc568d56$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($159ca9ebcc568d56$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$159ca9ebcc568d56$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[$159ca9ebcc568d56$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

});



parcelRegister("dC3pu", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $jfGLK = parcelRequire("jfGLK");

var $dYPYH = parcelRequire("dYPYH");
var $9e91782c75facebf$require$FORCED_PROMISE_CONSTRUCTOR = $dYPYH.CONSTRUCTOR;

var $iyCTW = parcelRequire("iyCTW");

var $eaZdY = parcelRequire("eaZdY");

var $9GTLg = parcelRequire("9GTLg");

var $5zwnU = parcelRequire("5zwnU");
var $9e91782c75facebf$var$NativePromisePrototype = $iyCTW && $iyCTW.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$hmx0d({
    target: 'Promise',
    proto: true,
    forced: $9e91782c75facebf$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$jfGLK && $9GTLg($iyCTW)) {
    var $9e91782c75facebf$var$method = $eaZdY('Promise').prototype['catch'];
    if ($9e91782c75facebf$var$NativePromisePrototype['catch'] !== $9e91782c75facebf$var$method) $5zwnU($9e91782c75facebf$var$NativePromisePrototype, 'catch', $9e91782c75facebf$var$method, {
        unsafe: true
    });
}

});

parcelRegister("liswE", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $bGtV7 = parcelRequire("bGtV7");

var $eXHxq = parcelRequire("eXHxq");

var $2J5Wx = parcelRequire("2J5Wx");

var $n6J5m = parcelRequire("n6J5m");

var $enLsu = parcelRequire("enLsu");

var $eDyVp = parcelRequire("eDyVp");
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$hmx0d({
    target: 'Promise',
    stat: true,
    forced: $eDyVp
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $2J5Wx.f(C);
        var reject = capability.reject;
        var result = $n6J5m(function() {
            var $promiseResolve = $eXHxq(C.resolve);
            $enLsu(iterable, function(promise) {
                $bGtV7($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});

});

parcelRegister("fKCV2", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $2J5Wx = parcelRequire("2J5Wx");

var $dYPYH = parcelRequire("dYPYH");
var $b7795760382ede7a$require$FORCED_PROMISE_CONSTRUCTOR = $dYPYH.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$hmx0d({
    target: 'Promise',
    stat: true,
    forced: $b7795760382ede7a$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $2J5Wx.f(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});

});

parcelRegister("aYvpg", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $eaZdY = parcelRequire("eaZdY");

var $jfGLK = parcelRequire("jfGLK");

var $iyCTW = parcelRequire("iyCTW");

var $dYPYH = parcelRequire("dYPYH");
var $7fd7dea6b7150202$require$FORCED_PROMISE_CONSTRUCTOR = $dYPYH.CONSTRUCTOR;

var $8cI6i = parcelRequire("8cI6i");
var $7fd7dea6b7150202$var$PromiseConstructorWrapper = $eaZdY('Promise');
var $7fd7dea6b7150202$var$CHECK_WRAPPER = $jfGLK && !$7fd7dea6b7150202$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$hmx0d({
    target: 'Promise',
    stat: true,
    forced: $jfGLK || $7fd7dea6b7150202$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $8cI6i($7fd7dea6b7150202$var$CHECK_WRAPPER && this === $7fd7dea6b7150202$var$PromiseConstructorWrapper ? $iyCTW : this, x);
    }
});

});
parcelRegister("8cI6i", function(module, exports) {
'use strict';

var $hc2VB = parcelRequire("hc2VB");

var $96Da4 = parcelRequire("96Da4");

var $2J5Wx = parcelRequire("2J5Wx");
module.exports = function(C, x) {
    $hc2VB(C);
    if ($96Da4(x) && x.constructor === C) return x;
    var promiseCapability = $2J5Wx.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});



parcelRegister("fOd0O", function(module, exports) {
function $b8259e79f5c77a6f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b8259e79f5c77a6f$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Miql", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $5Okwt = parcelRequire("5Okwt");

var $kZoi0 = parcelRequire("kZoi0");

var $hc2VB = parcelRequire("hc2VB");

var $96Da4 = parcelRequire("96Da4");

var $6pMmI = parcelRequire("6pMmI");

var $jqSLA = parcelRequire("jqSLA");

var $gMtBp = parcelRequire("gMtBp");

var $kdzTk = parcelRequire("kdzTk");

var $kUr0l = parcelRequire("kUr0l");

var $5mspY = parcelRequire("5mspY");

var $aRQrX = parcelRequire("aRQrX");
var $37a9efbf82e0dbd6$var$stringIndexOf = $5Okwt(''.indexOf);
// @@match logic
$kZoi0('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $gMtBp(this);
            var matcher = $96Da4(regexp) ? $kdzTk(regexp, MATCH) : undefined;
            if (matcher) return $bGtV7(matcher, regexp, O);
            var S = $jqSLA(O);
            return new RegExp(regexp)[MATCH](S);
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $hc2VB(this);
            var S = $jqSLA(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            var flags = $jqSLA($5mspY(rx));
            if (!~$37a9efbf82e0dbd6$var$stringIndexOf(flags, 'g')) return $aRQrX(rx, S);
            var fullUnicode = !!~$37a9efbf82e0dbd6$var$stringIndexOf(flags, 'u') || !!~$37a9efbf82e0dbd6$var$stringIndexOf(flags, 'v');
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $aRQrX(rx, S)) !== null){
                var matchStr = $jqSLA(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $kUr0l(S, $6pMmI(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});

});
parcelRegister("kZoi0", function(module, exports) {
'use strict';
parcelRequire("5UJ5z");

var $bGtV7 = parcelRequire("bGtV7");

var $5zwnU = parcelRequire("5zwnU");

var $bonTf = parcelRequire("bonTf");

var $8lFU3 = parcelRequire("8lFU3");

var $blCy8 = parcelRequire("blCy8");

var $bylnm = parcelRequire("bylnm");
var $f47c588794c56189$var$SPECIES = $blCy8('species');
var $f47c588794c56189$var$RegExpPrototype = RegExp.prototype;
module.exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $blCy8(KEY);
    var DELEGATES_TO_SYMBOL = !$8lFU3(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$8lFU3(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            var constructor = {};
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            constructor[$f47c588794c56189$var$SPECIES] = function() {
                return re;
            };
            re = {
                constructor: constructor,
                flags: ''
            };
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $bonTf || $exec === $f47c588794c56189$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $bGtV7(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $bGtV7(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $5zwnU(String.prototype, KEY, methods[0]);
        $5zwnU($f47c588794c56189$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $bylnm($f47c588794c56189$var$RegExpPrototype[SYMBOL], 'sham', true);
};

});
parcelRegister("5UJ5z", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $bonTf = parcelRequire("bonTf");
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$hmx0d({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $bonTf
}, {
    exec: $bonTf
});

});
parcelRegister("bonTf", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $5Okwt = parcelRequire("5Okwt");

var $jqSLA = parcelRequire("jqSLA");

var $1YgHc = parcelRequire("1YgHc");

var $jeN8V = parcelRequire("jeN8V");

var $2axMY = parcelRequire("2axMY");

var $7TMtU = parcelRequire("7TMtU");

var $51DEQ = parcelRequire("51DEQ");
var $84b477ad334ab936$require$getInternalState = $51DEQ.get;

var $ajlvS = parcelRequire("ajlvS");

var $051u0 = parcelRequire("051u0");
var $84b477ad334ab936$var$nativeReplace = $2axMY('native-string-replace', String.prototype.replace);
var $84b477ad334ab936$var$nativeExec = RegExp.prototype.exec;
var $84b477ad334ab936$var$patchedExec = $84b477ad334ab936$var$nativeExec;
var $84b477ad334ab936$var$charAt = $5Okwt(''.charAt);
var $84b477ad334ab936$var$indexOf = $5Okwt(''.indexOf);
var $84b477ad334ab936$var$replace = $5Okwt(''.replace);
var $84b477ad334ab936$var$stringSlice = $5Okwt(''.slice);
var $84b477ad334ab936$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $bGtV7($84b477ad334ab936$var$nativeExec, re1, 'a');
    $bGtV7($84b477ad334ab936$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $84b477ad334ab936$var$UNSUPPORTED_Y = $jeN8V.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $84b477ad334ab936$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $84b477ad334ab936$var$PATCH = $84b477ad334ab936$var$UPDATES_LAST_INDEX_WRONG || $84b477ad334ab936$var$NPCG_INCLUDED || $84b477ad334ab936$var$UNSUPPORTED_Y || $ajlvS || $051u0;
var $84b477ad334ab936$var$setGroups = function(re, groups) {
    var object = re.groups = $7TMtU(null);
    for(var i = 0; i < groups.length; i++){
        var group = groups[i];
        object[group[0]] = re[group[1]];
    }
};
if ($84b477ad334ab936$var$PATCH) $84b477ad334ab936$var$patchedExec = function exec(string) {
    var re = this;
    var state = $84b477ad334ab936$require$getInternalState(re);
    var str = $jqSLA(string);
    var raw = state.raw;
    var result, reCopy, lastIndex;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $bGtV7($84b477ad334ab936$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        if (result && state.groups) $84b477ad334ab936$var$setGroups(result, state.groups);
        return result;
    }
    var groups = state.groups;
    var sticky = $84b477ad334ab936$var$UNSUPPORTED_Y && re.sticky;
    var flags = $bGtV7($1YgHc, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $84b477ad334ab936$var$replace(flags, 'y', '');
        if ($84b477ad334ab936$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $84b477ad334ab936$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        var prevChar = re.lastIndex > 0 && $84b477ad334ab936$var$charAt(str, re.lastIndex - 1);
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && prevChar !== '\n' && prevChar !== '\r' && prevChar !== '\u2028' && prevChar !== '\u2029')) {
            source = '(?: (?:' + source + '))';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($84b477ad334ab936$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($84b477ad334ab936$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    var match = $bGtV7($84b477ad334ab936$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = str;
            match[0] = $84b477ad334ab936$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($84b477ad334ab936$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($84b477ad334ab936$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $bGtV7($84b477ad334ab936$var$nativeReplace, match[0], reCopy, function() {
        for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) $84b477ad334ab936$var$setGroups(match, groups);
    return match;
};
module.exports = $84b477ad334ab936$var$patchedExec;

});
parcelRegister("jqSLA", function(module, exports) {
'use strict';

var $f9qXf = parcelRequire("f9qXf");
var $e25aed89b5529bcb$var$$String = String;
module.exports = function(argument) {
    if ($f9qXf(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $e25aed89b5529bcb$var$$String(argument);
};

});

parcelRegister("1YgHc", function(module, exports) {
'use strict';

var $hc2VB = parcelRequire("hc2VB");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = $hc2VB(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};

});

parcelRegister("jeN8V", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");

var $5tjRy = parcelRequire("5tjRy");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $e01571e6e2fb2ce3$var$$RegExp = $5tjRy.RegExp;
var $e01571e6e2fb2ce3$var$UNSUPPORTED_Y = $8lFU3(function() {
    var re = $e01571e6e2fb2ce3$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $e01571e6e2fb2ce3$var$MISSED_STICKY = $e01571e6e2fb2ce3$var$UNSUPPORTED_Y || $8lFU3(function() {
    return !$e01571e6e2fb2ce3$var$$RegExp('a', 'y').sticky;
});
var $e01571e6e2fb2ce3$var$BROKEN_CARET = $e01571e6e2fb2ce3$var$UNSUPPORTED_Y || $8lFU3(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $e01571e6e2fb2ce3$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
module.exports = {
    BROKEN_CARET: $e01571e6e2fb2ce3$var$BROKEN_CARET,
    MISSED_STICKY: $e01571e6e2fb2ce3$var$MISSED_STICKY,
    UNSUPPORTED_Y: $e01571e6e2fb2ce3$var$UNSUPPORTED_Y
};

});

parcelRegister("7TMtU", function(module, exports) {
'use strict';

var $hc2VB = parcelRequire("hc2VB");

var $6yuKb = parcelRequire("6yuKb");

var $jQUZd = parcelRequire("jQUZd");

var $dGabS = parcelRequire("dGabS");

var $fRIdv = parcelRequire("fRIdv");

var $1RN1j = parcelRequire("1RN1j");

var $bgRz0 = parcelRequire("bgRz0");
var $5c0346dde328cc4c$var$GT = '>';
var $5c0346dde328cc4c$var$LT = '<';
var $5c0346dde328cc4c$var$PROTOTYPE = 'prototype';
var $5c0346dde328cc4c$var$SCRIPT = 'script';
var $5c0346dde328cc4c$var$IE_PROTO = $bgRz0('IE_PROTO');
var $5c0346dde328cc4c$var$EmptyConstructor = function() {};
var $5c0346dde328cc4c$var$scriptTag = function(content) {
    return $5c0346dde328cc4c$var$LT + $5c0346dde328cc4c$var$SCRIPT + $5c0346dde328cc4c$var$GT + content + $5c0346dde328cc4c$var$LT + '/' + $5c0346dde328cc4c$var$SCRIPT + $5c0346dde328cc4c$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5c0346dde328cc4c$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5c0346dde328cc4c$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5c0346dde328cc4c$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $1RN1j('iframe');
    var JS = 'java' + $5c0346dde328cc4c$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $fRIdv.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5c0346dde328cc4c$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5c0346dde328cc4c$var$activeXDocument;
var $5c0346dde328cc4c$var$NullProtoObject = function() {
    try {
        $5c0346dde328cc4c$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $5c0346dde328cc4c$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $5c0346dde328cc4c$var$activeXDocument ? $5c0346dde328cc4c$var$NullProtoObjectViaActiveX($5c0346dde328cc4c$var$activeXDocument) // old IE
     : $5c0346dde328cc4c$var$NullProtoObjectViaIFrame() : $5c0346dde328cc4c$var$NullProtoObjectViaActiveX($5c0346dde328cc4c$var$activeXDocument); // WSH
    var length = $jQUZd.length;
    while(length--)delete $5c0346dde328cc4c$var$NullProtoObject[$5c0346dde328cc4c$var$PROTOTYPE][$jQUZd[length]];
    return $5c0346dde328cc4c$var$NullProtoObject();
};
$dGabS[$5c0346dde328cc4c$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5c0346dde328cc4c$var$EmptyConstructor[$5c0346dde328cc4c$var$PROTOTYPE] = $hc2VB(O);
        result = new $5c0346dde328cc4c$var$EmptyConstructor();
        $5c0346dde328cc4c$var$EmptyConstructor[$5c0346dde328cc4c$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5c0346dde328cc4c$var$IE_PROTO] = O;
    } else result = $5c0346dde328cc4c$var$NullProtoObject();
    return Properties === undefined ? result : $6yuKb.f(result, Properties);
};

});
parcelRegister("6yuKb", function(module, exports) {

$parcel$export(module.exports, "f", () => $4c5dc42699fd98c2$export$2d1720544b23b823, (v) => $4c5dc42699fd98c2$export$2d1720544b23b823 = v);
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $4c5dc42699fd98c2$export$2d1720544b23b823;
'use strict';

var $kxexm = parcelRequire("kxexm");

var $1TEKD = parcelRequire("1TEKD");

var $3RKYQ = parcelRequire("3RKYQ");

var $hc2VB = parcelRequire("hc2VB");

var $6CGth = parcelRequire("6CGth");

var $fJEBY = parcelRequire("fJEBY");
$4c5dc42699fd98c2$export$2d1720544b23b823 = $kxexm && !$1TEKD ? Object.defineProperties : function defineProperties(O, Properties) {
    $hc2VB(O);
    var props = $6CGth(Properties);
    var keys = $fJEBY(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$3RKYQ.f(O, key = keys[index++], props[key]);
    return O;
};

});
parcelRegister("fJEBY", function(module, exports) {
'use strict';

var $gUxdt = parcelRequire("gUxdt");

var $jQUZd = parcelRequire("jQUZd");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return $gUxdt(O, $jQUZd);
};

});



parcelRegister("ajlvS", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");

var $5tjRy = parcelRequire("5tjRy");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $781c5dc7c9eca9c6$var$$RegExp = $5tjRy.RegExp;
module.exports = $8lFU3(function() {
    var re = $781c5dc7c9eca9c6$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});

});

parcelRegister("051u0", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");

var $5tjRy = parcelRequire("5tjRy");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $00f19e426ee3510d$var$$RegExp = $5tjRy.RegExp;
module.exports = $8lFU3(function() {
    var re = $00f19e426ee3510d$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});

});




parcelRegister("kUr0l", function(module, exports) {
'use strict';

var $i6fx7 = parcelRequire("i6fx7");
var $f38dfc2bbe492300$require$charAt = $i6fx7.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function(S, index, unicode) {
    return index + (unicode ? $f38dfc2bbe492300$require$charAt(S, index).length || 1 : 1);
};

});
parcelRegister("i6fx7", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $fBlGn = parcelRequire("fBlGn");

var $jqSLA = parcelRequire("jqSLA");

var $gMtBp = parcelRequire("gMtBp");
var $d2d4d612d3120d2f$var$charAt = $5Okwt(''.charAt);
var $d2d4d612d3120d2f$var$charCodeAt = $5Okwt(''.charCodeAt);
var $d2d4d612d3120d2f$var$stringSlice = $5Okwt(''.slice);
var $d2d4d612d3120d2f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $jqSLA($gMtBp($this));
        var position = $fBlGn(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $d2d4d612d3120d2f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $d2d4d612d3120d2f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $d2d4d612d3120d2f$var$charAt(S, position) : first : CONVERT_TO_STRING ? $d2d4d612d3120d2f$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $d2d4d612d3120d2f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $d2d4d612d3120d2f$var$createMethod(true)
};

});


parcelRegister("5mspY", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $2HOcD = parcelRequire("2HOcD");

var $5Ef1u = parcelRequire("5Ef1u");

var $3hzbr = parcelRequire("3hzbr");

var $1YgHc = parcelRequire("1YgHc");
var $3e750d071daf7fea$var$RegExpPrototype = RegExp.prototype;
module.exports = $3hzbr.correct ? function(it) {
    return it.flags;
} : function(it) {
    return !$3hzbr.correct && $5Ef1u($3e750d071daf7fea$var$RegExpPrototype, it) && !$2HOcD(it, 'flags') ? $bGtV7($1YgHc, it) : it.flags;
};

});
parcelRegister("3hzbr", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $8lFU3 = parcelRequire("8lFU3");
// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $263e4058840467d2$var$RegExp = $5tjRy.RegExp;
var $263e4058840467d2$var$FLAGS_GETTER_IS_CORRECT = !$8lFU3(function() {
    var INDICES_SUPPORT = true;
    try {
        $263e4058840467d2$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($263e4058840467d2$var$RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
module.exports = {
    correct: $263e4058840467d2$var$FLAGS_GETTER_IS_CORRECT
};

});


parcelRegister("aRQrX", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $hc2VB = parcelRequire("hc2VB");

var $9GTLg = parcelRequire("9GTLg");

var $faIBy = parcelRequire("faIBy");

var $bonTf = parcelRequire("bonTf");
var $7e978a137c7643bb$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function(R, S) {
    var exec = R.exec;
    if ($9GTLg(exec)) {
        var result = $bGtV7(exec, R, S);
        if (result !== null) $hc2VB(result);
        return result;
    }
    if ($faIBy(R) === 'RegExp') return $bGtV7($bonTf, R, S);
    throw new $7e978a137c7643bb$var$$TypeError('RegExp#exec called on incompatible receiver');
};

});


parcelRegister("6jpE8", function(module, exports) {
'use strict';

var $5dW2a = parcelRequire("5dW2a");

var $bGtV7 = parcelRequire("bGtV7");

var $5Okwt = parcelRequire("5Okwt");

var $kZoi0 = parcelRequire("kZoi0");

var $8lFU3 = parcelRequire("8lFU3");

var $hc2VB = parcelRequire("hc2VB");

var $9GTLg = parcelRequire("9GTLg");

var $96Da4 = parcelRequire("96Da4");

var $fBlGn = parcelRequire("fBlGn");

var $6pMmI = parcelRequire("6pMmI");

var $jqSLA = parcelRequire("jqSLA");

var $gMtBp = parcelRequire("gMtBp");

var $kUr0l = parcelRequire("kUr0l");

var $kdzTk = parcelRequire("kdzTk");

var $iZSYz = parcelRequire("iZSYz");

var $5mspY = parcelRequire("5mspY");

var $aRQrX = parcelRequire("aRQrX");

var $blCy8 = parcelRequire("blCy8");
var $49886945b3dd8647$var$REPLACE = $blCy8('replace');
var $49886945b3dd8647$var$max = Math.max;
var $49886945b3dd8647$var$min = Math.min;
var $49886945b3dd8647$var$concat = $5Okwt([].concat);
var $49886945b3dd8647$var$push = $5Okwt([].push);
var $49886945b3dd8647$var$stringIndexOf = $5Okwt(''.indexOf);
var $49886945b3dd8647$var$stringSlice = $5Okwt(''.slice);
var $49886945b3dd8647$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $49886945b3dd8647$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $49886945b3dd8647$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$49886945b3dd8647$var$REPLACE]) return /./[$49886945b3dd8647$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $49886945b3dd8647$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$8lFU3(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$kZoi0('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $49886945b3dd8647$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $gMtBp(this);
            var replacer = $96Da4(searchValue) ? $kdzTk(searchValue, $49886945b3dd8647$var$REPLACE) : undefined;
            return replacer ? $bGtV7(replacer, searchValue, O, replaceValue) : $bGtV7(nativeReplace, $jqSLA(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $hc2VB(this);
            var S = $jqSLA(string);
            var functionalReplace = $9GTLg(replaceValue);
            if (!functionalReplace) replaceValue = $jqSLA(replaceValue);
            var flags = $jqSLA($5mspY(rx));
            if (typeof replaceValue == 'string' && !~$49886945b3dd8647$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) && !~$49886945b3dd8647$var$stringIndexOf(replaceValue, '$<') && !~$49886945b3dd8647$var$stringIndexOf(flags, 'y')) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var global = !!~$49886945b3dd8647$var$stringIndexOf(flags, 'g');
            var fullUnicode;
            if (global) {
                fullUnicode = !!~$49886945b3dd8647$var$stringIndexOf(flags, 'u') || !!~$49886945b3dd8647$var$stringIndexOf(flags, 'v');
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $aRQrX(rx, S);
                if (result === null) break;
                $49886945b3dd8647$var$push(results, result);
                if (!global) break;
                var matchStr = $jqSLA(result[0]);
                if (matchStr === '') rx.lastIndex = $kUr0l(S, $6pMmI(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $jqSLA(result[0]);
                var position = $49886945b3dd8647$var$max($49886945b3dd8647$var$min($fBlGn(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$49886945b3dd8647$var$push(captures, $49886945b3dd8647$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $49886945b3dd8647$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $49886945b3dd8647$var$push(replacerArgs, namedCaptures);
                    replacement = $jqSLA($5dW2a(replaceValue, undefined, replacerArgs));
                } else replacement = $iZSYz(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $49886945b3dd8647$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $49886945b3dd8647$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$49886945b3dd8647$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$49886945b3dd8647$var$REPLACE_KEEPS_$0 || $49886945b3dd8647$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

});
parcelRegister("iZSYz", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $dZoqA = parcelRequire("dZoqA");
var $dd48918eff616ea7$var$floor = Math.floor;
var $dd48918eff616ea7$var$charAt = $5Okwt(''.charAt);
var $dd48918eff616ea7$var$replace = $5Okwt(''.replace);
var $dd48918eff616ea7$var$stringSlice = $5Okwt(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $dd48918eff616ea7$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $dd48918eff616ea7$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $dd48918eff616ea7$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $dZoqA(namedCaptures);
        symbols = $dd48918eff616ea7$var$SUBSTITUTION_SYMBOLS;
    }
    return $dd48918eff616ea7$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($dd48918eff616ea7$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $dd48918eff616ea7$var$stringSlice(str, 0, position);
            case "'":
                return $dd48918eff616ea7$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$dd48918eff616ea7$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $dd48918eff616ea7$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $dd48918eff616ea7$var$charAt(ch, 1) : captures[f - 1] + $dd48918eff616ea7$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};

});


parcelRegister("gG87B", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $6c6m5 = parcelRequire("6c6m5");

var $9po1L = parcelRequire("9po1L");
var $c246de5ad637f35b$require$getOwnPropertyDescriptor = $9po1L.f;

var $6pMmI = parcelRequire("6pMmI");

var $jqSLA = parcelRequire("jqSLA");

var $bOpc8 = parcelRequire("bOpc8");

var $gMtBp = parcelRequire("gMtBp");

var $dmE1x = parcelRequire("dmE1x");

var $jfGLK = parcelRequire("jfGLK");
var $c246de5ad637f35b$var$stringSlice = $6c6m5(''.slice);
var $c246de5ad637f35b$var$min = Math.min;
var $c246de5ad637f35b$var$CORRECT_IS_REGEXP_LOGIC = $dmE1x('startsWith');
// https://github.com/zloirock/core-js/pull/702
var $c246de5ad637f35b$var$MDN_POLYFILL_BUG = !$jfGLK && !$c246de5ad637f35b$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $c246de5ad637f35b$require$getOwnPropertyDescriptor(String.prototype, 'startsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$hmx0d({
    target: 'String',
    proto: true,
    forced: !$c246de5ad637f35b$var$MDN_POLYFILL_BUG && !$c246de5ad637f35b$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $jqSLA($gMtBp(this));
        $bOpc8(searchString);
        var search = $jqSLA(searchString);
        var index = $6pMmI($c246de5ad637f35b$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        return $c246de5ad637f35b$var$stringSlice(that, index, index + search.length) === search;
    }
});

});
parcelRegister("bOpc8", function(module, exports) {
'use strict';

var $iJKo2 = parcelRequire("iJKo2");
var $8997e85c68cee939$var$$TypeError = TypeError;
module.exports = function(it) {
    if ($iJKo2(it)) throw new $8997e85c68cee939$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};

});
parcelRegister("iJKo2", function(module, exports) {
'use strict';

var $96Da4 = parcelRequire("96Da4");

var $faIBy = parcelRequire("faIBy");

var $blCy8 = parcelRequire("blCy8");
var $da406964b80f2672$var$MATCH = $blCy8('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function(it) {
    var isRegExp;
    return $96Da4(it) && ((isRegExp = it[$da406964b80f2672$var$MATCH]) !== undefined ? !!isRegExp : $faIBy(it) === 'RegExp');
};

});


parcelRegister("dmE1x", function(module, exports) {
'use strict';

var $blCy8 = parcelRequire("blCy8");
var $9bac6050c12c390e$var$MATCH = $blCy8('match');
module.exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        '/./'[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$9bac6050c12c390e$var$MATCH] = false;
            return '/./'[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};

});


parcelRegister("6Jv57", function(module, exports) {
'use strict';

var $6CGth = parcelRequire("6CGth");

var $lHUxa = parcelRequire("lHUxa");

var $1mwfF = parcelRequire("1mwfF");

var $51DEQ = parcelRequire("51DEQ");

var $3RKYQ = parcelRequire("3RKYQ");
var $4e6f0e2f01535c0d$require$defineProperty = $3RKYQ.f;

var $dg9bG = parcelRequire("dg9bG");

var $jcAoN = parcelRequire("jcAoN");

var $jfGLK = parcelRequire("jfGLK");

var $kxexm = parcelRequire("kxexm");
var $4e6f0e2f01535c0d$var$ARRAY_ITERATOR = 'Array Iterator';
var $4e6f0e2f01535c0d$var$setInternalState = $51DEQ.set;
var $4e6f0e2f01535c0d$var$getInternalState = $51DEQ.getterFor($4e6f0e2f01535c0d$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = $dg9bG(Array, 'Array', function(iterated, kind) {
    $4e6f0e2f01535c0d$var$setInternalState(this, {
        type: $4e6f0e2f01535c0d$var$ARRAY_ITERATOR,
        target: $6CGth(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $4e6f0e2f01535c0d$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $jcAoN(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $jcAoN(index, false);
        case 'values':
            return $jcAoN(target[index], false);
    }
    return $jcAoN([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $4e6f0e2f01535c0d$var$values = $1mwfF.Arguments = $1mwfF.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$lHUxa('keys');
$lHUxa('values');
$lHUxa('entries');
// V8 ~ Chrome 45- bug
if (!$jfGLK && $kxexm && $4e6f0e2f01535c0d$var$values.name !== 'values') try {
    $4e6f0e2f01535c0d$require$defineProperty($4e6f0e2f01535c0d$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}

});
parcelRegister("lHUxa", function(module, exports) {
'use strict';

var $blCy8 = parcelRequire("blCy8");

var $7TMtU = parcelRequire("7TMtU");

var $3RKYQ = parcelRequire("3RKYQ");
var $fcd977913fa5bb2d$require$defineProperty = $3RKYQ.f;
var $fcd977913fa5bb2d$var$UNSCOPABLES = $blCy8('unscopables');
var $fcd977913fa5bb2d$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($fcd977913fa5bb2d$var$ArrayPrototype[$fcd977913fa5bb2d$var$UNSCOPABLES] === undefined) $fcd977913fa5bb2d$require$defineProperty($fcd977913fa5bb2d$var$ArrayPrototype, $fcd977913fa5bb2d$var$UNSCOPABLES, {
    configurable: true,
    value: $7TMtU(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    $fcd977913fa5bb2d$var$ArrayPrototype[$fcd977913fa5bb2d$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("dg9bG", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $bGtV7 = parcelRequire("bGtV7");

var $jfGLK = parcelRequire("jfGLK");

var $b8MME = parcelRequire("b8MME");

var $9GTLg = parcelRequire("9GTLg");

var $36tCU = parcelRequire("36tCU");

var $eiOHr = parcelRequire("eiOHr");

var $86ypM = parcelRequire("86ypM");

var $4W9Kw = parcelRequire("4W9Kw");

var $bylnm = parcelRequire("bylnm");

var $5zwnU = parcelRequire("5zwnU");

var $blCy8 = parcelRequire("blCy8");

var $1mwfF = parcelRequire("1mwfF");

var $behkw = parcelRequire("behkw");
var $9a73e569966b34cd$var$PROPER_FUNCTION_NAME = $b8MME.PROPER;
var $9a73e569966b34cd$var$CONFIGURABLE_FUNCTION_NAME = $b8MME.CONFIGURABLE;
var $9a73e569966b34cd$var$IteratorPrototype = $behkw.IteratorPrototype;
var $9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS = $behkw.BUGGY_SAFARI_ITERATORS;
var $9a73e569966b34cd$var$ITERATOR = $blCy8('iterator');
var $9a73e569966b34cd$var$KEYS = 'keys';
var $9a73e569966b34cd$var$VALUES = 'values';
var $9a73e569966b34cd$var$ENTRIES = 'entries';
var $9a73e569966b34cd$var$returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $36tCU(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $9a73e569966b34cd$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $9a73e569966b34cd$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $9a73e569966b34cd$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$9a73e569966b34cd$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $eiOHr(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$jfGLK && $eiOHr(CurrentIteratorPrototype) !== $9a73e569966b34cd$var$IteratorPrototype) {
                if ($86ypM) $86ypM(CurrentIteratorPrototype, $9a73e569966b34cd$var$IteratorPrototype);
                else if (!$9GTLg(CurrentIteratorPrototype[$9a73e569966b34cd$var$ITERATOR])) $5zwnU(CurrentIteratorPrototype, $9a73e569966b34cd$var$ITERATOR, $9a73e569966b34cd$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $4W9Kw(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($jfGLK) $1mwfF[TO_STRING_TAG] = $9a73e569966b34cd$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($9a73e569966b34cd$var$PROPER_FUNCTION_NAME && DEFAULT === $9a73e569966b34cd$var$VALUES && nativeIterator && nativeIterator.name !== $9a73e569966b34cd$var$VALUES) {
        if (!$jfGLK && $9a73e569966b34cd$var$CONFIGURABLE_FUNCTION_NAME) $bylnm(IterablePrototype, 'name', $9a73e569966b34cd$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $bGtV7(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($9a73e569966b34cd$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($9a73e569966b34cd$var$KEYS),
            entries: getIterationMethod($9a73e569966b34cd$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $5zwnU(IterablePrototype, KEY, methods[KEY]);
        } else $hmx0d({
            target: NAME,
            proto: true,
            forced: $9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$jfGLK || FORCED) && IterablePrototype[$9a73e569966b34cd$var$ITERATOR] !== defaultIterator) $5zwnU(IterablePrototype, $9a73e569966b34cd$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $1mwfF[NAME] = defaultIterator;
    return methods;
};

});
parcelRegister("36tCU", function(module, exports) {
'use strict';

var $behkw = parcelRequire("behkw");
var $2428e9d9593354c3$require$IteratorPrototype = $behkw.IteratorPrototype;

var $7TMtU = parcelRequire("7TMtU");

var $fEYls = parcelRequire("fEYls");

var $4W9Kw = parcelRequire("4W9Kw");

var $1mwfF = parcelRequire("1mwfF");
var $2428e9d9593354c3$var$returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $7TMtU($2428e9d9593354c3$require$IteratorPrototype, {
        next: $fEYls(+!ENUMERABLE_NEXT, next)
    });
    $4W9Kw(IteratorConstructor, TO_STRING_TAG, false, true);
    $1mwfF[TO_STRING_TAG] = $2428e9d9593354c3$var$returnThis;
    return IteratorConstructor;
};

});
parcelRegister("behkw", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");

var $9GTLg = parcelRequire("9GTLg");

var $96Da4 = parcelRequire("96Da4");

var $7TMtU = parcelRequire("7TMtU");

var $eiOHr = parcelRequire("eiOHr");

var $5zwnU = parcelRequire("5zwnU");

var $blCy8 = parcelRequire("blCy8");

var $jfGLK = parcelRequire("jfGLK");
var $82ce71e2bd45bc6e$var$ITERATOR = $blCy8('iterator');
var $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $82ce71e2bd45bc6e$var$IteratorPrototype, $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype, $82ce71e2bd45bc6e$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $82ce71e2bd45bc6e$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $82ce71e2bd45bc6e$var$arrayIterator)) $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype = $eiOHr($eiOHr($82ce71e2bd45bc6e$var$arrayIterator));
        if ($82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $82ce71e2bd45bc6e$var$IteratorPrototype = $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $82ce71e2bd45bc6e$var$NEW_ITERATOR_PROTOTYPE = !$96Da4($82ce71e2bd45bc6e$var$IteratorPrototype) || $8lFU3(function() {
    var test = {};
    // FF44- legacy iterators case
    return $82ce71e2bd45bc6e$var$IteratorPrototype[$82ce71e2bd45bc6e$var$ITERATOR].call(test) !== test;
});
if ($82ce71e2bd45bc6e$var$NEW_ITERATOR_PROTOTYPE) $82ce71e2bd45bc6e$var$IteratorPrototype = {};
else if ($jfGLK) $82ce71e2bd45bc6e$var$IteratorPrototype = $7TMtU($82ce71e2bd45bc6e$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$9GTLg($82ce71e2bd45bc6e$var$IteratorPrototype[$82ce71e2bd45bc6e$var$ITERATOR])) $5zwnU($82ce71e2bd45bc6e$var$IteratorPrototype, $82ce71e2bd45bc6e$var$ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: $82ce71e2bd45bc6e$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS
};

});
parcelRegister("eiOHr", function(module, exports) {
'use strict';

var $2HOcD = parcelRequire("2HOcD");

var $9GTLg = parcelRequire("9GTLg");

var $dZoqA = parcelRequire("dZoqA");

var $bgRz0 = parcelRequire("bgRz0");

var $jDKge = parcelRequire("jDKge");
var $a69a130329c6de82$var$IE_PROTO = $bgRz0('IE_PROTO');
var $a69a130329c6de82$var$$Object = Object;
var $a69a130329c6de82$var$ObjectPrototype = $a69a130329c6de82$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = $jDKge ? $a69a130329c6de82$var$$Object.getPrototypeOf : function(O) {
    var object = $dZoqA(O);
    if ($2HOcD(object, $a69a130329c6de82$var$IE_PROTO)) return object[$a69a130329c6de82$var$IE_PROTO];
    var constructor = object.constructor;
    if ($9GTLg(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $a69a130329c6de82$var$$Object ? $a69a130329c6de82$var$ObjectPrototype : null;
};

});
parcelRegister("jDKge", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");
module.exports = !$8lFU3(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

});





parcelRegister("jcAoN", function(module, exports) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

});


parcelRegister("8ZxhT", function(module, exports) {
'use strict';

var $5tjRy = parcelRequire("5tjRy");

var $7YpjL = parcelRequire("7YpjL");

var $4oKez = parcelRequire("4oKez");

var $6Jv57 = parcelRequire("6Jv57");

var $bylnm = parcelRequire("bylnm");

var $4W9Kw = parcelRequire("4W9Kw");

var $blCy8 = parcelRequire("blCy8");
var $68bdd76fab12c913$var$ITERATOR = $blCy8('iterator');
var $68bdd76fab12c913$var$ArrayValues = $6Jv57.values;
var $68bdd76fab12c913$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$68bdd76fab12c913$var$ITERATOR] !== $68bdd76fab12c913$var$ArrayValues) try {
            $bylnm(CollectionPrototype, $68bdd76fab12c913$var$ITERATOR, $68bdd76fab12c913$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$68bdd76fab12c913$var$ITERATOR] = $68bdd76fab12c913$var$ArrayValues;
        }
        $4W9Kw(CollectionPrototype, COLLECTION_NAME, true);
        if ($7YpjL[COLLECTION_NAME]) for(var METHOD_NAME in $6Jv57){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $6Jv57[METHOD_NAME]) try {
                $bylnm(CollectionPrototype, METHOD_NAME, $6Jv57[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $6Jv57[METHOD_NAME];
            }
        }
    }
};
for(var $68bdd76fab12c913$var$COLLECTION_NAME in $7YpjL)$68bdd76fab12c913$var$handlePrototype($5tjRy[$68bdd76fab12c913$var$COLLECTION_NAME] && $5tjRy[$68bdd76fab12c913$var$COLLECTION_NAME].prototype, $68bdd76fab12c913$var$COLLECTION_NAME);
$68bdd76fab12c913$var$handlePrototype($4oKez, 'DOMTokenList');

});
parcelRegister("7YpjL", function(module, exports) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

});

parcelRegister("4oKez", function(module, exports) {
'use strict';

var $1RN1j = parcelRequire("1RN1j");
var $333d4473749958a7$var$classList = $1RN1j('span').classList;
var $333d4473749958a7$var$DOMTokenListPrototype = $333d4473749958a7$var$classList && $333d4473749958a7$var$classList.constructor && $333d4473749958a7$var$classList.constructor.prototype;
module.exports = $333d4473749958a7$var$DOMTokenListPrototype === Object.prototype ? undefined : $333d4473749958a7$var$DOMTokenListPrototype;

});


parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hqBy5", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $3JG6c = parcelRequire("3JG6c");
var $cb01fdcdbe1ae0df$require$$reduce = $3JG6c.left;

var $e2SPO = parcelRequire("e2SPO");

var $fkVCI = parcelRequire("fkVCI");

var $bKnXw = parcelRequire("bKnXw");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $cb01fdcdbe1ae0df$var$CHROME_BUG = !$bKnXw && $fkVCI > 79 && $fkVCI < 83;
var $cb01fdcdbe1ae0df$var$FORCED = $cb01fdcdbe1ae0df$var$CHROME_BUG || !$e2SPO('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$hmx0d({
    target: 'Array',
    proto: true,
    forced: $cb01fdcdbe1ae0df$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $cb01fdcdbe1ae0df$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});

});
parcelRegister("3JG6c", function(module, exports) {
'use strict';

var $eXHxq = parcelRequire("eXHxq");

var $dZoqA = parcelRequire("dZoqA");

var $bbbU8 = parcelRequire("bbbU8");

var $ptmgx = parcelRequire("ptmgx");
var $2b863b0991f0de5a$var$$TypeError = TypeError;
var $2b863b0991f0de5a$var$REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $2b863b0991f0de5a$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $dZoqA(that);
        var self = $bbbU8(O);
        var length = $ptmgx(O);
        $eXHxq(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $2b863b0991f0de5a$var$$TypeError($2b863b0991f0de5a$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $2b863b0991f0de5a$var$$TypeError($2b863b0991f0de5a$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $2b863b0991f0de5a$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $2b863b0991f0de5a$var$createMethod(true)
};

});

parcelRegister("e2SPO", function(module, exports) {
'use strict';

var $8lFU3 = parcelRequire("8lFU3");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $8lFU3(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

});


parcelRegister("7QN7n", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $6c6m5 = parcelRequire("6c6m5");

var $9po1L = parcelRequire("9po1L");
var $5b737d8668d9ed3d$require$getOwnPropertyDescriptor = $9po1L.f;

var $6pMmI = parcelRequire("6pMmI");

var $jqSLA = parcelRequire("jqSLA");

var $bOpc8 = parcelRequire("bOpc8");

var $gMtBp = parcelRequire("gMtBp");

var $dmE1x = parcelRequire("dmE1x");

var $jfGLK = parcelRequire("jfGLK");
var $5b737d8668d9ed3d$var$slice = $6c6m5(''.slice);
var $5b737d8668d9ed3d$var$min = Math.min;
var $5b737d8668d9ed3d$var$CORRECT_IS_REGEXP_LOGIC = $dmE1x('endsWith');
// https://github.com/zloirock/core-js/pull/702
var $5b737d8668d9ed3d$var$MDN_POLYFILL_BUG = !$jfGLK && !$5b737d8668d9ed3d$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $5b737d8668d9ed3d$require$getOwnPropertyDescriptor(String.prototype, 'endsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$hmx0d({
    target: 'String',
    proto: true,
    forced: !$5b737d8668d9ed3d$var$MDN_POLYFILL_BUG && !$5b737d8668d9ed3d$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $jqSLA($gMtBp(this));
        $bOpc8(searchString);
        var search = $jqSLA(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $5b737d8668d9ed3d$var$min($6pMmI(endPosition), len);
        return $5b737d8668d9ed3d$var$slice(that, end - search.length, end) === search;
    }
});

});

parcelRegister("6peZT", function(module, exports) {
'use strict';

var $bGtV7 = parcelRequire("bGtV7");

var $5Okwt = parcelRequire("5Okwt");

var $kZoi0 = parcelRequire("kZoi0");

var $hc2VB = parcelRequire("hc2VB");

var $96Da4 = parcelRequire("96Da4");

var $gMtBp = parcelRequire("gMtBp");

var $4IYe9 = parcelRequire("4IYe9");

var $kUr0l = parcelRequire("kUr0l");

var $6pMmI = parcelRequire("6pMmI");

var $jqSLA = parcelRequire("jqSLA");

var $kdzTk = parcelRequire("kdzTk");

var $5mspY = parcelRequire("5mspY");

var $aRQrX = parcelRequire("aRQrX");

var $jeN8V = parcelRequire("jeN8V");

var $8lFU3 = parcelRequire("8lFU3");
var $4aa0b6082c28cabb$var$UNSUPPORTED_Y = $jeN8V.UNSUPPORTED_Y;
var $4aa0b6082c28cabb$var$MAX_UINT32 = 0xFFFFFFFF;
var $4aa0b6082c28cabb$var$min = Math.min;
var $4aa0b6082c28cabb$var$push = $5Okwt([].push);
var $4aa0b6082c28cabb$var$stringSlice = $5Okwt(''.slice);
var $4aa0b6082c28cabb$var$stringIndexOf = $5Okwt(''.indexOf);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $4aa0b6082c28cabb$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$8lFU3(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});
var $4aa0b6082c28cabb$var$BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
'.'.split(/()()/).length > 1 || ''.split(/.?/).length;
// @@split logic
$kZoi0('split', function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit = '0'.split(undefined, 0).length ? function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $bGtV7(nativeSplit, this, separator, limit);
    } : nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $gMtBp(this);
            var splitter = $96Da4(separator) ? $kdzTk(separator, SPLIT) : undefined;
            return splitter ? $bGtV7(splitter, separator, O, limit) : $bGtV7(internalSplit, $jqSLA(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $hc2VB(this);
            var S = $jqSLA(string);
            if (!$4aa0b6082c28cabb$var$BUGGY) {
                var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                if (res.done) return res.value;
            }
            var C = $4IYe9(rx, RegExp);
            var flags = $jqSLA($5mspY(rx));
            var unicodeMatching = !!~$4aa0b6082c28cabb$var$stringIndexOf(flags, 'u') || !!~$4aa0b6082c28cabb$var$stringIndexOf(flags, 'v');
            if ($4aa0b6082c28cabb$var$UNSUPPORTED_Y) {
                if (!~$4aa0b6082c28cabb$var$stringIndexOf(flags, 'g')) flags += 'g';
            } else if (!~$4aa0b6082c28cabb$var$stringIndexOf(flags, 'y')) flags += 'y';
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($4aa0b6082c28cabb$var$UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
            var lim = limit === undefined ? $4aa0b6082c28cabb$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $aRQrX(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $4aa0b6082c28cabb$var$UNSUPPORTED_Y ? 0 : q;
                var z = $aRQrX(splitter, $4aa0b6082c28cabb$var$UNSUPPORTED_Y ? $4aa0b6082c28cabb$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $4aa0b6082c28cabb$var$min($6pMmI(splitter.lastIndex + ($4aa0b6082c28cabb$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $kUr0l(S, q, unicodeMatching);
                else {
                    $4aa0b6082c28cabb$var$push(A, $4aa0b6082c28cabb$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $4aa0b6082c28cabb$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $4aa0b6082c28cabb$var$push(A, $4aa0b6082c28cabb$var$stringSlice(S, p));
            return A;
        }
    ];
}, $4aa0b6082c28cabb$var$BUGGY || !$4aa0b6082c28cabb$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $4aa0b6082c28cabb$var$UNSUPPORTED_Y);

});

parcelRegister("ctRqH", function(module, exports) {

var $eR26l = parcelRequire("eR26l");
var $9161a37c5225314c$var$root = typeof window === 'undefined' ? $parcel$global : window, $9161a37c5225314c$var$vendors = [
    'moz',
    'webkit'
], $9161a37c5225314c$var$suffix = 'AnimationFrame', $9161a37c5225314c$var$raf = $9161a37c5225314c$var$root['request' + $9161a37c5225314c$var$suffix], $9161a37c5225314c$var$caf = $9161a37c5225314c$var$root['cancel' + $9161a37c5225314c$var$suffix] || $9161a37c5225314c$var$root['cancelRequest' + $9161a37c5225314c$var$suffix];
for(var $9161a37c5225314c$var$i = 0; !$9161a37c5225314c$var$raf && $9161a37c5225314c$var$i < $9161a37c5225314c$var$vendors.length; $9161a37c5225314c$var$i++){
    $9161a37c5225314c$var$raf = $9161a37c5225314c$var$root[$9161a37c5225314c$var$vendors[$9161a37c5225314c$var$i] + 'Request' + $9161a37c5225314c$var$suffix];
    $9161a37c5225314c$var$caf = $9161a37c5225314c$var$root[$9161a37c5225314c$var$vendors[$9161a37c5225314c$var$i] + 'Cancel' + $9161a37c5225314c$var$suffix] || $9161a37c5225314c$var$root[$9161a37c5225314c$var$vendors[$9161a37c5225314c$var$i] + 'CancelRequest' + $9161a37c5225314c$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$9161a37c5225314c$var$raf || !$9161a37c5225314c$var$caf) {
    var $9161a37c5225314c$var$last = 0, $9161a37c5225314c$var$id = 0, $9161a37c5225314c$var$queue = [], $9161a37c5225314c$var$frameDuration = 1000 / 60;
    $9161a37c5225314c$var$raf = function(callback) {
        if ($9161a37c5225314c$var$queue.length === 0) {
            var _now = $eR26l(), next = Math.max(0, $9161a37c5225314c$var$frameDuration - (_now - $9161a37c5225314c$var$last));
            $9161a37c5225314c$var$last = next + _now;
            setTimeout(function() {
                var cp = $9161a37c5225314c$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $9161a37c5225314c$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($9161a37c5225314c$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $9161a37c5225314c$var$queue.push({
            handle: ++$9161a37c5225314c$var$id,
            callback: callback,
            cancelled: false
        });
        return $9161a37c5225314c$var$id;
    };
    $9161a37c5225314c$var$caf = function(handle) {
        for(var i = 0; i < $9161a37c5225314c$var$queue.length; i++)if ($9161a37c5225314c$var$queue[i].handle === handle) $9161a37c5225314c$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $9161a37c5225314c$var$raf.call($9161a37c5225314c$var$root, fn);
};
module.exports.cancel = function() {
    $9161a37c5225314c$var$caf.apply($9161a37c5225314c$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $9161a37c5225314c$var$root;
    object.requestAnimationFrame = $9161a37c5225314c$var$raf;
    object.cancelAnimationFrame = $9161a37c5225314c$var$caf;
};

});
parcelRegister("eR26l", function(module, exports) {
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("2lVA1", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $fiz21 = parcelRequire("fiz21");
var $1b6a351d5fe7744a$require$$trim = $fiz21.trim;

var $4xx7a = parcelRequire("4xx7a");
// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$hmx0d({
    target: 'String',
    proto: true,
    forced: $4xx7a('trim')
}, {
    trim: function trim() {
        return $1b6a351d5fe7744a$require$$trim(this);
    }
});

});
parcelRegister("fiz21", function(module, exports) {
'use strict';

var $5Okwt = parcelRequire("5Okwt");

var $gMtBp = parcelRequire("gMtBp");

var $jqSLA = parcelRequire("jqSLA");

var $cmHkW = parcelRequire("cmHkW");
var $b233b5fe34d0f4ed$var$replace = $5Okwt(''.replace);
var $b233b5fe34d0f4ed$var$ltrim = RegExp('^[' + $cmHkW + ']+');
var $b233b5fe34d0f4ed$var$rtrim = RegExp('(^|[^' + $cmHkW + '])[' + $cmHkW + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $b233b5fe34d0f4ed$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $jqSLA($gMtBp($this));
        if (TYPE & 1) string = $b233b5fe34d0f4ed$var$replace(string, $b233b5fe34d0f4ed$var$ltrim, '');
        if (TYPE & 2) string = $b233b5fe34d0f4ed$var$replace(string, $b233b5fe34d0f4ed$var$rtrim, '$1');
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $b233b5fe34d0f4ed$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $b233b5fe34d0f4ed$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $b233b5fe34d0f4ed$var$createMethod(3)
};

});
parcelRegister("cmHkW", function(module, exports) {
'use strict';
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("4xx7a", function(module, exports) {
'use strict';

var $b8MME = parcelRequire("b8MME");
var $34e3ee5cd9ff4dfe$require$PROPER_FUNCTION_NAME = $b8MME.PROPER;

var $8lFU3 = parcelRequire("8lFU3");

var $cmHkW = parcelRequire("cmHkW");
var $34e3ee5cd9ff4dfe$var$non = '\u200B\u0085\u180E';
// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function(METHOD_NAME) {
    return $8lFU3(function() {
        return !!$cmHkW[METHOD_NAME]() || $34e3ee5cd9ff4dfe$var$non[METHOD_NAME]() !== $34e3ee5cd9ff4dfe$var$non || $34e3ee5cd9ff4dfe$require$PROPER_FUNCTION_NAME && $cmHkW[METHOD_NAME].name !== METHOD_NAME;
    });
};

});


parcelRegister("4VIYO", function(module, exports) {
/*
	Based on rgbcolor.js by Stoyan Stefanov <sstoo@gmail.com>
	http://www.phpied.com/rgb-color-parser-in-javascript/
*/ module.exports = function(color_string) {
    this.ok = false;
    this.alpha = 1.0;
    // strip any leading #
    if (color_string.charAt(0) == '#') color_string = color_string.substr(1, 6);
    color_string = color_string.replace(/ /g, '');
    color_string = color_string.toLowerCase();
    // before getting into regexps, try simple matches
    // and overwrite the input
    var simple_colors = {
        aliceblue: 'f0f8ff',
        antiquewhite: 'faebd7',
        aqua: '00ffff',
        aquamarine: '7fffd4',
        azure: 'f0ffff',
        beige: 'f5f5dc',
        bisque: 'ffe4c4',
        black: '000000',
        blanchedalmond: 'ffebcd',
        blue: '0000ff',
        blueviolet: '8a2be2',
        brown: 'a52a2a',
        burlywood: 'deb887',
        cadetblue: '5f9ea0',
        chartreuse: '7fff00',
        chocolate: 'd2691e',
        coral: 'ff7f50',
        cornflowerblue: '6495ed',
        cornsilk: 'fff8dc',
        crimson: 'dc143c',
        cyan: '00ffff',
        darkblue: '00008b',
        darkcyan: '008b8b',
        darkgoldenrod: 'b8860b',
        darkgray: 'a9a9a9',
        darkgreen: '006400',
        darkkhaki: 'bdb76b',
        darkmagenta: '8b008b',
        darkolivegreen: '556b2f',
        darkorange: 'ff8c00',
        darkorchid: '9932cc',
        darkred: '8b0000',
        darksalmon: 'e9967a',
        darkseagreen: '8fbc8f',
        darkslateblue: '483d8b',
        darkslategray: '2f4f4f',
        darkturquoise: '00ced1',
        darkviolet: '9400d3',
        deeppink: 'ff1493',
        deepskyblue: '00bfff',
        dimgray: '696969',
        dodgerblue: '1e90ff',
        feldspar: 'd19275',
        firebrick: 'b22222',
        floralwhite: 'fffaf0',
        forestgreen: '228b22',
        fuchsia: 'ff00ff',
        gainsboro: 'dcdcdc',
        ghostwhite: 'f8f8ff',
        gold: 'ffd700',
        goldenrod: 'daa520',
        gray: '808080',
        green: '008000',
        greenyellow: 'adff2f',
        honeydew: 'f0fff0',
        hotpink: 'ff69b4',
        indianred: 'cd5c5c',
        indigo: '4b0082',
        ivory: 'fffff0',
        khaki: 'f0e68c',
        lavender: 'e6e6fa',
        lavenderblush: 'fff0f5',
        lawngreen: '7cfc00',
        lemonchiffon: 'fffacd',
        lightblue: 'add8e6',
        lightcoral: 'f08080',
        lightcyan: 'e0ffff',
        lightgoldenrodyellow: 'fafad2',
        lightgrey: 'd3d3d3',
        lightgreen: '90ee90',
        lightpink: 'ffb6c1',
        lightsalmon: 'ffa07a',
        lightseagreen: '20b2aa',
        lightskyblue: '87cefa',
        lightslateblue: '8470ff',
        lightslategray: '778899',
        lightsteelblue: 'b0c4de',
        lightyellow: 'ffffe0',
        lime: '00ff00',
        limegreen: '32cd32',
        linen: 'faf0e6',
        magenta: 'ff00ff',
        maroon: '800000',
        mediumaquamarine: '66cdaa',
        mediumblue: '0000cd',
        mediumorchid: 'ba55d3',
        mediumpurple: '9370d8',
        mediumseagreen: '3cb371',
        mediumslateblue: '7b68ee',
        mediumspringgreen: '00fa9a',
        mediumturquoise: '48d1cc',
        mediumvioletred: 'c71585',
        midnightblue: '191970',
        mintcream: 'f5fffa',
        mistyrose: 'ffe4e1',
        moccasin: 'ffe4b5',
        navajowhite: 'ffdead',
        navy: '000080',
        oldlace: 'fdf5e6',
        olive: '808000',
        olivedrab: '6b8e23',
        orange: 'ffa500',
        orangered: 'ff4500',
        orchid: 'da70d6',
        palegoldenrod: 'eee8aa',
        palegreen: '98fb98',
        paleturquoise: 'afeeee',
        palevioletred: 'd87093',
        papayawhip: 'ffefd5',
        peachpuff: 'ffdab9',
        peru: 'cd853f',
        pink: 'ffc0cb',
        plum: 'dda0dd',
        powderblue: 'b0e0e6',
        purple: '800080',
        rebeccapurple: '663399',
        red: 'ff0000',
        rosybrown: 'bc8f8f',
        royalblue: '4169e1',
        saddlebrown: '8b4513',
        salmon: 'fa8072',
        sandybrown: 'f4a460',
        seagreen: '2e8b57',
        seashell: 'fff5ee',
        sienna: 'a0522d',
        silver: 'c0c0c0',
        skyblue: '87ceeb',
        slateblue: '6a5acd',
        slategray: '708090',
        snow: 'fffafa',
        springgreen: '00ff7f',
        steelblue: '4682b4',
        tan: 'd2b48c',
        teal: '008080',
        thistle: 'd8bfd8',
        tomato: 'ff6347',
        turquoise: '40e0d0',
        violet: 'ee82ee',
        violetred: 'd02090',
        wheat: 'f5deb3',
        white: 'ffffff',
        whitesmoke: 'f5f5f5',
        yellow: 'ffff00',
        yellowgreen: '9acd32'
    };
    color_string = simple_colors[color_string] || color_string;
    // emd of simple type-in colors
    // array of color definition objects
    var color_defs = [
        {
            re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
            example: [
                'rgba(123, 234, 45, 0.8)',
                'rgba(255,234,245,1.0)'
            ],
            process: function(bits) {
                return [
                    parseInt(bits[1]),
                    parseInt(bits[2]),
                    parseInt(bits[3]),
                    parseFloat(bits[4])
                ];
            }
        },
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                'rgb(123, 234, 45)',
                'rgb(255,234,245)'
            ],
            process: function(bits) {
                return [
                    parseInt(bits[1]),
                    parseInt(bits[2]),
                    parseInt(bits[3])
                ];
            }
        },
        {
            re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            example: [
                '#00ff00',
                '336699'
            ],
            process: function(bits) {
                return [
                    parseInt(bits[1], 16),
                    parseInt(bits[2], 16),
                    parseInt(bits[3], 16)
                ];
            }
        },
        {
            re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            example: [
                '#fb0',
                'f0f'
            ],
            process: function(bits) {
                return [
                    parseInt(bits[1] + bits[1], 16),
                    parseInt(bits[2] + bits[2], 16),
                    parseInt(bits[3] + bits[3], 16)
                ];
            }
        }
    ];
    // search through the definitions to find a match
    for(var i = 0; i < color_defs.length; i++){
        var re = color_defs[i].re;
        var processor = color_defs[i].process;
        var bits = re.exec(color_string);
        if (bits) {
            var channels = processor(bits);
            this.r = channels[0];
            this.g = channels[1];
            this.b = channels[2];
            if (channels.length > 3) this.alpha = channels[3];
            this.ok = true;
        }
    }
    // validate/cleanup values
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r;
    this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g;
    this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
    this.alpha = this.alpha < 0 ? 0 : this.alpha > 1.0 || isNaN(this.alpha) ? 1.0 : this.alpha;
    // some getters
    this.toRGB = function() {
        return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
    };
    this.toRGBA = function() {
        return 'rgba(' + this.r + ', ' + this.g + ', ' + this.b + ', ' + this.alpha + ')';
    };
    this.toHex = function() {
        var r = this.r.toString(16);
        var g = this.g.toString(16);
        var b = this.b.toString(16);
        if (r.length == 1) r = '0' + r;
        if (g.length == 1) g = '0' + g;
        if (b.length == 1) b = '0' + b;
        return '#' + r + g + b;
    };
    // help
    this.getHelpXML = function() {
        var examples = new Array();
        // add regexps
        for(var i = 0; i < color_defs.length; i++){
            var example = color_defs[i].example;
            for(var j = 0; j < example.length; j++)examples[examples.length] = example[j];
        }
        // add type-in colors
        for(var sc in simple_colors)examples[examples.length] = sc;
        var xml = document.createElement('ul');
        xml.setAttribute('id', 'rgbcolor-examples');
        for(var i = 0; i < examples.length; i++)try {
            var list_item = document.createElement('li');
            var list_color = new RGBColor(examples[i]);
            var example_div = document.createElement('div');
            example_div.style.cssText = "margin: 3px; border: 1px solid black; background:" + list_color.toHex() + '; ' + 'color:' + list_color.toHex();
            example_div.appendChild(document.createTextNode('test'));
            var list_item_value = document.createTextNode(' ' + examples[i] + ' -> ' + list_color.toRGB() + ' -> ' + list_color.toHex());
            list_item.appendChild(example_div);
            list_item.appendChild(list_item_value);
            xml.appendChild(list_item);
        } catch (e) {}
        return xml;
    };
};

});

parcelRegister("lc3S4", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $6c6m5 = parcelRequire("6c6m5");

var $kBDFQ = parcelRequire("kBDFQ");
var $f6ddb8b44f7aa451$require$$indexOf = $kBDFQ.indexOf;

var $e2SPO = parcelRequire("e2SPO");
var $f6ddb8b44f7aa451$var$nativeIndexOf = $6c6m5([].indexOf);
var $f6ddb8b44f7aa451$var$NEGATIVE_ZERO = !!$f6ddb8b44f7aa451$var$nativeIndexOf && 1 / $f6ddb8b44f7aa451$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $f6ddb8b44f7aa451$var$FORCED = $f6ddb8b44f7aa451$var$NEGATIVE_ZERO || !$e2SPO('indexOf');
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$hmx0d({
    target: 'Array',
    proto: true,
    forced: $f6ddb8b44f7aa451$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $f6ddb8b44f7aa451$var$NEGATIVE_ZERO ? $f6ddb8b44f7aa451$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $f6ddb8b44f7aa451$require$$indexOf(this, searchElement, fromIndex);
    }
});

});

parcelRegister("j30OU", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $5Okwt = parcelRequire("5Okwt");

var $bOpc8 = parcelRequire("bOpc8");

var $gMtBp = parcelRequire("gMtBp");

var $jqSLA = parcelRequire("jqSLA");

var $dmE1x = parcelRequire("dmE1x");
var $dddeef0247751a19$var$stringIndexOf = $5Okwt(''.indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$hmx0d({
    target: 'String',
    proto: true,
    forced: !$dmE1x('includes')
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$dddeef0247751a19$var$stringIndexOf($jqSLA($gMtBp(this)), $jqSLA($bOpc8(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});

});

parcelRegister("fgEtE", function(module, exports) {
'use strict';

var $hmx0d = parcelRequire("hmx0d");

var $5Okwt = parcelRequire("5Okwt");

var $h6ycM = parcelRequire("h6ycM");
var $b1d7bf90b7292489$var$nativeReverse = $5Okwt([].reverse);
var $b1d7bf90b7292489$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$hmx0d({
    target: 'Array',
    proto: true,
    forced: String($b1d7bf90b7292489$var$test) === String($b1d7bf90b7292489$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($h6ycM(this)) this.length = this.length;
        return $b1d7bf90b7292489$var$nativeReverse(this);
    }
});

});
parcelRegister("h6ycM", function(module, exports) {
'use strict';

var $faIBy = parcelRequire("faIBy");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return $faIBy(argument) === 'Array';
};

});


parcelRegister("68e7U", function(module, exports) {

$parcel$export(module.exports, "SVGPathData", () => $476e72a94ce3adba$export$7b924f12d9cdca0a);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $476e72a94ce3adba$var$t = function(r, e) {
    return ($476e72a94ce3adba$var$t = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, r) {
        t.__proto__ = r;
    } || function(t, r) {
        for(var e in r)Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
    })(r, e);
};
function $476e72a94ce3adba$var$r(r, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function i() {
        this.constructor = r;
    }
    $476e72a94ce3adba$var$t(r, e), r.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
}
function $476e72a94ce3adba$export$bf3575705b57a51a(t) {
    var r = "";
    Array.isArray(t) || (t = [
        t
    ]);
    for(var e = 0; e < t.length; e++){
        var i = t[e];
        if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.CLOSE_PATH) r += "z";
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO) r += (i.relative ? "h" : "H") + i.x;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO) r += (i.relative ? "v" : "V") + i.y;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO) r += (i.relative ? "m" : "M") + i.x + " " + i.y;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO) r += (i.relative ? "l" : "L") + i.x + " " + i.y;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO) r += (i.relative ? "c" : "C") + i.x1 + " " + i.y1 + " " + i.x2 + " " + i.y2 + " " + i.x + " " + i.y;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO) r += (i.relative ? "s" : "S") + i.x2 + " " + i.y2 + " " + i.x + " " + i.y;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO) r += (i.relative ? "q" : "Q") + i.x1 + " " + i.y1 + " " + i.x + " " + i.y;
        else if (i.type === $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO) r += (i.relative ? "t" : "T") + i.x + " " + i.y;
        else {
            if (i.type !== $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC) throw new Error('Unexpected command type "' + i.type + '" at index ' + e + ".");
            r += (i.relative ? "a" : "A") + i.rX + " " + i.rY + " " + i.xRot + " " + +i.lArcFlag + " " + +i.sweepFlag + " " + i.x + " " + i.y;
        }
    }
    return r;
}
function $476e72a94ce3adba$var$i(t, r) {
    var e = t[0], i = t[1];
    return [
        e * Math.cos(r) - i * Math.sin(r),
        e * Math.sin(r) + i * Math.cos(r)
    ];
}
function $476e72a94ce3adba$var$a() {
    for(var t = [], r = 0; r < arguments.length; r++)t[r] = arguments[r];
    for(var e = 0; e < t.length; e++)if ("number" != typeof t[e]) throw new Error("assertNumbers arguments[" + e + "] is not a number. " + typeof t[e] + " == typeof " + t[e]);
    return !0;
}
var $476e72a94ce3adba$var$n = Math.PI;
function $476e72a94ce3adba$var$o(t, r, e) {
    t.lArcFlag = 0 === t.lArcFlag ? 0 : 1, t.sweepFlag = 0 === t.sweepFlag ? 0 : 1;
    var a = t.rX, o = t.rY, s = t.x, u = t.y;
    a = Math.abs(t.rX), o = Math.abs(t.rY);
    var h = $476e72a94ce3adba$var$i([
        (r - s) / 2,
        (e - u) / 2
    ], -t.xRot / 180 * $476e72a94ce3adba$var$n), c = h[0], y = h[1], p = Math.pow(c, 2) / Math.pow(a, 2) + Math.pow(y, 2) / Math.pow(o, 2);
    1 < p && (a *= Math.sqrt(p), o *= Math.sqrt(p)), t.rX = a, t.rY = o;
    var m = Math.pow(a, 2) * Math.pow(y, 2) + Math.pow(o, 2) * Math.pow(c, 2), O = (t.lArcFlag !== t.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(a, 2) * Math.pow(o, 2) - m) / m)), l = a * y / o * O, T = -o * c / a * O, v = $476e72a94ce3adba$var$i([
        l,
        T
    ], t.xRot / 180 * $476e72a94ce3adba$var$n);
    t.cX = v[0] + (r + s) / 2, t.cY = v[1] + (e + u) / 2, t.phi1 = Math.atan2((y - T) / o, (c - l) / a), t.phi2 = Math.atan2((-y - T) / o, (-c - l) / a), 0 === t.sweepFlag && t.phi2 > t.phi1 && (t.phi2 -= 2 * $476e72a94ce3adba$var$n), 1 === t.sweepFlag && t.phi2 < t.phi1 && (t.phi2 += 2 * $476e72a94ce3adba$var$n), t.phi1 *= 180 / $476e72a94ce3adba$var$n, t.phi2 *= 180 / $476e72a94ce3adba$var$n;
}
function $476e72a94ce3adba$var$s(t, r, e) {
    $476e72a94ce3adba$var$a(t, r, e);
    var i = t * t + r * r - e * e;
    if (0 > i) return [];
    if (0 === i) return [
        [
            t * e / (t * t + r * r),
            r * e / (t * t + r * r)
        ]
    ];
    var n = Math.sqrt(i);
    return [
        [
            (t * e + r * n) / (t * t + r * r),
            (r * e - t * n) / (t * t + r * r)
        ],
        [
            (t * e - r * n) / (t * t + r * r),
            (r * e + t * n) / (t * t + r * r)
        ]
    ];
}
var $476e72a94ce3adba$export$acab2bba24699133, $476e72a94ce3adba$var$h = Math.PI / 180;
function $476e72a94ce3adba$var$c(t, r, e) {
    return (1 - e) * t + e * r;
}
function $476e72a94ce3adba$var$y(t, r, e, i) {
    return t + Math.cos(i / 180 * $476e72a94ce3adba$var$n) * r + Math.sin(i / 180 * $476e72a94ce3adba$var$n) * e;
}
function $476e72a94ce3adba$var$p(t, r, e, i) {
    var a = 1e-6, n = r - t, o = e - r, s = 3 * n + 3 * (i - e) - 6 * o, u = 6 * (o - n), h = 3 * n;
    return Math.abs(s) < a ? [
        -h / u
    ] : function(t, r, e) {
        void 0 === e && (e = 1e-6);
        var i = t * t / 4 - r;
        if (i < -e) return [];
        if (i <= e) return [
            -t / 2
        ];
        var a = Math.sqrt(i);
        return [
            -t / 2 - a,
            -t / 2 + a
        ];
    }(u / s, h / s, a);
}
function $476e72a94ce3adba$var$m(t, r, e, i, a) {
    var n = 1 - a;
    return t * (n * n * n) + r * (3 * n * n * a) + e * (3 * n * a * a) + i * (a * a * a);
}
!function(t) {
    function r() {
        return u(function(t, r, e) {
            return t.relative && (void 0 !== t.x1 && (t.x1 += r), void 0 !== t.y1 && (t.y1 += e), void 0 !== t.x2 && (t.x2 += r), void 0 !== t.y2 && (t.y2 += e), void 0 !== t.x && (t.x += r), void 0 !== t.y && (t.y += e), t.relative = !1), t;
        });
    }
    function e() {
        var t = NaN, r = NaN, e = NaN, i = NaN;
        return u(function(a, n, o) {
            return a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO && (a.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO, t = isNaN(t) ? n : t, r = isNaN(r) ? o : r, a.x1 = a.relative ? n - t : 2 * n - t, a.y1 = a.relative ? o - r : 2 * o - r), a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO ? (t = a.relative ? n + a.x2 : a.x2, r = a.relative ? o + a.y2 : a.y2) : (t = NaN, r = NaN), a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO && (a.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO, e = isNaN(e) ? n : e, i = isNaN(i) ? o : i, a.x1 = a.relative ? n - e : 2 * n - e, a.y1 = a.relative ? o - i : 2 * o - i), a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO ? (e = a.relative ? n + a.x1 : a.x1, i = a.relative ? o + a.y1 : a.y1) : (e = NaN, i = NaN), a;
        });
    }
    function n() {
        var t = NaN, r = NaN;
        return u(function(e, i, a) {
            if (e.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO && (e.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO, t = isNaN(t) ? i : t, r = isNaN(r) ? a : r, e.x1 = e.relative ? i - t : 2 * i - t, e.y1 = e.relative ? a - r : 2 * a - r), e.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO) {
                t = e.relative ? i + e.x1 : e.x1, r = e.relative ? a + e.y1 : e.y1;
                var n = e.x1, o = e.y1;
                e.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO, e.x1 = ((e.relative ? 0 : i) + 2 * n) / 3, e.y1 = ((e.relative ? 0 : a) + 2 * o) / 3, e.x2 = (e.x + 2 * n) / 3, e.y2 = (e.y + 2 * o) / 3;
            } else t = NaN, r = NaN;
            return e;
        });
    }
    function u(t) {
        var r = 0, e = 0, i = NaN, a = NaN;
        return function(n) {
            if (isNaN(i) && !(n.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO)) throw new Error("path must start with moveto");
            var o = t(n, r, e, i, a);
            return n.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.CLOSE_PATH && (r = i, e = a), void 0 !== n.x && (r = n.relative ? r + n.x : n.x), void 0 !== n.y && (e = n.relative ? e + n.y : n.y), n.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO && (i = r, a = e), o;
        };
    }
    function O(t, r, e, i, n, o) {
        return $476e72a94ce3adba$var$a(t, r, e, i, n, o), u(function(a, s, u, h) {
            var c = a.x1, y = a.x2, p = a.relative && !isNaN(h), m = void 0 !== a.x ? a.x : p ? 0 : s, O = void 0 !== a.y ? a.y : p ? 0 : u;
            function l(t) {
                return t * t;
            }
            a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO && 0 !== r && (a.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, a.y = a.relative ? 0 : u), a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO && 0 !== e && (a.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, a.x = a.relative ? 0 : s), void 0 !== a.x && (a.x = a.x * t + O * e + (p ? 0 : n)), void 0 !== a.y && (a.y = m * r + a.y * i + (p ? 0 : o)), void 0 !== a.x1 && (a.x1 = a.x1 * t + a.y1 * e + (p ? 0 : n)), void 0 !== a.y1 && (a.y1 = c * r + a.y1 * i + (p ? 0 : o)), void 0 !== a.x2 && (a.x2 = a.x2 * t + a.y2 * e + (p ? 0 : n)), void 0 !== a.y2 && (a.y2 = y * r + a.y2 * i + (p ? 0 : o));
            var T = t * i - r * e;
            if (void 0 !== a.xRot && (1 !== t || 0 !== r || 0 !== e || 1 !== i)) {
                if (0 === T) delete a.rX, delete a.rY, delete a.xRot, delete a.lArcFlag, delete a.sweepFlag, a.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO;
                else {
                    var v = a.xRot * Math.PI / 180, f = Math.sin(v), N = Math.cos(v), x = 1 / l(a.rX), d = 1 / l(a.rY), E = l(N) * x + l(f) * d, A = 2 * f * N * (x - d), C = l(f) * x + l(N) * d, M = E * i * i - A * r * i + C * r * r, R = A * (t * i + r * e) - 2 * (E * e * i + C * t * r), g = E * e * e - A * t * e + C * t * t, I = (Math.atan2(R, M - g) + Math.PI) % Math.PI / 2, S = Math.sin(I), L = Math.cos(I);
                    a.rX = Math.abs(T) / Math.sqrt(M * l(L) + R * S * L + g * l(S)), a.rY = Math.abs(T) / Math.sqrt(M * l(S) - R * S * L + g * l(L)), a.xRot = 180 * I / Math.PI;
                }
            }
            return void 0 !== a.sweepFlag && 0 > T && (a.sweepFlag = +!a.sweepFlag), a;
        });
    }
    function l() {
        return function(t) {
            var r = {};
            for(var e in t)r[e] = t[e];
            return r;
        };
    }
    t.ROUND = function(t) {
        function r(r) {
            return Math.round(r * t) / t;
        }
        return void 0 === t && (t = 1e13), $476e72a94ce3adba$var$a(t), function(t) {
            return void 0 !== t.x1 && (t.x1 = r(t.x1)), void 0 !== t.y1 && (t.y1 = r(t.y1)), void 0 !== t.x2 && (t.x2 = r(t.x2)), void 0 !== t.y2 && (t.y2 = r(t.y2)), void 0 !== t.x && (t.x = r(t.x)), void 0 !== t.y && (t.y = r(t.y)), void 0 !== t.rX && (t.rX = r(t.rX)), void 0 !== t.rY && (t.rY = r(t.rY)), t;
        };
    }, t.TO_ABS = r, t.TO_REL = function() {
        return u(function(t, r, e) {
            return t.relative || (void 0 !== t.x1 && (t.x1 -= r), void 0 !== t.y1 && (t.y1 -= e), void 0 !== t.x2 && (t.x2 -= r), void 0 !== t.y2 && (t.y2 -= e), void 0 !== t.x && (t.x -= r), void 0 !== t.y && (t.y -= e), t.relative = !0), t;
        });
    }, t.NORMALIZE_HVZ = function(t, r, e) {
        return void 0 === t && (t = !0), void 0 === r && (r = !0), void 0 === e && (e = !0), u(function(i, a, n, o, s) {
            if (isNaN(o) && !(i.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO)) throw new Error("path must start with moveto");
            return r && i.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO && (i.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, i.y = i.relative ? 0 : n), e && i.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO && (i.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, i.x = i.relative ? 0 : a), t && i.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.CLOSE_PATH && (i.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, i.x = i.relative ? o - a : o, i.y = i.relative ? s - n : s), i.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC && (0 === i.rX || 0 === i.rY) && (i.type = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, delete i.rX, delete i.rY, delete i.xRot, delete i.lArcFlag, delete i.sweepFlag), i;
        });
    }, t.NORMALIZE_ST = e, t.QT_TO_C = n, t.INFO = u, t.SANITIZE = function(t) {
        void 0 === t && (t = 0), $476e72a94ce3adba$var$a(t);
        var r = NaN, e = NaN, i = NaN, n = NaN;
        return u(function(a, o, s, u, h) {
            var c = Math.abs, y = !1, p = 0, m = 0;
            if (a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO && (p = isNaN(r) ? 0 : o - r, m = isNaN(e) ? 0 : s - e), a.type & ($476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO | $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO) ? (r = a.relative ? o + a.x2 : a.x2, e = a.relative ? s + a.y2 : a.y2) : (r = NaN, e = NaN), a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO ? (i = isNaN(i) ? o : 2 * o - i, n = isNaN(n) ? s : 2 * s - n) : a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO ? (i = a.relative ? o + a.x1 : a.x1, n = a.relative ? s + a.y1 : a.y2) : (i = NaN, n = NaN), a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_COMMANDS || a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC && (0 === a.rX || 0 === a.rY || !a.lArcFlag) || a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO || a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO || a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO || a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO) {
                var O = void 0 === a.x ? 0 : a.relative ? a.x : a.x - o, l = void 0 === a.y ? 0 : a.relative ? a.y : a.y - s;
                p = isNaN(i) ? void 0 === a.x1 ? p : a.relative ? a.x : a.x1 - o : i - o, m = isNaN(n) ? void 0 === a.y1 ? m : a.relative ? a.y : a.y1 - s : n - s;
                var T = void 0 === a.x2 ? 0 : a.relative ? a.x : a.x2 - o, v = void 0 === a.y2 ? 0 : a.relative ? a.y : a.y2 - s;
                c(O) <= t && c(l) <= t && c(p) <= t && c(m) <= t && c(T) <= t && c(v) <= t && (y = !0);
            }
            return a.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.CLOSE_PATH && c(o - u) <= t && c(s - h) <= t && (y = !0), y ? [] : a;
        });
    }, t.MATRIX = O, t.ROTATE = function(t, r, e) {
        void 0 === r && (r = 0), void 0 === e && (e = 0), $476e72a94ce3adba$var$a(t, r, e);
        var i = Math.sin(t), n = Math.cos(t);
        return O(n, i, -i, n, r - r * n + e * i, e - r * i - e * n);
    }, t.TRANSLATE = function(t, r) {
        return void 0 === r && (r = 0), $476e72a94ce3adba$var$a(t, r), O(1, 0, 0, 1, t, r);
    }, t.SCALE = function(t, r) {
        return void 0 === r && (r = t), $476e72a94ce3adba$var$a(t, r), O(t, 0, 0, r, 0, 0);
    }, t.SKEW_X = function(t) {
        return $476e72a94ce3adba$var$a(t), O(1, 0, Math.atan(t), 1, 0, 0);
    }, t.SKEW_Y = function(t) {
        return $476e72a94ce3adba$var$a(t), O(1, Math.atan(t), 0, 1, 0, 0);
    }, t.X_AXIS_SYMMETRY = function(t) {
        return void 0 === t && (t = 0), $476e72a94ce3adba$var$a(t), O(-1, 0, 0, 1, t, 0);
    }, t.Y_AXIS_SYMMETRY = function(t) {
        return void 0 === t && (t = 0), $476e72a94ce3adba$var$a(t), O(1, 0, 0, -1, 0, t);
    }, t.A_TO_C = function() {
        return u(function(t, r, e) {
            return $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC === t.type ? function(t, r, e) {
                var a, n, s, u;
                t.cX || $476e72a94ce3adba$var$o(t, r, e);
                for(var y = Math.min(t.phi1, t.phi2), p = Math.max(t.phi1, t.phi2) - y, m = Math.ceil(p / 90), O = new Array(m), l = r, T = e, v = 0; v < m; v++){
                    var f = $476e72a94ce3adba$var$c(t.phi1, t.phi2, v / m), N = $476e72a94ce3adba$var$c(t.phi1, t.phi2, (v + 1) / m), x = N - f, d = 4 / 3 * Math.tan(x * $476e72a94ce3adba$var$h / 4), E = [
                        Math.cos(f * $476e72a94ce3adba$var$h) - d * Math.sin(f * $476e72a94ce3adba$var$h),
                        Math.sin(f * $476e72a94ce3adba$var$h) + d * Math.cos(f * $476e72a94ce3adba$var$h)
                    ], A = E[0], C = E[1], M = [
                        Math.cos(N * $476e72a94ce3adba$var$h),
                        Math.sin(N * $476e72a94ce3adba$var$h)
                    ], R = M[0], g = M[1], I = [
                        R + d * Math.sin(N * $476e72a94ce3adba$var$h),
                        g - d * Math.cos(N * $476e72a94ce3adba$var$h)
                    ], S = I[0], L = I[1];
                    O[v] = {
                        relative: t.relative,
                        type: $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO
                    };
                    var H = function(r, e) {
                        var a = $476e72a94ce3adba$var$i([
                            r * t.rX,
                            e * t.rY
                        ], t.xRot), n = a[0], o = a[1];
                        return [
                            t.cX + n,
                            t.cY + o
                        ];
                    };
                    a = H(A, C), O[v].x1 = a[0], O[v].y1 = a[1], n = H(S, L), O[v].x2 = n[0], O[v].y2 = n[1], s = H(R, g), O[v].x = s[0], O[v].y = s[1], t.relative && (O[v].x1 -= l, O[v].y1 -= T, O[v].x2 -= l, O[v].y2 -= T, O[v].x -= l, O[v].y -= T), l = (u = [
                        O[v].x,
                        O[v].y
                    ])[0], T = u[1];
                }
                return O;
            }(t, t.relative ? 0 : r, t.relative ? 0 : e) : t;
        });
    }, t.ANNOTATE_ARCS = function() {
        return u(function(t, r, e) {
            return t.relative && (r = 0, e = 0), $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC === t.type && $476e72a94ce3adba$var$o(t, r, e), t;
        });
    }, t.CLONE = l, t.CALCULATE_BOUNDS = function() {
        var t = function(t) {
            var r = {};
            for(var e in t)r[e] = t[e];
            return r;
        }, i = r(), a = n(), h = e(), c = u(function(r, e, n) {
            var u = h(a(i(t(r))));
            function O(t) {
                t > c.maxX && (c.maxX = t), t < c.minX && (c.minX = t);
            }
            function l(t) {
                t > c.maxY && (c.maxY = t), t < c.minY && (c.minY = t);
            }
            if (u.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.DRAWING_COMMANDS && (O(e), l(n)), u.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO && O(u.x), u.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO && l(u.y), u.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO && (O(u.x), l(u.y)), u.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO) {
                O(u.x), l(u.y);
                for(var T = 0, v = $476e72a94ce3adba$var$p(e, u.x1, u.x2, u.x); T < v.length; T++)0 < (w = v[T]) && 1 > w && O($476e72a94ce3adba$var$m(e, u.x1, u.x2, u.x, w));
                for(var f = 0, N = $476e72a94ce3adba$var$p(n, u.y1, u.y2, u.y); f < N.length; f++)0 < (w = N[f]) && 1 > w && l($476e72a94ce3adba$var$m(n, u.y1, u.y2, u.y, w));
            }
            if (u.type & $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC) {
                O(u.x), l(u.y), $476e72a94ce3adba$var$o(u, e, n);
                for(var x = u.xRot / 180 * Math.PI, d = Math.cos(x) * u.rX, E = Math.sin(x) * u.rX, A = -Math.sin(x) * u.rY, C = Math.cos(x) * u.rY, M = u.phi1 < u.phi2 ? [
                    u.phi1,
                    u.phi2
                ] : -180 > u.phi2 ? [
                    u.phi2 + 360,
                    u.phi1 + 360
                ] : [
                    u.phi2,
                    u.phi1
                ], R = M[0], g = M[1], I = function(t) {
                    var r = t[0], e = t[1], i = 180 * Math.atan2(e, r) / Math.PI;
                    return i < R ? i + 360 : i;
                }, S = 0, L = $476e72a94ce3adba$var$s(A, -d, 0).map(I); S < L.length; S++)(w = L[S]) > R && w < g && O($476e72a94ce3adba$var$y(u.cX, d, A, w));
                for(var H = 0, U = $476e72a94ce3adba$var$s(C, -E, 0).map(I); H < U.length; H++){
                    var w;
                    (w = U[H]) > R && w < g && l($476e72a94ce3adba$var$y(u.cY, E, C, w));
                }
            }
            return r;
        });
        return c.minX = 1 / 0, c.maxX = -1 / 0, c.minY = 1 / 0, c.maxY = -1 / 0, c;
    };
}($476e72a94ce3adba$export$acab2bba24699133 || ($476e72a94ce3adba$export$acab2bba24699133 = {}));
var $476e72a94ce3adba$var$O, $476e72a94ce3adba$var$l = function() {
    function t() {}
    return t.prototype.round = function(t) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.ROUND(t));
    }, t.prototype.toAbs = function() {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.TO_ABS());
    }, t.prototype.toRel = function() {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.TO_REL());
    }, t.prototype.normalizeHVZ = function(t, r, e) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.NORMALIZE_HVZ(t, r, e));
    }, t.prototype.normalizeST = function() {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.NORMALIZE_ST());
    }, t.prototype.qtToC = function() {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.QT_TO_C());
    }, t.prototype.aToC = function() {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.A_TO_C());
    }, t.prototype.sanitize = function(t) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.SANITIZE(t));
    }, t.prototype.translate = function(t, r) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.TRANSLATE(t, r));
    }, t.prototype.scale = function(t, r) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.SCALE(t, r));
    }, t.prototype.rotate = function(t, r, e) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.ROTATE(t, r, e));
    }, t.prototype.matrix = function(t, r, e, i, a, n) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.MATRIX(t, r, e, i, a, n));
    }, t.prototype.skewX = function(t) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.SKEW_X(t));
    }, t.prototype.skewY = function(t) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.SKEW_Y(t));
    }, t.prototype.xSymmetry = function(t) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.X_AXIS_SYMMETRY(t));
    }, t.prototype.ySymmetry = function(t) {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.Y_AXIS_SYMMETRY(t));
    }, t.prototype.annotateArcs = function() {
        return this.transform($476e72a94ce3adba$export$acab2bba24699133.ANNOTATE_ARCS());
    }, t;
}(), $476e72a94ce3adba$var$T = function(t) {
    return " " === t || "\t" === t || "\r" === t || "\n" === t;
}, $476e72a94ce3adba$var$v = function(t) {
    return "0".charCodeAt(0) <= t.charCodeAt(0) && t.charCodeAt(0) <= "9".charCodeAt(0);
}, $476e72a94ce3adba$export$93ceea106e074429 = function(t) {
    function e() {
        var r = t.call(this) || this;
        return r.curNumber = "", r.curCommandType = -1, r.curCommandRelative = !1, r.canParseCommandOrComma = !0, r.curNumberHasExp = !1, r.curNumberHasExpDigits = !1, r.curNumberHasDecimal = !1, r.curArgs = [], r;
    }
    return $476e72a94ce3adba$var$r(e, t), e.prototype.finish = function(t) {
        if (void 0 === t && (t = []), this.parse(" ", t), 0 !== this.curArgs.length || !this.canParseCommandOrComma) throw new SyntaxError("Unterminated command at the path end.");
        return t;
    }, e.prototype.parse = function(t, r) {
        var e = this;
        void 0 === r && (r = []);
        for(var i = function(t) {
            r.push(t), e.curArgs.length = 0, e.canParseCommandOrComma = !0;
        }, a = 0; a < t.length; a++){
            var n = t[a], o = !(this.curCommandType !== $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC || 3 !== this.curArgs.length && 4 !== this.curArgs.length || 1 !== this.curNumber.length || "0" !== this.curNumber && "1" !== this.curNumber), s = $476e72a94ce3adba$var$v(n) && ("0" === this.curNumber && "0" === n || o);
            if (!$476e72a94ce3adba$var$v(n) || s) {
                if ("e" !== n && "E" !== n) {
                    if ("-" !== n && "+" !== n || !this.curNumberHasExp || this.curNumberHasExpDigits) {
                        if ("." !== n || this.curNumberHasExp || this.curNumberHasDecimal || o) {
                            if (this.curNumber && -1 !== this.curCommandType) {
                                var u = Number(this.curNumber);
                                if (isNaN(u)) throw new SyntaxError("Invalid number ending at " + a);
                                if (this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC) {
                                    if (0 === this.curArgs.length || 1 === this.curArgs.length) {
                                        if (0 > u) throw new SyntaxError('Expected positive number, got "' + u + '" at index "' + a + '"');
                                    } else if ((3 === this.curArgs.length || 4 === this.curArgs.length) && "0" !== this.curNumber && "1" !== this.curNumber) throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + a + '"');
                                }
                                this.curArgs.push(u), this.curArgs.length === $476e72a94ce3adba$export$bcd392cc0692a90[this.curCommandType] && ($476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO === this.curCommandType ? i({
                                    type: $476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO,
                                    relative: this.curCommandRelative,
                                    x: u
                                }) : $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO === this.curCommandType ? i({
                                    type: $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO,
                                    relative: this.curCommandRelative,
                                    y: u
                                }) : this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO || this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO || this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO ? (i({
                                    type: this.curCommandType,
                                    relative: this.curCommandRelative,
                                    x: this.curArgs[0],
                                    y: this.curArgs[1]
                                }), $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO === this.curCommandType && (this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO)) : this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO ? i({
                                    type: $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO,
                                    relative: this.curCommandRelative,
                                    x1: this.curArgs[0],
                                    y1: this.curArgs[1],
                                    x2: this.curArgs[2],
                                    y2: this.curArgs[3],
                                    x: this.curArgs[4],
                                    y: this.curArgs[5]
                                }) : this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO ? i({
                                    type: $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO,
                                    relative: this.curCommandRelative,
                                    x2: this.curArgs[0],
                                    y2: this.curArgs[1],
                                    x: this.curArgs[2],
                                    y: this.curArgs[3]
                                }) : this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO ? i({
                                    type: $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO,
                                    relative: this.curCommandRelative,
                                    x1: this.curArgs[0],
                                    y1: this.curArgs[1],
                                    x: this.curArgs[2],
                                    y: this.curArgs[3]
                                }) : this.curCommandType === $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC && i({
                                    type: $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC,
                                    relative: this.curCommandRelative,
                                    rX: this.curArgs[0],
                                    rY: this.curArgs[1],
                                    xRot: this.curArgs[2],
                                    lArcFlag: this.curArgs[3],
                                    sweepFlag: this.curArgs[4],
                                    x: this.curArgs[5],
                                    y: this.curArgs[6]
                                })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
                            }
                            if (!$476e72a94ce3adba$var$T(n)) {
                                if ("," === n && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
                                else if ("+" !== n && "-" !== n && "." !== n) {
                                    if (s) this.curNumber = n, this.curNumberHasDecimal = !1;
                                    else {
                                        if (0 !== this.curArgs.length) throw new SyntaxError("Unterminated command at index " + a + ".");
                                        if (!this.canParseCommandOrComma) throw new SyntaxError('Unexpected character "' + n + '" at index ' + a + ". Command cannot follow comma");
                                        if (this.canParseCommandOrComma = !1, "z" !== n && "Z" !== n) {
                                            if ("h" === n || "H" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO, this.curCommandRelative = "h" === n;
                                            else if ("v" === n || "V" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO, this.curCommandRelative = "v" === n;
                                            else if ("m" === n || "M" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO, this.curCommandRelative = "m" === n;
                                            else if ("l" === n || "L" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO, this.curCommandRelative = "l" === n;
                                            else if ("c" === n || "C" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO, this.curCommandRelative = "c" === n;
                                            else if ("s" === n || "S" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO, this.curCommandRelative = "s" === n;
                                            else if ("q" === n || "Q" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO, this.curCommandRelative = "q" === n;
                                            else if ("t" === n || "T" === n) this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO, this.curCommandRelative = "t" === n;
                                            else {
                                                if ("a" !== n && "A" !== n) throw new SyntaxError('Unexpected character "' + n + '" at index ' + a + ".");
                                                this.curCommandType = $476e72a94ce3adba$export$7b924f12d9cdca0a.ARC, this.curCommandRelative = "a" === n;
                                            }
                                        } else r.push({
                                            type: $476e72a94ce3adba$export$7b924f12d9cdca0a.CLOSE_PATH
                                        }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
                                    }
                                } else this.curNumber = n, this.curNumberHasDecimal = "." === n;
                            }
                        } else this.curNumber += n, this.curNumberHasDecimal = !0;
                    } else this.curNumber += n;
                } else this.curNumber += n, this.curNumberHasExp = !0;
            } else this.curNumber += n, this.curNumberHasExpDigits = this.curNumberHasExp;
        }
        return r;
    }, e.prototype.transform = function(t) {
        return Object.create(this, {
            parse: {
                value: function(r, e) {
                    void 0 === e && (e = []);
                    for(var i = 0, a = Object.getPrototypeOf(this).parse.call(this, r); i < a.length; i++){
                        var n = a[i], o = t(n);
                        Array.isArray(o) ? e.push.apply(e, o) : e.push(o);
                    }
                    return e;
                }
            }
        });
    }, e;
}($476e72a94ce3adba$var$l), $476e72a94ce3adba$export$7b924f12d9cdca0a = function(t) {
    function i(r) {
        var e = t.call(this) || this;
        return e.commands = "string" == typeof r ? i.parse(r) : r, e;
    }
    return $476e72a94ce3adba$var$r(i, t), i.prototype.encode = function() {
        return i.encode(this.commands);
    }, i.prototype.getBounds = function() {
        var t = $476e72a94ce3adba$export$acab2bba24699133.CALCULATE_BOUNDS();
        return this.transform(t), t;
    }, i.prototype.transform = function(t) {
        for(var r = [], e = 0, i = this.commands; e < i.length; e++){
            var a = t(i[e]);
            Array.isArray(a) ? r.push.apply(r, a) : r.push(a);
        }
        return this.commands = r, this;
    }, i.encode = function(t) {
        return $476e72a94ce3adba$export$bf3575705b57a51a(t);
    }, i.parse = function(t) {
        var r = new $476e72a94ce3adba$export$93ceea106e074429, e = [];
        return r.parse(t, e), r.finish(e), e;
    }, i.CLOSE_PATH = 1, i.MOVE_TO = 2, i.HORIZ_LINE_TO = 4, i.VERT_LINE_TO = 8, i.LINE_TO = 16, i.CURVE_TO = 32, i.SMOOTH_CURVE_TO = 64, i.QUAD_TO = 128, i.SMOOTH_QUAD_TO = 256, i.ARC = 512, i.LINE_COMMANDS = i.LINE_TO | i.HORIZ_LINE_TO | i.VERT_LINE_TO, i.DRAWING_COMMANDS = i.HORIZ_LINE_TO | i.VERT_LINE_TO | i.LINE_TO | i.CURVE_TO | i.SMOOTH_CURVE_TO | i.QUAD_TO | i.SMOOTH_QUAD_TO | i.ARC, i;
}($476e72a94ce3adba$var$l), $476e72a94ce3adba$export$bcd392cc0692a90 = (($476e72a94ce3adba$var$O = {})[$476e72a94ce3adba$export$7b924f12d9cdca0a.MOVE_TO] = 2, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.LINE_TO] = 2, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.HORIZ_LINE_TO] = 1, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.VERT_LINE_TO] = 1, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.CLOSE_PATH] = 0, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.QUAD_TO] = 4, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_QUAD_TO] = 2, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.CURVE_TO] = 6, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.SMOOTH_CURVE_TO] = 4, $476e72a94ce3adba$var$O[$476e72a94ce3adba$export$7b924f12d9cdca0a.ARC] = 7, $476e72a94ce3adba$var$O);

});

parcelRegister("eJkjO", function(module, exports) {
'use strict';

var $b8MME = parcelRequire("b8MME");
var $ab95077b953d108d$require$PROPER_FUNCTION_NAME = $b8MME.PROPER;

var $5zwnU = parcelRequire("5zwnU");

var $hc2VB = parcelRequire("hc2VB");

var $jqSLA = parcelRequire("jqSLA");

var $8lFU3 = parcelRequire("8lFU3");

var $5mspY = parcelRequire("5mspY");
var $ab95077b953d108d$var$TO_STRING = 'toString';
var $ab95077b953d108d$var$RegExpPrototype = RegExp.prototype;
var $ab95077b953d108d$var$nativeToString = $ab95077b953d108d$var$RegExpPrototype[$ab95077b953d108d$var$TO_STRING];
var $ab95077b953d108d$var$NOT_GENERIC = $8lFU3(function() {
    return $ab95077b953d108d$var$nativeToString.call({
        source: 'a',
        flags: 'b'
    }) !== '/a/b';
});
// FF44- RegExp#toString has a wrong name
var $ab95077b953d108d$var$INCORRECT_NAME = $ab95077b953d108d$require$PROPER_FUNCTION_NAME && $ab95077b953d108d$var$nativeToString.name !== $ab95077b953d108d$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($ab95077b953d108d$var$NOT_GENERIC || $ab95077b953d108d$var$INCORRECT_NAME) $5zwnU($ab95077b953d108d$var$RegExpPrototype, $ab95077b953d108d$var$TO_STRING, function toString() {
    var R = $hc2VB(this);
    var pattern = $jqSLA(R.source);
    var flags = $jqSLA($5mspY(R));
    return '/' + pattern + '/' + flags;
}, {
    unsafe: true
});

});

parcelRegister("dKQCx", function(module, exports) {

$parcel$export(module.exports, "canvasRGBA", () => $a03863992cdf6103$export$2dd10362761f44f5);
function $a03863992cdf6103$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a03863992cdf6103$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $a03863992cdf6103$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a03863992cdf6103$var$_typeof(obj);
}
function $a03863992cdf6103$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/* eslint-disable no-bitwise -- used for calculations */ /* eslint-disable unicorn/prefer-query-selector -- aiming at
  backward-compatibility */ /**
* StackBlur - a fast almost Gaussian Blur For Canvas
*
* In case you find this class useful - especially in commercial projects -
* I am not totally unhappy for a small donation to my PayPal account
* mario@quasimondo.de
*
* Or support me on flattr:
* {@link https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript}.
*
* @module StackBlur
* @author Mario Klingemann
* Contact: mario@quasimondo.com
* Website: {@link http://www.quasimondo.com/StackBlurForCanvas/StackBlurDemo.html}
* Twitter: @quasimondo
*
* @copyright (c) 2010 Mario Klingemann
*
* Permission is hereby granted, free of charge, to any person
* obtaining a copy of this software and associated documentation
* files (the "Software"), to deal in the Software without
* restriction, including without limitation the rights to use,
* copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the
* Software is furnished to do so, subject to the following
* conditions:
*
* The above copyright notice and this permission notice shall be
* included in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
* OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
* HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
* FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
* OTHER DEALINGS IN THE SOFTWARE.
*/ var $a03863992cdf6103$var$mulTable = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var $a03863992cdf6103$var$shgTable = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
/**
 * @param {string|HTMLImageElement} img
 * @param {string|HTMLCanvasElement} canvas
 * @param {Float} radius
 * @param {boolean} blurAlphaChannel
 * @param {boolean} useOffset
 * @param {boolean} skipStyles
 * @returns {undefined}
 */ function $a03863992cdf6103$export$5c452ff88e35e47d(img, canvas, radius, blurAlphaChannel, useOffset, skipStyles) {
    if (typeof img === 'string') img = document.getElementById(img);
    if (!img || Object.prototype.toString.call(img).slice(8, -1) === 'HTMLImageElement' && !('naturalWidth' in img)) return;
    var dimensionType = useOffset ? 'offset' : 'natural';
    var w = img[dimensionType + 'Width'];
    var h = img[dimensionType + 'Height']; // add ImageBitmap support,can blur texture source
    if (Object.prototype.toString.call(img).slice(8, -1) === 'ImageBitmap') {
        w = img.width;
        h = img.height;
    }
    if (typeof canvas === 'string') canvas = document.getElementById(canvas);
    if (!canvas || !('getContext' in canvas)) return;
    if (!skipStyles) {
        canvas.style.width = w + 'px';
        canvas.style.height = h + 'px';
    }
    canvas.width = w;
    canvas.height = h;
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, w, h);
    context.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, w, h);
    if (isNaN(radius) || radius < 1) return;
    if (blurAlphaChannel) $a03863992cdf6103$export$2dd10362761f44f5(canvas, 0, 0, w, h, radius);
    else $a03863992cdf6103$export$b5ffa7e20566d485(canvas, 0, 0, w, h, radius);
}
/**
 * @param {string|HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @throws {Error|TypeError}
 * @returns {ImageData} See {@link https://html.spec.whatwg.org/multipage/canvas.html#imagedata}
 */ function $a03863992cdf6103$var$getImageDataFromCanvas(canvas, topX, topY, width, height) {
    if (typeof canvas === 'string') canvas = document.getElementById(canvas);
    if (!canvas || $a03863992cdf6103$var$_typeof(canvas) !== 'object' || !('getContext' in canvas)) throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
    var context = canvas.getContext('2d');
    try {
        return context.getImageData(topX, topY, width, height);
    } catch (e) {
        throw new Error('unable to access image data: ' + e);
    }
}
/**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */ function $a03863992cdf6103$export$2dd10362761f44f5(canvas, topX, topY, width, height, radius) {
    if (isNaN(radius) || radius < 1) return;
    radius |= 0;
    var imageData = $a03863992cdf6103$var$getImageDataFromCanvas(canvas, topX, topY, width, height);
    imageData = $a03863992cdf6103$export$95ea1a5e72bf4fa5(imageData, topX, topY, width, height, radius);
    canvas.getContext('2d').putImageData(imageData, topX, topY);
}
/**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */ function $a03863992cdf6103$export$95ea1a5e72bf4fa5(imageData, topX, topY, width, height, radius) {
    var pixels = imageData.data;
    var div = 2 * radius + 1; // const w4 = width << 2;
    var widthMinus1 = width - 1;
    var heightMinus1 = height - 1;
    var radiusPlus1 = radius + 1;
    var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
    var stackStart = new $a03863992cdf6103$export$c7ee5523f3ead121();
    var stack = stackStart;
    var stackEnd;
    for(var i = 1; i < div; i++){
        stack = stack.next = new $a03863992cdf6103$export$c7ee5523f3ead121();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    var stackIn = null, stackOut = null, yw = 0, yi = 0;
    var mulSum = $a03863992cdf6103$var$mulTable[radius];
    var shgSum = $a03863992cdf6103$var$shgTable[radius];
    for(var y = 0; y < height; y++){
        stack = stackStart;
        var pr = pixels[yi], pg = pixels[yi + 1], pb = pixels[yi + 2], pa = pixels[yi + 3];
        for(var _i = 0; _i < radiusPlus1; _i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        var rInSum = 0, gInSum = 0, bInSum = 0, aInSum = 0, rOutSum = radiusPlus1 * pr, gOutSum = radiusPlus1 * pg, bOutSum = radiusPlus1 * pb, aOutSum = radiusPlus1 * pa, rSum = sumFactor * pr, gSum = sumFactor * pg, bSum = sumFactor * pb, aSum = sumFactor * pa;
        for(var _i2 = 1; _i2 < radiusPlus1; _i2++){
            var p = yi + ((widthMinus1 < _i2 ? widthMinus1 : _i2) << 2);
            var r = pixels[p], g = pixels[p + 1], b = pixels[p + 2], a = pixels[p + 3];
            var rbs = radiusPlus1 - _i2;
            rSum += (stack.r = r) * rbs;
            gSum += (stack.g = g) * rbs;
            bSum += (stack.b = b) * rbs;
            aSum += (stack.a = a) * rbs;
            rInSum += r;
            gInSum += g;
            bInSum += b;
            aInSum += a;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(var x = 0; x < width; x++){
            var paInitial = aSum * mulSum >>> shgSum;
            pixels[yi + 3] = paInitial;
            if (paInitial !== 0) {
                var _a2 = 255 / paInitial;
                pixels[yi] = (rSum * mulSum >>> shgSum) * _a2;
                pixels[yi + 1] = (gSum * mulSum >>> shgSum) * _a2;
                pixels[yi + 2] = (bSum * mulSum >>> shgSum) * _a2;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            rSum -= rOutSum;
            gSum -= gOutSum;
            bSum -= bOutSum;
            aSum -= aOutSum;
            rOutSum -= stackIn.r;
            gOutSum -= stackIn.g;
            bOutSum -= stackIn.b;
            aOutSum -= stackIn.a;
            var _p = x + radius + 1;
            _p = yw + (_p < widthMinus1 ? _p : widthMinus1) << 2;
            rInSum += stackIn.r = pixels[_p];
            gInSum += stackIn.g = pixels[_p + 1];
            bInSum += stackIn.b = pixels[_p + 2];
            aInSum += stackIn.a = pixels[_p + 3];
            rSum += rInSum;
            gSum += gInSum;
            bSum += bInSum;
            aSum += aInSum;
            stackIn = stackIn.next;
            var _stackOut = stackOut, _r = _stackOut.r, _g = _stackOut.g, _b = _stackOut.b, _a = _stackOut.a;
            rOutSum += _r;
            gOutSum += _g;
            bOutSum += _b;
            aOutSum += _a;
            rInSum -= _r;
            gInSum -= _g;
            bInSum -= _b;
            aInSum -= _a;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(var _x = 0; _x < width; _x++){
        yi = _x << 2;
        var _pr = pixels[yi], _pg = pixels[yi + 1], _pb = pixels[yi + 2], _pa = pixels[yi + 3], _rOutSum = radiusPlus1 * _pr, _gOutSum = radiusPlus1 * _pg, _bOutSum = radiusPlus1 * _pb, _aOutSum = radiusPlus1 * _pa, _rSum = sumFactor * _pr, _gSum = sumFactor * _pg, _bSum = sumFactor * _pb, _aSum = sumFactor * _pa;
        stack = stackStart;
        for(var _i3 = 0; _i3 < radiusPlus1; _i3++){
            stack.r = _pr;
            stack.g = _pg;
            stack.b = _pb;
            stack.a = _pa;
            stack = stack.next;
        }
        var yp = width;
        var _gInSum = 0, _bInSum = 0, _aInSum = 0, _rInSum = 0;
        for(var _i4 = 1; _i4 <= radius; _i4++){
            yi = yp + _x << 2;
            var _rbs = radiusPlus1 - _i4;
            _rSum += (stack.r = _pr = pixels[yi]) * _rbs;
            _gSum += (stack.g = _pg = pixels[yi + 1]) * _rbs;
            _bSum += (stack.b = _pb = pixels[yi + 2]) * _rbs;
            _aSum += (stack.a = _pa = pixels[yi + 3]) * _rbs;
            _rInSum += _pr;
            _gInSum += _pg;
            _bInSum += _pb;
            _aInSum += _pa;
            stack = stack.next;
            if (_i4 < heightMinus1) yp += width;
        }
        yi = _x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(var _y = 0; _y < height; _y++){
            var _p2 = yi << 2;
            pixels[_p2 + 3] = _pa = _aSum * mulSum >>> shgSum;
            if (_pa > 0) {
                _pa = 255 / _pa;
                pixels[_p2] = (_rSum * mulSum >>> shgSum) * _pa;
                pixels[_p2 + 1] = (_gSum * mulSum >>> shgSum) * _pa;
                pixels[_p2 + 2] = (_bSum * mulSum >>> shgSum) * _pa;
            } else pixels[_p2] = pixels[_p2 + 1] = pixels[_p2 + 2] = 0;
            _rSum -= _rOutSum;
            _gSum -= _gOutSum;
            _bSum -= _bOutSum;
            _aSum -= _aOutSum;
            _rOutSum -= stackIn.r;
            _gOutSum -= stackIn.g;
            _bOutSum -= stackIn.b;
            _aOutSum -= stackIn.a;
            _p2 = _x + ((_p2 = _y + radiusPlus1) < heightMinus1 ? _p2 : heightMinus1) * width << 2;
            _rSum += _rInSum += stackIn.r = pixels[_p2];
            _gSum += _gInSum += stackIn.g = pixels[_p2 + 1];
            _bSum += _bInSum += stackIn.b = pixels[_p2 + 2];
            _aSum += _aInSum += stackIn.a = pixels[_p2 + 3];
            stackIn = stackIn.next;
            _rOutSum += _pr = stackOut.r;
            _gOutSum += _pg = stackOut.g;
            _bOutSum += _pb = stackOut.b;
            _aOutSum += _pa = stackOut.a;
            _rInSum -= _pr;
            _gInSum -= _pg;
            _bInSum -= _pb;
            _aInSum -= _pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
    return imageData;
}
/**
 * @param {HTMLCanvasElement} canvas
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {undefined}
 */ function $a03863992cdf6103$export$b5ffa7e20566d485(canvas, topX, topY, width, height, radius) {
    if (isNaN(radius) || radius < 1) return;
    radius |= 0;
    var imageData = $a03863992cdf6103$var$getImageDataFromCanvas(canvas, topX, topY, width, height);
    imageData = $a03863992cdf6103$export$78187a1b7e472a09(imageData, topX, topY, width, height, radius);
    canvas.getContext('2d').putImageData(imageData, topX, topY);
}
/**
 * @param {ImageData} imageData
 * @param {Integer} topX
 * @param {Integer} topY
 * @param {Integer} width
 * @param {Integer} height
 * @param {Float} radius
 * @returns {ImageData}
 */ function $a03863992cdf6103$export$78187a1b7e472a09(imageData, topX, topY, width, height, radius) {
    var pixels = imageData.data;
    var div = 2 * radius + 1; // const w4 = width << 2;
    var widthMinus1 = width - 1;
    var heightMinus1 = height - 1;
    var radiusPlus1 = radius + 1;
    var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;
    var stackStart = new $a03863992cdf6103$export$c7ee5523f3ead121();
    var stack = stackStart;
    var stackEnd;
    for(var i = 1; i < div; i++){
        stack = stack.next = new $a03863992cdf6103$export$c7ee5523f3ead121();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    var stackIn = null;
    var stackOut = null;
    var mulSum = $a03863992cdf6103$var$mulTable[radius];
    var shgSum = $a03863992cdf6103$var$shgTable[radius];
    var p, rbs;
    var yw = 0, yi = 0;
    for(var y = 0; y < height; y++){
        var pr = pixels[yi], pg = pixels[yi + 1], pb = pixels[yi + 2], rOutSum = radiusPlus1 * pr, gOutSum = radiusPlus1 * pg, bOutSum = radiusPlus1 * pb, rSum = sumFactor * pr, gSum = sumFactor * pg, bSum = sumFactor * pb;
        stack = stackStart;
        for(var _i5 = 0; _i5 < radiusPlus1; _i5++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack = stack.next;
        }
        var rInSum = 0, gInSum = 0, bInSum = 0;
        for(var _i6 = 1; _i6 < radiusPlus1; _i6++){
            p = yi + ((widthMinus1 < _i6 ? widthMinus1 : _i6) << 2);
            rSum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - _i6);
            gSum += (stack.g = pg = pixels[p + 1]) * rbs;
            bSum += (stack.b = pb = pixels[p + 2]) * rbs;
            rInSum += pr;
            gInSum += pg;
            bInSum += pb;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(var x = 0; x < width; x++){
            pixels[yi] = rSum * mulSum >>> shgSum;
            pixels[yi + 1] = gSum * mulSum >>> shgSum;
            pixels[yi + 2] = bSum * mulSum >>> shgSum;
            rSum -= rOutSum;
            gSum -= gOutSum;
            bSum -= bOutSum;
            rOutSum -= stackIn.r;
            gOutSum -= stackIn.g;
            bOutSum -= stackIn.b;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            rInSum += stackIn.r = pixels[p];
            gInSum += stackIn.g = pixels[p + 1];
            bInSum += stackIn.b = pixels[p + 2];
            rSum += rInSum;
            gSum += gInSum;
            bSum += bInSum;
            stackIn = stackIn.next;
            rOutSum += pr = stackOut.r;
            gOutSum += pg = stackOut.g;
            bOutSum += pb = stackOut.b;
            rInSum -= pr;
            gInSum -= pg;
            bInSum -= pb;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(var _x2 = 0; _x2 < width; _x2++){
        yi = _x2 << 2;
        var _pr2 = pixels[yi], _pg2 = pixels[yi + 1], _pb2 = pixels[yi + 2], _rOutSum2 = radiusPlus1 * _pr2, _gOutSum2 = radiusPlus1 * _pg2, _bOutSum2 = radiusPlus1 * _pb2, _rSum2 = sumFactor * _pr2, _gSum2 = sumFactor * _pg2, _bSum2 = sumFactor * _pb2;
        stack = stackStart;
        for(var _i7 = 0; _i7 < radiusPlus1; _i7++){
            stack.r = _pr2;
            stack.g = _pg2;
            stack.b = _pb2;
            stack = stack.next;
        }
        var _rInSum2 = 0, _gInSum2 = 0, _bInSum2 = 0;
        for(var _i8 = 1, yp = width; _i8 <= radius; _i8++){
            yi = yp + _x2 << 2;
            _rSum2 += (stack.r = _pr2 = pixels[yi]) * (rbs = radiusPlus1 - _i8);
            _gSum2 += (stack.g = _pg2 = pixels[yi + 1]) * rbs;
            _bSum2 += (stack.b = _pb2 = pixels[yi + 2]) * rbs;
            _rInSum2 += _pr2;
            _gInSum2 += _pg2;
            _bInSum2 += _pb2;
            stack = stack.next;
            if (_i8 < heightMinus1) yp += width;
        }
        yi = _x2;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(var _y2 = 0; _y2 < height; _y2++){
            p = yi << 2;
            pixels[p] = _rSum2 * mulSum >>> shgSum;
            pixels[p + 1] = _gSum2 * mulSum >>> shgSum;
            pixels[p + 2] = _bSum2 * mulSum >>> shgSum;
            _rSum2 -= _rOutSum2;
            _gSum2 -= _gOutSum2;
            _bSum2 -= _bOutSum2;
            _rOutSum2 -= stackIn.r;
            _gOutSum2 -= stackIn.g;
            _bOutSum2 -= stackIn.b;
            p = _x2 + ((p = _y2 + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            _rSum2 += _rInSum2 += stackIn.r = pixels[p];
            _gSum2 += _gInSum2 += stackIn.g = pixels[p + 1];
            _bSum2 += _bInSum2 += stackIn.b = pixels[p + 2];
            stackIn = stackIn.next;
            _rOutSum2 += _pr2 = stackOut.r;
            _gOutSum2 += _pg2 = stackOut.g;
            _bOutSum2 += _pb2 = stackOut.b;
            _rInSum2 -= _pr2;
            _gInSum2 -= _pg2;
            _bInSum2 -= _pb2;
            stackOut = stackOut.next;
            yi += width;
        }
    }
    return imageData;
}
/**
 *
 */ var $a03863992cdf6103$export$c7ee5523f3ead121 = /**
 * Set properties.
 */ function BlurStack() {
    $a03863992cdf6103$var$_classCallCheck(this, BlurStack);
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
};

});



//# sourceMappingURL=index.es.ea36f43a.js.map
